import React from 'react';

// import {
//   MapMarkerStyle,
// } from '~/common/styles/styled.layout';

import {
  AiFillTag,
} from 'react-icons/ai';

import {
  BiDollar,
  BiExit,
} from 'react-icons/bi';

import {
  BsCalendarRangeFill,
  BsCheckAll,
  BsCreditCardFill,
  BsFileMusicFill,
  BsFillBuildingsFill,
  BsFillChatFill,
  BsFillFileLock2Fill,
  BsFillTaxiFrontFill,
  BsFire,
} from 'react-icons/bs';

import {
  FaMinus,
  FaQrcode,
  FaPlus,
  FaTrash,
  FaCocktail,
  FaFacebook,
  FaExclamation,
  FaInstagram,
  FaShoppingBag,
  FaYoutube,
  FaCoffee,
  FaHamburger,
  FaCopy,
  FaMicrophoneAlt,
  FaRoute,
  FaMinusCircle,
  FaAddressCard,
  FaBook,
  FaCouch,
  FaStoreAlt,
  FaParking,
  FaSmoking,
  FaAccessibleIcon,
  FaWhatsapp,
  FaFacebookMessenger,
  FaImages,
  FaDirections,
  FaClinicMedical,
  FaBus,
  FaLifeRing,
  FaLinkedin,
  FaTiktok,
  FaDatabase,
  FaCookieBite,
  FaUserTie,
} from 'react-icons/fa';

import {
  FaChildren,
  FaThreads,
  FaXTwitter,
} from 'react-icons/fa6';

import {
  FiMoreHorizontal,
} from 'react-icons/fi';

import {
  GiBeerBottle,
  GiForkKnifeSpoon,
  GiKidSlide,
  GiPartyFlags,
  GiPartyPopper,
  GiPathDistance,
  GiPoliceOfficerHead,
  GiSteak,
  GiStreetLight,
} from 'react-icons/gi';

import {
  GoVerified,
} from 'react-icons/go';

import {
  HiCheckCircle,
  HiOutlineMenu,
} from 'react-icons/hi';

import {
  ImTicket,
} from 'react-icons/im';

import {
  IoIosBeer,
  IoMdEye,
  IoMdEyeOff,
  IoMdGlobe,
  IoMdInformationCircle,
  IoMdLock,
  IoMdMap,
  IoMdPhonePortrait,
  IoMdPizza,
  IoMdSearch,
} from 'react-icons/io';

import {
  IoFlag,
  IoHomeSharp,
  IoLanguage,
  IoLocationSharp,
  IoPersonCircle,
  IoPlaySkipBack,
} from 'react-icons/io5';

import {
  LiaUserTieSolid,
  LiaUserAltSlashSolid,
} from 'react-icons/lia';

import {
  MdAdd,
  MdArrowDropUp,
  MdArrowDropDown,
  MdArrowForward,
  MdArrowBack,
  MdList,
  MdEvent,
  MdClose,
  MdNotifications,
  MdStar,
  MdStarOutline,
  MdMyLocation,
  MdRestaurantMenu,
  MdPhone,
  MdOutlinePlaylistAddCircle,
  MdCheck,
  MdEmail,
  MdOutlineHelp,
  MdVpnKey,
  MdFace,
  MdSecurity,
  MdAttractions,
  MdDeliveryDining,
  MdShare,
  MdFavorite,
  MdOutlineFavoriteBorder,
  MdRefresh,
  MdMoreHoriz,
  MdWatch,
  MdWatchOff,
  MdThumbUp,
  MdThumbDown,
  MdThumbsUpDown,
  MdOutlineFlashOn,
  MdOutlineFlashOff,
  MdFlipCameraAndroid,
  MdFastfood,
  MdWifiFind,
} from 'react-icons/md';

import {
  RiArrowDownSFill,
  RiArrowUpSFill,
  RiCheckboxBlankLine,
  RiCheckboxFill,
  RiEditBoxFill,
  RiLineChartFill,
  RiListCheck,
  RiReservedFill,
  RiWifiFill,
} from 'react-icons/ri';

import {
  TbAirConditioning,
} from 'react-icons/tb';

import {
  Colors,
  Sizes,
} from '../../shared/constants';



interface IProps {
  expanded?: boolean;
  isPassword?: boolean;

  size?: number;
  color?: string;

  style?: any;
}



export const IconAccessible: React.FC<IProps> = (props: any) => {
  return (

    <FaAccessibleIcon
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconAdd: React.FC<IProps> = (props: any) => {
  return (

    <MdAdd
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconAddress: React.FC<IProps> = (props: any) => {
  return (

    <FaRoute
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconAirConditioning: React.FC<IProps> = (props: any) => {
  return (

    <TbAirConditioning
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconArrowUp: React.FC<IProps> = (props: any) => {
  return (

    <MdArrowDropUp
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconArrowDown: React.FC<IProps> = (props: any) => {
  return (

    <MdArrowDropDown
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconArrowLightRight: React.FC<IProps> = (props: any) => {
  return (

    <MdArrowForward
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconArrowExpand: React.FC<IProps> = (props: any) => {
  return (

    <RiArrowDownSFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconArrowExpanded: React.FC<IProps> = (props: any) => {
  return (

    <RiArrowUpSFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconAvailableDoubleCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4172 0.292821C9.55317 0.351108 8.61717 0.481393 8.10288 0.611679C7.96917 0.645965 7.66059 0.748823 7.41716 0.844821C7.17031 0.937393 6.87888 1.04025 6.76574 1.07454C6.65602 1.10539 6.44002 1.20825 6.28574 1.29739C6.13488 1.38996 5.91545 1.49625 5.79888 1.53739C5.68231 1.57854 5.52802 1.66425 5.45602 1.72254C5.38402 1.78425 5.20231 1.91796 5.05145 2.01739C4.69831 2.25396 4.46516 2.45625 3.75202 3.15225C2.79545 4.08139 2.32916 4.59568 2.01373 5.06882C1.93488 5.19225 1.81145 5.36025 1.73945 5.44596C1.66745 5.53168 1.56116 5.72368 1.5063 5.87454C1.44802 6.02539 1.34516 6.23454 1.28002 6.34425C1.21145 6.45054 1.08459 6.75225 0.992018 7.01282C0.899446 7.27339 0.769161 7.64025 0.700589 7.82882C0.563446 8.21282 0.405732 9.07682 0.333732 9.83454C0.272017 10.4757 0.278875 11.5282 0.347446 12.1145C0.440018 12.886 0.611446 13.8425 0.704018 14.1031C0.752018 14.2334 0.872018 14.5797 0.974875 14.8642C1.08459 15.1831 1.20802 15.4574 1.28345 15.5671C1.35202 15.6665 1.4583 15.862 1.52345 15.9991C1.58516 16.1362 1.70516 16.3282 1.78745 16.4277C1.87316 16.5271 1.96573 16.6574 1.99659 16.7191C2.02745 16.7808 2.11659 16.894 2.19202 16.9694C2.26745 17.0448 2.38059 17.1854 2.4423 17.2848C2.50745 17.3842 2.60688 17.5077 2.66859 17.566C2.7303 17.6208 2.8503 17.7614 2.93602 17.8745C3.02173 17.9877 3.17945 18.1728 3.28231 18.286C3.38516 18.3991 3.52231 18.5637 3.58745 18.6528C3.73488 18.862 4.24231 19.2974 4.73602 19.6334C5.21259 19.966 6.09716 20.4322 6.44002 20.5317C6.58059 20.5728 6.85145 20.6825 7.04002 20.7751C7.28002 20.8917 7.50288 20.9705 7.77716 21.0322C7.99317 21.0802 8.28117 21.1591 8.41145 21.2071C9.05259 21.4368 9.3166 21.478 10.5063 21.5122C11.2469 21.5328 12.1795 21.4951 12.6457 21.4197C12.7692 21.4025 13.0297 21.3305 13.2252 21.2654C13.4206 21.1968 13.8217 21.0905 14.1166 21.0254C14.5383 20.9328 14.7132 20.878 14.9429 20.758C15.104 20.6757 15.32 20.5831 15.4229 20.5488C15.6457 20.4768 15.9166 20.3465 16.0572 20.2402C16.1155 20.1957 16.3006 20.0894 16.4755 20.0037C16.6503 19.918 16.8423 19.8014 16.904 19.7465C16.9657 19.6917 17.1166 19.5888 17.24 19.5168C17.36 19.4482 17.5212 19.3317 17.6 19.2631C17.6755 19.1945 17.8366 19.0608 17.96 18.9648C18.2035 18.7728 18.824 18.1488 19.04 17.8745C19.1155 17.7785 19.2252 17.6482 19.2835 17.5797C19.3417 17.5111 19.448 17.3568 19.52 17.2368C19.5886 17.1168 19.6915 16.966 19.7463 16.9042C19.8012 16.8425 19.9109 16.6677 19.9863 16.5134C20.0617 16.3625 20.192 16.1362 20.2777 16.0094C20.36 15.886 20.4732 15.6528 20.528 15.4917C20.5829 15.3305 20.6892 15.07 20.768 14.9088C20.8435 14.7477 20.9326 14.518 20.96 14.3945C21.0903 13.822 21.2172 13.3625 21.296 13.1431C21.4195 12.8105 21.4503 12.574 21.4983 11.6791C21.5292 11.0654 21.5292 10.7294 21.4949 10.102C21.4469 9.21054 21.3955 8.88139 21.248 8.50768C21.1932 8.36711 21.1006 8.05511 21.0423 7.81854C20.9703 7.52368 20.8812 7.26996 20.7715 7.04025C20.6789 6.85168 20.5795 6.59796 20.5486 6.47454C20.5177 6.35111 20.4492 6.16596 20.3977 6.06311C20.1817 5.62425 19.8972 5.10996 19.7806 4.94882C19.712 4.85282 19.5989 4.69168 19.5303 4.58539C19.2937 4.23568 18.92 3.82082 18.6115 3.56025C18.4435 3.41968 18.1863 3.20368 18.0389 3.08025C17.8915 2.95682 17.6857 2.77854 17.5829 2.68254C17.48 2.58654 17.3429 2.48025 17.2846 2.44939C17.2229 2.41854 17.1063 2.32597 17.0275 2.24368C16.9452 2.16139 16.7703 2.02425 16.6366 1.93854C16.4995 1.85282 16.3795 1.76711 16.3657 1.74654C16.3555 1.72597 16.232 1.65054 16.0983 1.58539C15.9612 1.51682 15.7452 1.38996 15.6115 1.30082C15.4366 1.18768 15.2275 1.09511 14.84 0.964822C14.5486 0.868822 14.1989 0.748823 14.0686 0.700822C13.4035 0.460823 11.336 0.22768 10.4172 0.292821ZM8.23317 5.56939C8.30517 5.57625 8.49031 5.64825 8.64117 5.72368C8.82974 5.81968 9.05602 5.89511 9.34059 5.95682L9.76231 6.05282L10.1189 6.41282C10.424 6.72139 10.4823 6.79682 10.5166 6.94082C10.5955 7.25625 10.6469 7.32139 10.9555 7.50654L11.2435 7.68139L12.2446 7.68825C13.2217 7.69511 13.2492 7.69511 13.4 7.77396C13.7017 7.93168 13.8492 8.05511 13.9829 8.27454C14.1509 8.53854 14.2572 8.59339 14.4423 8.51796C14.6343 8.43911 14.7372 8.34654 14.912 8.09282C15.1486 7.74654 15.1966 7.72254 15.7315 7.69511C15.9783 7.68139 16.4206 7.68139 16.712 7.69511C17.2126 7.71911 17.2537 7.72597 17.3463 7.80482C17.5075 7.93854 17.5623 8.07568 17.5589 8.32939C17.5555 8.62082 17.4629 8.82996 17.2435 9.06311C17.1509 9.15911 17.0515 9.29282 17.0172 9.35796C16.8389 9.70425 16.3726 10.3728 16.2423 10.4688C16.0709 10.5957 16.0057 10.7122 16.0057 10.894C16.0057 11.1168 16.0949 11.2917 16.3006 11.4665C16.4035 11.5522 16.5475 11.7134 16.6229 11.8197C16.9623 12.3031 17.0892 12.4711 17.2537 12.646C17.3772 12.7762 17.456 12.9031 17.5143 13.054C17.5726 13.2117 17.6446 13.3214 17.7749 13.4517C17.9737 13.6471 18.0183 13.774 17.9806 14.0414C17.9497 14.2608 17.8606 14.4048 17.72 14.4528C17.576 14.5008 15.7795 14.5145 15.656 14.4665C15.6115 14.4494 15.4435 14.3054 15.2789 14.1477C15.0389 13.918 14.96 13.8151 14.8743 13.6231C14.7577 13.366 14.4286 12.9374 14.3189 12.9031C14.2195 12.8688 14.1303 12.9717 14.0857 13.1671C14.0446 13.3694 13.9212 13.6231 13.7635 13.8425C13.7017 13.9282 13.6092 14.0894 13.5612 14.1957C13.4137 14.5282 13.8389 14.5008 9.10745 14.4905L4.94859 14.4802L4.80802 14.4048C4.72916 14.3637 4.65373 14.302 4.64002 14.2677C4.59545 14.158 4.62288 12.7488 4.67088 12.6288C4.73259 12.4848 5.01716 12.238 5.34974 12.0425C5.62745 11.878 5.84002 11.71 6.40574 11.1888C6.57031 11.038 6.75202 10.8734 6.80345 10.8254C6.85831 10.7774 7.02631 10.5922 7.17717 10.4208C7.32802 10.246 7.52345 10.0231 7.61259 9.92368C7.80117 9.71796 7.85945 9.58768 7.93145 9.24825C8.01031 8.87111 8.00002 8.64825 7.89717 8.54882C7.73945 8.38768 7.60231 8.48025 7.53716 8.79568C7.43431 9.28939 7.38974 9.36139 7.18402 9.40254C7.12231 9.41625 6.69031 9.43339 6.21716 9.44711C5.49031 9.46425 5.32574 9.45739 5.13716 9.40939C4.74288 9.30996 4.62288 9.09396 4.62288 8.48368C4.62288 8.17168 4.65031 8.05854 4.85945 7.55796C5.01373 7.18768 5.08574 7.10196 5.84688 6.32368C6.20688 5.95682 6.21031 5.95339 6.56002 5.90882C6.74516 5.88139 6.88231 5.82311 6.95431 5.73739C7.10859 5.54882 7.58859 5.48711 8.23317 5.56939Z" fill={color} />
      <path d="M11.168 8.89512C11.1406 8.92597 11.0823 9.05969 11.0343 9.1934C10.9589 9.40255 10.9246 9.4574 10.7738 9.5774C10.5578 9.7454 10.52 9.8174 10.52 10.054C10.52 10.3385 10.4275 10.4483 10.0949 10.5614C9.76918 10.6711 9.67318 10.7603 9.49147 11.1065C9.41604 11.2505 9.29947 11.4357 9.23432 11.5145C9.0869 11.6894 9.07318 11.8437 9.19661 11.9568C9.26861 12.022 9.33718 12.0391 9.63547 12.0665C9.83089 12.0803 10.16 12.094 10.3726 12.0974C10.7498 12.0974 10.7532 12.0974 10.8389 12.1968C10.8835 12.2517 10.9486 12.4025 10.9829 12.5328C11.0618 12.8243 11.1303 12.9511 11.2297 12.9785C11.3257 12.9991 11.456 12.9203 11.5383 12.79C11.5692 12.7385 11.6755 12.6117 11.7749 12.5054C11.8709 12.4025 11.9909 12.2414 12.0389 12.1454C12.0869 12.0528 12.2172 11.8505 12.3337 11.6928C12.5806 11.35 12.6389 11.158 12.5806 10.8528C12.5326 10.5888 12.032 9.74883 11.7886 9.52598C11.6823 9.42998 11.576 9.28255 11.5006 9.12826C11.36 8.84369 11.2675 8.77855 11.168 8.89512Z" fill={color} />
    </svg>

  );
};



export const IconAvailableComboCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0744 0.306201C9.74181 0.330201 8.98752 0.439916 8.29495 0.563344C8.12695 0.594201 7.81495 0.693629 7.55095 0.799916C7.30067 0.899344 6.98524 1.01592 6.8481 1.05363C6.71095 1.09134 6.48124 1.19077 6.34067 1.27306C6.19667 1.35877 5.97381 1.47192 5.8401 1.52677C5.3121 1.74963 4.48924 2.40106 3.57724 3.31306C2.61724 4.27649 2.20924 4.73249 1.98295 5.09592C1.90752 5.22277 1.78409 5.40106 1.71209 5.4902C1.64009 5.57934 1.54752 5.7542 1.50638 5.8742C1.46524 5.9942 1.35895 6.20677 1.27667 6.35077C1.19095 6.49134 1.09152 6.71763 1.05038 6.85477C1.01267 6.98849 0.933809 7.21134 0.878951 7.34506C0.669808 7.83191 0.577237 8.1542 0.491523 8.6822C0.285808 9.95763 0.23438 10.8902 0.316665 11.7953C0.395523 12.6491 0.59438 13.7976 0.73838 14.1885C0.803523 14.3668 0.916666 14.6993 0.992094 14.9256C1.08124 15.1931 1.18067 15.4159 1.27667 15.5599C1.35895 15.6833 1.48238 15.8993 1.55438 16.0399C1.62638 16.1805 1.73952 16.3656 1.81152 16.4513C1.88352 16.5371 1.96581 16.6536 1.99667 16.7119C2.02409 16.7736 2.12352 16.9039 2.21609 17.0033C2.30867 17.1062 2.42181 17.2502 2.46981 17.3256C2.51781 17.4011 2.61038 17.5176 2.67552 17.5828C2.80238 17.7062 3.18295 18.1485 3.54295 18.5942C3.78638 18.8925 4.30067 19.3485 4.6401 19.5679C4.77038 19.6502 4.93495 19.7633 5.0001 19.8113C5.2401 19.9965 6.18295 20.4559 6.50867 20.5485C6.68695 20.5999 6.92352 20.6959 7.04695 20.7713C7.21495 20.8708 7.38295 20.9291 7.78752 21.0285C8.0721 21.1005 8.41838 21.1999 8.54867 21.2513C8.68238 21.3028 8.89838 21.3713 9.0321 21.4022C9.36124 21.4742 10.743 21.5393 11.463 21.5119C12.423 21.4742 12.711 21.4365 13.2115 21.2685C13.4584 21.1862 13.8801 21.0731 14.1544 21.0148C14.5452 20.9291 14.727 20.8708 14.9944 20.7405C15.183 20.6479 15.399 20.5519 15.4744 20.5313C15.6492 20.4765 15.9235 20.3393 16.0572 20.2399C16.1155 20.1953 16.3007 20.0891 16.4755 20.0033C16.6504 19.9176 16.8424 19.8011 16.9041 19.7462C16.9658 19.6913 17.1132 19.5919 17.2332 19.5199C17.6995 19.2491 18.5772 18.4262 19.2218 17.6548C19.3041 17.5588 19.4344 17.3736 19.5098 17.2468C19.5887 17.1199 19.695 16.9656 19.7498 16.9039C19.8012 16.8422 19.911 16.6673 19.9864 16.5131C20.0618 16.3622 20.1921 16.1359 20.2778 16.0091C20.3601 15.8856 20.4732 15.6525 20.5247 15.4913C20.5795 15.3302 20.6892 15.0765 20.7681 14.9256C20.8778 14.7096 20.9327 14.5348 21.0252 14.1028C21.0904 13.8011 21.1967 13.4068 21.2618 13.2285C21.327 13.0502 21.399 12.7896 21.4195 12.6559C21.4915 12.1931 21.5327 11.1988 21.5087 10.5028C21.4744 9.40563 21.4401 9.12106 21.2892 8.66849C21.2138 8.45249 21.1007 8.0582 21.0321 7.7942C20.9532 7.48563 20.8538 7.20449 20.7544 7.00563C20.6721 6.8342 20.5761 6.59763 20.5487 6.4742C20.487 6.23763 20.4252 6.10049 20.103 5.49706C19.6298 4.60906 19.0915 3.96106 18.2207 3.2342C17.9944 3.04563 17.7167 2.80563 17.6035 2.69934C17.487 2.59306 17.343 2.47992 17.2847 2.44906C17.223 2.4182 17.1064 2.32563 17.0275 2.24334C16.9452 2.16106 16.7704 2.02392 16.6367 1.9382C16.4995 1.85249 16.3795 1.76677 16.3658 1.7462C16.3555 1.72563 16.2321 1.6502 16.0984 1.58163C15.9612 1.51649 15.7452 1.38963 15.6115 1.30392C15.4504 1.20106 15.2001 1.08792 14.8572 0.967915C14.5761 0.871917 14.2367 0.751916 14.103 0.703916C13.7327 0.566773 12.3064 0.347344 11.5281 0.302773C10.8115 0.265059 10.6058 0.265059 10.0744 0.306201ZM9.52924 5.61363C9.59781 5.6342 9.70753 5.68906 9.76924 5.73706C9.83438 5.78163 9.96124 5.86392 10.0572 5.91534C10.2595 6.02849 10.4344 6.19992 10.5612 6.40906C10.6127 6.49134 10.7087 6.62506 10.7772 6.70734C10.9452 6.91649 10.983 7.07077 10.983 7.62277C10.983 8.06849 10.9761 8.11306 10.8972 8.26391C10.743 8.54849 10.4207 8.93591 10.2184 9.07991C10.1121 9.15534 9.9681 9.26163 9.90295 9.31991C9.7281 9.46734 9.45381 9.52563 8.94295 9.52563C8.35667 9.52563 8.17495 9.4742 7.84581 9.22049C7.59552 9.02849 7.29038 8.65477 7.12581 8.34963C7.0161 8.15077 6.97152 7.72563 7.01953 7.32106C7.06067 6.96449 7.1361 6.74163 7.27667 6.57706C7.32124 6.5222 7.41038 6.38849 7.46867 6.2822C7.55095 6.14506 7.63324 6.05592 7.76352 5.97363C7.86638 5.90849 8.00352 5.80906 8.06867 5.75077C8.26067 5.58277 8.41838 5.54849 8.94295 5.5622C9.19667 5.56906 9.46067 5.59306 9.52924 5.61363ZM14.7681 6.70392C14.8607 6.76563 15.0561 6.9782 15.1761 7.13592C15.3338 7.35534 15.2207 7.7222 14.9087 7.98277C14.8092 8.06849 14.6721 8.19191 14.6035 8.26049C14.535 8.32563 14.4047 8.4422 14.3121 8.51763C14.0481 8.72677 12.6424 10.1359 12.4778 10.3553C12.3955 10.4651 12.3167 10.5542 12.2995 10.5542C12.2858 10.5542 12.1898 10.6571 12.087 10.7839C11.8298 11.1062 11.0652 11.8742 10.7875 12.0936C10.6572 12.1931 10.5544 12.2856 10.5544 12.3028C10.5544 12.3165 10.4652 12.3953 10.359 12.4776C10.1224 12.6593 8.67895 14.0925 8.51095 14.3119C8.44238 14.4011 8.33267 14.5279 8.2641 14.5965C8.1921 14.6685 8.06181 14.8125 7.96924 14.9222C7.68467 15.2582 7.36581 15.3439 7.10524 15.1553C6.87895 14.9873 6.64581 14.7165 6.64238 14.6102C6.62867 14.2948 6.65267 14.2468 6.93381 13.9691C7.05038 13.8525 7.44467 13.4411 7.8081 13.0502C8.17153 12.6593 8.75781 12.0731 9.10752 11.7473C9.91667 10.9965 10.887 10.0296 11.7955 9.06277C12.183 8.64791 12.8515 7.9862 13.2767 7.59191C13.7018 7.19763 14.055 6.85477 14.0652 6.82734C14.1304 6.6662 14.5967 6.58049 14.7681 6.70392ZM13.3178 12.3028C13.551 12.3508 13.7567 12.4193 13.9692 12.5256C14.2744 12.6731 14.2881 12.6868 14.5658 13.0468C14.7235 13.2491 14.8812 13.4891 14.9155 13.5782C15.0424 13.9176 15.0252 14.7851 14.8847 15.0559C14.8538 15.1176 14.703 15.3165 14.5521 15.5016C14.3018 15.8068 14.247 15.8513 14.0001 15.9713C13.647 16.1462 13.3932 16.2148 12.9887 16.2353C12.5772 16.2593 12.3372 16.2113 11.9875 16.0296C11.7441 15.9062 11.6892 15.8548 11.4492 15.5599C11.1235 15.1588 11.0824 15.0868 11.031 14.7919C10.9795 14.4868 11.007 13.7393 11.079 13.5473C11.1338 13.4033 11.5658 12.7725 11.6824 12.6662C11.7647 12.5908 12.1315 12.4125 12.4058 12.3165C12.6801 12.2171 12.8824 12.2136 13.3178 12.3028Z" fill={color} />
      <path d="M8.607 7.13251C8.511 7.18051 8.41157 7.36566 8.38071 7.55423C8.34986 7.73594 8.46643 7.96909 8.63443 8.05823C8.87786 8.19194 9.29957 8.0788 9.40586 7.85594C9.50871 7.64337 9.42986 7.31766 9.24129 7.18051C9.12814 7.09823 8.73386 7.06737 8.607 7.13251Z" fill={color} />
      <path d="M12.6012 13.7085C12.4846 13.801 12.3303 14.1199 12.3303 14.2708C12.3303 14.4456 12.5018 14.7988 12.6149 14.8605C12.8583 14.9839 13.2526 14.8639 13.3898 14.617C13.5441 14.3428 13.5166 14.0616 13.3212 13.8525C13.1292 13.6468 12.7726 13.5748 12.6012 13.7085Z" fill={color} />
    </svg>

  );
};



export const IconAvailableListCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0435 0.302894C9.11776 0.374894 8.21947 0.536037 7.82861 0.693751C7.55776 0.806893 7.23547 0.91318 6.76576 1.05375C6.63547 1.09147 6.43661 1.18404 6.3269 1.25947C6.21376 1.33489 6.00804 1.44118 5.86747 1.49261C5.72004 1.54747 5.54861 1.64347 5.46633 1.71204C5.3909 1.78061 5.21947 1.90404 5.08576 1.98975C4.66061 2.26404 4.0949 2.75432 3.44347 3.41261C2.66176 4.20118 2.25718 4.66747 2.00004 5.06861C1.90747 5.20918 1.77718 5.39089 1.70861 5.46975C1.63318 5.55547 1.54061 5.72347 1.48918 5.87089C1.43776 6.01147 1.34861 6.19661 1.29376 6.28232C1.1429 6.52575 1.07433 6.67661 1.00918 6.92004C0.974899 7.04347 0.865185 7.35547 0.762328 7.61604C0.601185 8.01718 0.560042 8.17147 0.474327 8.67889C0.340613 9.50175 0.289185 10.0812 0.289185 10.8972C0.289185 11.672 0.330327 12.1966 0.460613 13.0743C0.566899 13.7806 0.590899 13.8903 0.734899 14.2366C0.796613 14.384 0.889185 14.648 0.937185 14.8195C1.06747 15.272 1.11547 15.3818 1.24576 15.536C1.3109 15.6115 1.42061 15.8069 1.49261 15.9749C1.56461 16.1498 1.68118 16.352 1.76004 16.4446C1.8389 16.5338 1.9589 16.6949 2.02747 16.8012C2.09604 16.9075 2.19204 17.0206 2.23661 17.0549C2.28461 17.0858 2.38061 17.2023 2.44918 17.312C2.51433 17.4218 2.64461 17.5966 2.73376 17.6926C2.8229 17.792 2.95661 17.96 3.02861 18.0629C3.27547 18.4092 4.05376 19.1909 4.3829 19.424C4.50633 19.5132 4.71547 19.664 4.84576 19.7635C4.97947 19.8595 5.17147 19.9829 5.27433 20.0343C5.37719 20.0858 5.5109 20.1612 5.56576 20.2058C5.7269 20.3258 5.93604 20.4218 6.26176 20.528C6.42633 20.5829 6.66976 20.6926 6.80004 20.768C7.06747 20.9258 7.17033 20.96 7.5989 21.0286C7.82861 21.0663 7.97604 21.1178 8.24004 21.248C8.48347 21.3715 8.65147 21.4332 8.8229 21.4572C9.22747 21.5155 11.8229 21.5429 12.5395 21.4915C12.8858 21.4709 13.2149 21.4366 13.2698 21.4195C13.328 21.4058 13.4412 21.3372 13.5235 21.2686C13.712 21.1143 13.7738 21.0938 14.2778 21.0286C14.7543 20.9703 14.8983 20.9258 15.2206 20.7406C15.344 20.6686 15.5326 20.5829 15.632 20.5486C15.872 20.4698 16.0538 20.3806 16.2526 20.2366C16.3418 20.1749 16.52 20.0686 16.6469 20.0035C16.7738 19.9383 16.9418 19.8218 17.0172 19.7429C17.0926 19.664 17.2263 19.5646 17.312 19.52C17.3978 19.4755 17.552 19.3623 17.6549 19.2698C17.7578 19.1806 17.9326 19.0332 18.0458 18.9475C18.2995 18.752 18.8583 18.1829 19.064 17.9086C19.1498 17.7955 19.256 17.672 19.2972 17.6343C19.3383 17.5966 19.4309 17.4663 19.5029 17.3429C19.5749 17.2195 19.6915 17.0652 19.76 17C19.8286 16.9349 19.9349 16.7875 19.9898 16.6743C20.048 16.5612 20.1646 16.3726 20.2469 16.256C20.3292 16.1395 20.4423 15.9166 20.5006 15.7658C20.5555 15.6115 20.6618 15.3749 20.7372 15.2412C20.9292 14.8915 20.9703 14.7475 21.0286 14.2675C21.0903 13.7738 21.1109 13.712 21.2686 13.5269C21.4263 13.3418 21.4469 13.2595 21.4949 12.5086C21.5429 11.7612 21.5155 9.20004 21.4538 8.82289C21.4298 8.66175 21.3578 8.46975 21.248 8.24004C21.1109 7.95889 21.0663 7.82861 21.0149 7.51318C20.96 7.18404 20.9258 7.08461 20.7783 6.81032C20.6858 6.63547 20.5726 6.38175 20.5315 6.25147C20.4355 5.95661 20.3532 5.78518 20.2058 5.58289C20.144 5.49718 20.0549 5.34289 20.0069 5.24004C19.9623 5.13718 19.8629 4.97261 19.7909 4.88004C19.7155 4.78404 19.5715 4.59204 19.472 4.45146C19.16 4.01947 18.4983 3.35775 18.0458 3.02861C17.9703 2.97375 17.8195 2.84689 17.7132 2.75089C17.6069 2.65147 17.4286 2.51775 17.3189 2.45261C17.2092 2.38404 17.0789 2.27432 17.024 2.20918C16.9726 2.14061 16.856 2.04461 16.7669 1.99318C16.6778 1.94175 16.5338 1.83547 16.4446 1.75661C16.3486 1.67089 16.1703 1.57147 16.0092 1.50289C15.8583 1.44461 15.6492 1.32461 15.5395 1.24232C15.4195 1.14975 15.2686 1.07089 15.152 1.03661C14.9052 0.968038 14.3463 0.782895 14.0275 0.666324C13.3178 0.405751 11.2092 0.213752 10.0435 0.302894ZM12.4092 4.10175C12.464 4.16347 12.5086 4.23889 12.5086 4.27318C12.5086 4.35204 12.632 4.46861 12.7486 4.50289C12.8652 4.53718 12.9475 4.61261 13.0435 4.78061C13.088 4.85604 13.1635 4.93832 13.2115 4.95889C13.2732 4.98632 13.6126 5.00004 14.2949 5.00004H15.2926L15.4023 5.11318C15.4606 5.17832 15.536 5.27089 15.5669 5.31889C15.6012 5.36689 15.6938 5.44918 15.7726 5.50404C15.8549 5.55889 15.9406 5.64461 15.9646 5.69604C15.9989 5.76804 16.0092 6.90289 16.0058 11.5212C16.0058 17.0412 16.0023 17.2606 15.944 17.3429C15.9063 17.3909 15.8412 17.4492 15.7966 17.4698C15.6766 17.5315 6.28576 17.5315 6.17604 17.4698C6.13147 17.4458 6.05261 17.3532 5.99776 17.2675C5.93947 17.1783 5.83661 17.0686 5.76461 17.024C5.69261 16.976 5.60347 16.9075 5.56576 16.8629C5.49719 16.7875 5.49719 16.7326 5.4869 11.3292C5.48004 7.44461 5.4869 5.83661 5.51433 5.74404C5.54519 5.64461 5.58976 5.58975 5.72004 5.51089C5.82633 5.44575 5.92576 5.34632 5.99433 5.23661C6.04919 5.14404 6.13833 5.05147 6.18633 5.03432C6.23433 5.01375 6.69376 5.00004 7.22861 5.00004C7.76347 5.00004 8.2229 4.98632 8.2709 4.96575C8.3189 4.94861 8.40804 4.85261 8.46976 4.75661C8.55547 4.61604 8.61376 4.56461 8.76119 4.49946C8.8949 4.44118 8.95319 4.38975 8.97719 4.32461C9.0389 4.14975 9.09719 4.05718 9.1829 4.01604C9.24804 3.98175 9.6149 3.97489 10.7875 3.97832L12.3098 3.98861L12.4092 4.10175Z" fill={color} />
      <path d="M9.09381 4.59201C9.03553 4.65716 9.02867 4.72916 9.01838 5.20573L9.0081 5.74744L9.10752 5.86401L9.21038 5.97716L10.6881 5.98744C12.351 5.99773 12.3647 5.99773 12.4607 5.76801C12.5018 5.66858 12.5087 5.55544 12.4881 5.15087C12.4744 4.83887 12.447 4.63316 12.4195 4.59544C12.3818 4.54058 12.2515 4.53716 10.7704 4.52687C9.16581 4.51658 9.16238 4.52001 9.09381 4.59201Z" fill={color} />
      <path d="M6.72809 6.02864C6.68695 6.04235 6.62181 6.10064 6.58066 6.15206L6.50866 6.24464V11.2298C6.50866 16.6503 6.49838 16.3555 6.69723 16.4446C6.76581 16.4755 7.81152 16.4858 11.0309 16.4858H15.2721L15.3509 16.4138C15.3921 16.3761 15.4401 16.3041 15.4607 16.2561C15.4778 16.2046 15.4915 14.2366 15.4915 11.2538C15.4915 6.03892 15.4949 6.19321 15.3372 6.06292C15.2858 6.02178 15.1075 6.00806 14.3292 6.00121C13.7258 5.99435 13.3384 6.00121 13.2595 6.02521C13.1669 6.05264 13.1052 6.10749 13.0092 6.25149C12.9407 6.35778 12.8447 6.45721 12.7967 6.47435C12.6629 6.52578 8.79895 6.51892 8.6858 6.46749C8.6378 6.44692 8.55209 6.35435 8.49723 6.26178C8.33952 6.00806 8.28123 5.99435 7.47895 5.99778C7.10523 5.99778 6.76581 6.01149 6.72809 6.02864ZM14.3087 7.51664C14.4355 7.57149 14.4869 7.68121 14.4492 7.83206C14.4012 8.01035 14.3429 8.01721 12.5018 8.01721C10.9624 8.01721 10.8012 8.01035 10.6915 7.95549C10.5887 7.90749 10.5715 7.87664 10.5612 7.76692C10.5509 7.62635 10.5921 7.54749 10.7087 7.50292C10.7464 7.48578 11.5452 7.47206 12.4847 7.47206C13.8938 7.46864 14.2127 7.47892 14.3087 7.51664ZM9.84123 7.54064C9.9818 7.61606 10.0058 7.76349 10.0058 8.54178C10.0058 9.23092 10.0024 9.28235 9.9338 9.36464C9.89609 9.41606 9.81038 9.46749 9.73838 9.48464C9.66981 9.49835 9.18295 9.51206 8.65838 9.50864H7.70181L7.60238 9.39549L7.50295 9.28578V7.70178L7.70181 7.50292H8.73723C9.41266 7.50292 9.79323 7.51664 9.84123 7.54064ZM14.3738 8.56921C14.4972 8.66521 14.4972 8.84349 14.3738 8.93949C14.2847 9.01149 14.2504 9.01149 12.4949 9.01149C10.7395 9.01149 10.7018 9.01149 10.6298 8.94292C10.5544 8.87092 10.5269 8.69264 10.5818 8.61378C10.6538 8.50406 10.7498 8.50064 12.5121 8.49721C14.2504 8.49721 14.2847 8.49721 14.3738 8.56921ZM9.80009 10.5303C9.97838 10.6195 10.0058 10.7429 10.0058 11.5246C10.0058 12.3098 9.98866 12.3955 9.80695 12.4709C9.73838 12.4984 9.41952 12.5086 8.68923 12.5018L7.66752 12.4915L7.58523 12.3955C7.50295 12.2995 7.50295 12.2961 7.50295 11.5212C7.50638 10.6915 7.51666 10.6229 7.6778 10.5338C7.79438 10.4686 9.67323 10.4652 9.80009 10.5303ZM14.3738 10.5578C14.4972 10.6538 14.4972 10.8321 14.3738 10.9281C14.2847 11.0001 14.2504 11.0001 12.5189 11.0001C10.7601 11.0001 10.6538 10.9932 10.5818 10.8835C10.5269 10.8046 10.5544 10.6263 10.6298 10.5543C10.7018 10.4858 10.7395 10.4858 12.4949 10.4858C14.2504 10.4858 14.2847 10.4858 14.3738 10.5578ZM14.2915 11.5246C14.5144 11.6001 14.5247 11.8881 14.3087 11.9806C14.1475 12.0458 10.8252 12.0526 10.6915 11.9841C10.5064 11.8915 10.5132 11.6138 10.7018 11.5315C10.8492 11.4664 14.1029 11.4595 14.2915 11.5246ZM14.3087 13.5166C14.5144 13.6024 14.5212 13.8595 14.3258 13.9555C14.2161 14.0103 14.0549 14.0172 12.4915 14.0172C10.8424 14.0172 10.7738 14.0138 10.6675 13.9486C10.5681 13.8904 10.5544 13.8629 10.5544 13.7429C10.5544 13.6229 10.5681 13.5955 10.6675 13.5372C10.7738 13.4721 10.8424 13.4686 12.4847 13.4686C13.8904 13.4686 14.2127 13.4789 14.3087 13.5166ZM9.84123 13.5406C9.9818 13.6161 10.0058 13.7635 10.0058 14.5486V15.2858L9.90638 15.3955L9.80695 15.5086H7.70181L7.60238 15.3955L7.50295 15.2858V13.7018L7.70181 13.5029H8.73723C9.41266 13.5029 9.79323 13.5166 9.84123 13.5406ZM14.3738 14.5692C14.4972 14.6652 14.4972 14.8435 14.3738 14.9395C14.2847 15.0115 14.2504 15.0115 12.4984 15.0115H10.7121L10.6332 14.9361C10.5544 14.8641 10.5269 14.6926 10.5818 14.6138C10.6538 14.5041 10.7498 14.5006 12.5121 14.4972C14.2504 14.4972 14.2847 14.4972 14.3738 14.5692Z" fill={color} />
    </svg>

  );
};



export const IconAvailableOpenBarCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2629 0.21689C10.0194 0.244317 9.54628 0.309461 9.21714 0.367746C8.888 0.422603 8.53143 0.47746 8.42857 0.491174C8.12685 0.525461 7.76 0.635175 7.496 0.76889C7.36228 0.837461 7.09143 0.943746 6.89257 1.00889C6.69371 1.07403 6.42971 1.18718 6.30628 1.2626C6.17943 1.3346 5.96686 1.44432 5.83314 1.49918C5.696 1.55403 5.49371 1.67403 5.38743 1.75975C5.28114 1.84889 5.09943 1.96546 4.98971 2.02375C4.87657 2.0786 4.67771 2.2226 4.54057 2.3426C4.136 2.70603 3.76571 3.05232 3.59771 3.2306C3.512 3.31975 3.38857 3.44318 3.32343 3.50489C3.25828 3.56317 3.16571 3.65575 3.11771 3.71403C3.06971 3.76889 2.92228 3.9266 2.78857 4.06032C2.36343 4.49575 2.13371 4.77346 2.00343 5.0066C1.93143 5.13346 1.81485 5.31175 1.73943 5.40089C1.66743 5.49003 1.568 5.65803 1.52343 5.7746C1.47543 5.89117 1.36228 6.10375 1.26971 6.24432C1.15314 6.4226 1.07771 6.5906 1.02628 6.7826C0.981712 6.93689 0.875426 7.2146 0.782855 7.40317C0.604569 7.7666 0.587426 7.83175 0.374855 8.97689C0.186283 9.9746 0.158855 10.2249 0.155426 10.9826C0.155426 11.706 0.189712 12.0317 0.340569 12.7072C0.395426 12.9609 0.470855 13.3586 0.508569 13.5917C0.57714 14.0169 0.666283 14.298 0.827426 14.6203C0.875426 14.7163 0.954283 14.9289 1.00228 15.1003C1.064 15.3095 1.13943 15.4775 1.24571 15.6317C1.33143 15.7552 1.45828 15.978 1.53371 16.1289C1.60571 16.2763 1.70857 16.4375 1.76 16.4855C1.81143 16.5335 1.92114 16.6775 2.00685 16.8043C2.08914 16.9312 2.17828 17.0443 2.20571 17.0546C2.23314 17.0683 2.33257 17.178 2.42171 17.3049C2.51428 17.4283 2.65485 17.5997 2.73371 17.682C2.816 17.7643 2.95657 17.946 3.04914 18.0866C3.14171 18.2237 3.25828 18.3609 3.30628 18.3952C3.35428 18.426 3.44685 18.5255 3.50857 18.618C3.64571 18.8237 4.19771 19.3449 4.44457 19.4992C4.54743 19.5643 4.70171 19.6775 4.78743 19.7495C4.87657 19.8215 5.06171 19.938 5.19885 20.0032C5.336 20.0683 5.52457 20.178 5.61714 20.2432C5.70971 20.3083 5.936 20.4146 6.12114 20.4763C6.30628 20.538 6.60114 20.6615 6.77943 20.754C6.99886 20.8637 7.26628 20.9597 7.60228 21.0455C7.87657 21.1209 8.25714 21.234 8.44571 21.2992C8.98743 21.4912 9.54628 21.5357 11.12 21.5152C12.5703 21.498 12.8583 21.4637 13.4754 21.2512C13.688 21.1792 14.0651 21.0797 14.3086 21.0283C14.6549 20.9597 14.8194 20.9049 15.0526 20.7883C15.2171 20.7026 15.4846 20.5826 15.6457 20.5175C15.8069 20.4523 16.0126 20.346 16.1017 20.2809C16.1909 20.2157 16.3897 20.0992 16.5474 20.0203C16.7051 19.9415 16.9006 19.8146 16.9794 19.7426C17.0583 19.6706 17.192 19.5712 17.2743 19.5232C17.7611 19.2489 19.2937 17.7163 19.5131 17.2877C19.544 17.2295 19.64 17.0957 19.7257 16.9963C19.8149 16.8935 19.9486 16.6877 20.024 16.5369C20.0994 16.386 20.1954 16.2146 20.24 16.1597C20.3429 16.0226 20.4423 15.8203 20.5486 15.5392C20.5966 15.4123 20.696 15.1963 20.7749 15.0592C20.8846 14.8569 20.9291 14.7163 21.0149 14.3049C21.0697 14.0272 21.1554 13.6912 21.2069 13.5575C21.4537 12.8683 21.4914 12.5975 21.5154 11.2569C21.5429 9.7106 21.4743 8.97003 21.2343 8.30832C21.1691 8.1266 21.0663 7.79403 21.0114 7.56432C20.9429 7.29689 20.8571 7.06375 20.7714 6.90603C20.6994 6.77232 20.5897 6.51518 20.5314 6.33689C20.4731 6.1586 20.3634 5.9186 20.2914 5.80546C20.2194 5.69232 20.1029 5.47975 20.0343 5.32889C19.9657 5.18146 19.8457 4.97232 19.7634 4.86603C19.6811 4.75975 19.5474 4.57803 19.4651 4.46146C19.1943 4.08089 18.8171 3.66603 18.6183 3.52889C18.512 3.45689 18.3851 3.35403 18.3371 3.3026C18.2891 3.25117 18.1314 3.11746 17.9806 3.00432C17.8331 2.89118 17.6754 2.75746 17.6274 2.7026C17.5829 2.64775 17.4457 2.54146 17.3257 2.46603C17.2023 2.38717 17.0789 2.28432 17.0446 2.23632C17.0137 2.18489 16.8766 2.07518 16.7429 1.98946C16.6126 1.90717 16.4514 1.7906 16.3863 1.73232C16.3211 1.67746 16.1429 1.5746 15.992 1.5026C15.8377 1.4306 15.6457 1.31746 15.56 1.24889C15.4469 1.15975 15.2994 1.09117 15.0114 1.00203C14.7954 0.93346 14.4971 0.823747 14.3497 0.758603C14.0549 0.628318 13.6811 0.539174 13.0057 0.436317C12.7623 0.398603 12.4983 0.354032 12.4229 0.336889C12.2549 0.299175 11.3943 0.210033 11 0.186033C10.8389 0.175746 10.5097 0.18946 10.2629 0.21689ZM13.304 2.57918C13.4549 2.65117 13.5371 2.81232 13.6229 3.18946C13.7154 3.61117 13.736 4.09803 13.6811 4.65689C13.6194 5.32203 13.6297 5.47289 13.8834 7.17689C14.0617 8.3666 14.0823 8.45232 14.24 8.75403C14.3189 8.90489 14.4389 9.19975 14.5074 9.40546C14.5794 9.6146 14.6823 9.85117 14.7371 9.93689C14.888 10.1597 14.936 10.2832 14.9943 10.6226C15.0217 10.7872 15.1074 11.0855 15.1794 11.2809C15.4297 11.9426 15.4229 11.8466 15.4229 15.2717C15.4229 17.4077 15.4126 18.3883 15.3851 18.5152C15.3303 18.762 15.1726 18.9095 14.8297 19.0363C14.6891 19.0877 14.4971 19.1769 14.4046 19.2352C14.3154 19.2935 14.1474 19.3723 14.0343 19.41C13.8389 19.4786 13.7497 19.482 12.3783 19.4786C11.4251 19.4752 10.8903 19.4615 10.8149 19.434C10.6537 19.3826 10.568 19.2763 10.4994 19.0397C10.4446 18.8512 10.4411 18.5837 10.4343 16.0055C10.4309 12.8135 10.4514 11.7575 10.5337 11.3769C10.5646 11.226 10.6503 10.9963 10.7429 10.8215C10.8423 10.6226 10.9314 10.3792 11 10.1015C11.0754 9.8066 11.1474 9.6146 11.24 9.45689C11.3909 9.19975 11.4183 9.11403 11.5109 8.66832C11.5486 8.49003 11.6343 8.16775 11.6994 7.95517C11.8297 7.54032 11.8537 7.36889 11.9257 6.13117C11.9771 5.27403 11.9771 5.06832 11.9429 4.22489C11.9223 3.6866 11.9257 3.42946 11.9566 3.2306C12.008 2.90146 12.0971 2.68889 12.2069 2.6306C12.4606 2.49346 13.0606 2.4626 13.304 2.57918ZM10.3314 9.0866C10.4651 9.14832 10.4994 9.2546 10.4754 9.57003C10.4549 9.88546 10.3691 10.1529 10.2286 10.3346C10.0914 10.5163 10.0469 10.6535 9.95428 11.1849C9.90628 11.4557 9.83428 11.8055 9.79314 11.9632C9.72114 12.2306 9.71428 12.3403 9.704 13.4512C9.69714 14.1095 9.69028 14.7677 9.68686 14.9083C9.68686 15.0489 9.68686 15.9815 9.69371 16.9757L9.70057 18.786L9.61485 18.9335C9.44343 19.2249 9.32 19.2626 8.60343 19.2283C7.97943 19.2009 7.91428 19.1769 7.91428 18.9643C7.91428 18.7483 8.05828 18.6557 8.63428 18.4946C8.744 18.4637 8.86057 18.4055 8.90857 18.354L8.99086 18.2649L8.99771 16.8352C9.008 15.3643 8.99086 15.1003 8.87086 14.8706C8.78857 14.706 8.71657 14.658 8.37371 14.5277C8.15086 14.4455 8.04114 14.3735 7.808 14.1712C7.40686 13.8215 7.06743 13.434 6.97143 13.218C6.92686 13.1152 6.82743 12.9369 6.752 12.8169C6.51886 12.4569 6.49143 12.3197 6.49143 11.5312C6.49143 10.6672 6.53257 10.4375 6.74857 10.026C6.83771 9.8546 6.93028 9.65232 6.95428 9.57689C7.02628 9.3506 7.12228 9.18603 7.21828 9.12432C7.30057 9.06946 7.448 9.05917 8.63428 9.04203C10.0091 9.02146 10.2046 9.02832 10.3314 9.0866Z" fill={color} />
    </svg>

  );
};



export const IconAvailableLiveMusicCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7932 0.0288419C10.2721 0.0768422 9.87437 0.1557 9.5178 0.282555C9.33951 0.347699 8.99323 0.4437 8.75322 0.4917C8.2698 0.591128 8.1978 0.618556 7.9098 0.793414C7.80351 0.858556 7.60808 0.940843 7.48123 0.975127C7.20351 1.04713 7.03208 1.12941 6.88465 1.2597C6.7578 1.36941 6.5658 1.47227 6.36351 1.53741C6.29151 1.56141 6.15094 1.65398 6.04808 1.74656C5.94866 1.83913 5.78751 1.95227 5.69494 2.00027C5.59894 2.04827 5.44466 2.15456 5.34866 2.24027C5.25608 2.32256 5.09494 2.44598 4.99208 2.51113C4.64237 2.73398 3.78866 3.59456 3.46294 4.05741C3.35323 4.20827 3.22294 4.36941 3.17151 4.41741C3.12009 4.46542 3.02751 4.5957 2.9658 4.70884C2.90066 4.82199 2.80123 4.96256 2.73951 5.01742C2.68123 5.0757 2.57151 5.25056 2.49951 5.40827C2.42409 5.56599 2.31437 5.76141 2.24923 5.83684C2.1018 6.02199 2.07437 6.07341 1.97151 6.3957C1.92694 6.54313 1.84123 6.7317 1.78294 6.81741C1.62866 7.04027 1.58751 7.15341 1.49494 7.59913C1.4058 8.00713 1.33037 8.25399 1.20352 8.53513C1.1658 8.62084 1.11094 8.8197 1.08352 8.98084C1.00123 9.46084 0.949801 10.726 0.973801 11.686C1.00466 12.9511 1.0698 13.4243 1.26866 13.8837C1.33037 14.0174 1.40923 14.2643 1.44694 14.4254C1.59094 15.0563 1.61837 15.142 1.75209 15.3408C1.82751 15.454 1.93723 15.7008 2.0058 15.9031C2.09494 16.1706 2.16351 16.3111 2.27323 16.4414C2.35209 16.5408 2.45494 16.7123 2.49951 16.822C2.54409 16.9351 2.6538 17.1203 2.74294 17.23C2.83209 17.3431 2.95551 17.5283 3.0138 17.6414C3.07551 17.7683 3.17494 17.8986 3.25723 17.9637C3.33609 18.0254 3.42866 18.1317 3.4698 18.2003C3.50751 18.2654 3.64123 18.4197 3.76123 18.5431C3.88123 18.6666 4.14866 18.9374 4.35437 19.15C4.56008 19.3591 4.75894 19.5408 4.79323 19.5546C4.83094 19.5648 4.92351 19.6506 5.00237 19.7431C5.08466 19.8391 5.21151 19.9488 5.29037 19.99C5.36923 20.0277 5.5098 20.1271 5.60237 20.2128C5.69494 20.2951 5.88008 20.4151 6.0138 20.4768C6.15094 20.542 6.32923 20.6517 6.41151 20.7203C6.58637 20.8643 6.7338 20.9431 6.99094 21.0288C7.09037 21.0597 7.27208 21.1557 7.39551 21.2414C7.57723 21.3648 7.69723 21.4128 8.00923 21.4951C8.25951 21.5568 8.50637 21.6494 8.69151 21.7488C8.92123 21.8688 9.02065 21.9031 9.15094 21.9031C9.33608 21.9031 9.40465 21.8483 9.52808 21.6048C9.56922 21.5226 9.6618 21.3614 9.73722 21.2448C9.81608 21.1283 9.90865 20.9226 9.9498 20.7888C10.0355 20.4974 10.1144 20.3363 10.2652 20.1374C10.3304 20.0551 10.4161 19.894 10.4607 19.7774C10.5052 19.6608 10.6081 19.4894 10.6835 19.4003C10.8721 19.1774 10.9509 19.0471 11.0435 18.8003C11.0847 18.6871 11.1704 18.5088 11.2321 18.406C11.3795 18.166 11.4515 17.8368 11.4515 17.3946C11.4515 16.8906 11.4035 16.6711 11.2149 16.2837C11.0847 16.0197 11.0332 15.862 10.9887 15.6048C10.9578 15.4197 10.8858 15.1146 10.8275 14.926C10.7452 14.6483 10.7212 14.5008 10.7075 14.1546L10.6904 13.726L10.8652 13.1774C11.0298 12.6631 11.0538 12.6186 11.2081 12.4574C11.3007 12.3614 11.4138 12.2243 11.4618 12.1523C11.5715 11.9877 12.0618 11.5386 12.2127 11.4597C12.2744 11.4288 12.4081 11.3431 12.5075 11.2677C12.7407 11.0963 12.8469 11.0517 13.2961 10.9454C13.9818 10.7843 14.2115 10.702 14.3247 10.5751C14.3829 10.5066 14.4412 10.39 14.4618 10.294C14.4927 10.1568 14.5544 3.87227 14.5544 1.05741C14.5544 0.611699 14.4995 0.412843 14.3349 0.255128C14.2492 0.172843 14.1978 0.159127 13.9167 0.12827C13.7384 0.111127 13.5327 0.0802697 13.4572 0.059699C13.2858 0.0116986 11.2595 -0.0123015 10.7932 0.0288419ZM10.6287 3.36141C10.8207 3.46084 10.9269 3.61513 10.9544 3.84484C10.9647 3.94427 10.9715 5.28141 10.9647 6.81741C10.9544 10.0163 10.9818 9.73856 10.6218 10.0266C10.5087 10.1191 10.3715 10.2288 10.3201 10.2734C10.1144 10.4448 9.60694 10.438 9.30522 10.2631C9.12351 10.1568 8.89722 9.8997 8.84237 9.74199C8.78408 9.56027 8.83208 9.28256 8.95208 9.11799C9.0618 8.9637 9.20922 8.87799 9.50065 8.79227C9.7338 8.72713 9.88465 8.58656 9.93951 8.38427C9.97037 8.28141 9.97722 7.76713 9.97037 6.59456C9.96008 5.04484 9.95665 4.94199 9.89494 4.81856C9.77151 4.57856 9.4938 4.5717 9.05494 4.79113C8.84923 4.89741 8.71551 4.92827 8.07094 5.03113C7.5018 5.1237 7.30637 5.20256 7.07323 5.4357C6.75094 5.75799 6.77151 5.59684 6.76808 7.88027C6.76808 8.98427 6.75437 9.96827 6.74065 10.0643C6.72351 10.1911 6.67208 10.3077 6.55208 10.4928C6.36008 10.7877 6.29151 10.8528 6.11323 10.918C5.95894 10.9694 5.45494 10.9797 5.27666 10.9317C5.12237 10.8871 4.5978 10.3626 4.58751 10.2426C4.56008 9.80713 4.7178 9.6117 5.26294 9.40599C5.39323 9.35799 5.54751 9.2757 5.60237 9.22427C5.81151 9.02541 5.80808 9.04941 5.83208 7.22884C5.85266 5.46313 5.86637 5.3397 6.04123 4.87341C6.09608 4.72256 6.14408 4.66427 6.3018 4.5477C6.40808 4.46884 6.56923 4.33856 6.65494 4.2597C6.84351 4.08827 7.00123 4.03684 7.57037 3.95456C7.78637 3.9237 8.06408 3.86199 8.18751 3.81398C8.73951 3.60484 8.89037 3.5637 9.3258 3.49513C9.57951 3.45741 9.87437 3.3957 9.97722 3.35799C10.2344 3.26541 10.4401 3.26884 10.6287 3.36141Z" fill={color} />
      <path d="M17.1567 1.3317C17.0778 1.36255 16.9921 1.47912 16.9612 1.60598C16.927 1.7397 17.0264 6.55341 17.1224 9.54313C17.143 10.1054 17.1944 10.3111 17.3692 10.5134C17.575 10.7534 17.7155 10.8117 18.3601 10.9317C18.9567 11.0414 19.1624 11.11 19.3612 11.2608C19.423 11.3054 19.5738 11.3911 19.6972 11.446C19.9441 11.5591 20.4207 11.9603 20.5475 12.166C20.5887 12.2311 20.6881 12.358 20.7704 12.4471C20.911 12.598 20.9384 12.6597 21.1132 13.2186C21.3464 13.9797 21.3601 14.158 21.199 14.6174C21.1338 14.8026 21.0618 15.1214 21.0172 15.4231C20.9624 15.7831 20.911 15.9957 20.8252 16.2083C20.6744 16.5854 20.599 16.942 20.5955 17.326C20.5921 17.662 20.6332 17.7888 20.7464 17.7888C20.7875 17.7888 20.9384 17.6791 21.0892 17.5386C21.3292 17.3226 21.3841 17.2506 21.511 16.9831C21.5932 16.8117 21.7064 16.6163 21.7681 16.5477C21.8298 16.4791 21.9258 16.2871 21.9944 16.1054C22.0595 15.9306 22.1692 15.7043 22.2378 15.6048C22.3818 15.3923 22.4298 15.2654 22.5258 14.8368C22.5635 14.6586 22.6595 14.3774 22.7487 14.1923C22.8995 13.8597 22.9167 13.7877 23.0024 13.0746C23.1361 11.9808 23.1807 10.8014 23.1087 10.2597C23.0915 10.1226 23.0538 9.72141 23.023 9.36827C22.951 8.55913 22.9064 8.34313 22.735 7.98655C22.6595 7.82884 22.5738 7.58541 22.543 7.43798C22.4538 7.02998 22.3921 6.86541 22.2481 6.64598C22.1727 6.53627 22.0664 6.30998 22.0115 6.14884C21.9052 5.83341 21.8195 5.66884 21.6995 5.56255C21.6584 5.52827 21.5658 5.37741 21.4938 5.22998C21.4218 5.08255 21.2984 4.89055 21.223 4.80484C21.1475 4.7157 21.0344 4.56141 20.9761 4.45512C20.9144 4.34884 20.7875 4.17741 20.6915 4.07455C20.5955 3.9717 20.4824 3.83113 20.4412 3.76598C20.4001 3.69741 20.3075 3.59113 20.2287 3.52941C20.1532 3.4677 20.047 3.35455 19.999 3.27913C19.9475 3.2037 19.8172 3.0837 19.711 3.00827C19.6012 2.93627 19.4812 2.82998 19.4401 2.7717C19.399 2.71684 19.2961 2.62084 19.207 2.55912C19.1178 2.50084 18.967 2.37741 18.871 2.28827C18.775 2.19913 18.6035 2.07913 18.487 2.02084C18.3704 1.96255 18.199 1.84598 18.1064 1.7637C18.0138 1.68141 17.7875 1.54084 17.6024 1.45513C17.2424 1.2837 17.2595 1.29055 17.1567 1.3317Z" fill={color} />
      <path d="M15.2915 15.6905C15.2195 15.7488 15.2195 15.7557 15.2709 15.8105C15.3669 15.9065 15.6001 15.9511 15.9635 15.9511C16.3681 15.9477 16.6972 15.8654 16.6972 15.766C16.6972 15.6631 16.5121 15.6288 15.9258 15.6288C15.4389 15.6288 15.3567 15.6357 15.2915 15.6905Z" fill={color} />
      <path d="M15.4629 16.4722C15.1406 16.5408 15.0651 16.5785 14.9691 16.7259C14.9246 16.7979 14.8149 16.9111 14.7291 16.9831C14.5989 17.0894 14.568 17.1374 14.5337 17.3019C14.4754 17.5728 14.4857 18.2208 14.5509 18.4471C14.6091 18.6528 14.7154 18.7659 15.1337 19.0779C15.2811 19.1911 15.4354 19.3042 15.4766 19.3351C15.7131 19.5202 16.3337 19.5099 16.5291 19.3179C16.5737 19.2768 16.68 19.1911 16.7623 19.1328C17.0057 18.9579 17.3794 18.5911 17.4206 18.4848C17.4754 18.3442 17.4994 17.6345 17.4548 17.3945C17.4206 17.2128 17.4 17.1716 17.2491 17.0345C17.1566 16.9488 17.0571 16.8322 17.0297 16.7774C16.9474 16.6094 16.8617 16.5579 16.5394 16.4859C16.1863 16.4071 15.7851 16.4036 15.4629 16.4722Z" fill={color} />
    </svg>

  );
};



export const IconAvailableVipCircle: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.76577 0.134679C9.51205 0.155252 9.20691 0.20325 9.01148 0.258107C8.52462 0.388395 8.24691 0.456966 7.81148 0.556394C7.50634 0.628394 7.36234 0.679822 7.19434 0.786107C7.07091 0.861537 6.8652 0.954108 6.73148 0.991822C6.35434 1.10154 6.29948 1.12896 6.09034 1.28325C5.98063 1.36211 5.8332 1.44782 5.76463 1.47182C5.55548 1.53697 5.37034 1.63982 5.20577 1.77697C5.12005 1.84554 4.96577 1.95182 4.86291 2.01011C4.62977 2.14039 4.46863 2.29125 3.37491 3.38839C2.15777 4.60554 2.15091 4.61582 2.02063 4.84554C1.95891 4.95868 1.8492 5.11982 1.7772 5.20554C1.6332 5.38039 1.56806 5.49696 1.46863 5.76097C1.43091 5.86382 1.34863 6.00782 1.28349 6.08325C1.1292 6.26497 1.10863 6.31296 1.02291 6.64554C0.974914 6.83754 0.902914 7.00897 0.8172 7.14268C0.656057 7.38954 0.6012 7.53696 0.525772 7.91754C0.494915 8.07525 0.416058 8.39411 0.350915 8.62382C0.176058 9.23068 0.128058 9.65239 0.107486 10.7084C0.086915 11.8295 0.134915 12.3335 0.333772 13.105C0.4092 13.3895 0.501772 13.7941 0.542915 14.0067C0.628629 14.4661 0.669772 14.5998 0.810343 14.8193C0.868629 14.9118 0.957771 15.1073 1.00577 15.2513C1.05377 15.3987 1.16006 15.6078 1.23549 15.721C1.31434 15.8307 1.42749 16.033 1.4892 16.1701C1.55434 16.3073 1.67091 16.4924 1.7532 16.5815C1.83549 16.6707 1.9452 16.8113 1.9932 16.897C2.04463 16.9827 2.16806 17.1473 2.27091 17.2638C2.37377 17.3804 2.52806 17.5724 2.6172 17.6855C2.70291 17.7987 2.78863 17.8913 2.8092 17.8913C2.82634 17.8913 2.90863 17.9838 2.99091 18.097C3.30634 18.5255 4.12234 19.3861 4.30063 19.4787C4.36234 19.5095 4.49263 19.609 4.59205 19.7015C4.69491 19.7941 4.89377 19.9278 5.03434 19.9998C5.17491 20.0718 5.36005 20.1781 5.4492 20.2432C5.53491 20.305 5.78177 20.425 5.99777 20.5107C6.21034 20.593 6.56691 20.7404 6.78291 20.8364C6.99891 20.929 7.31777 21.0387 7.4892 21.0764C7.66062 21.1141 7.90748 21.193 8.03777 21.2513C8.39091 21.4124 8.76462 21.4878 9.39205 21.5255C10.1121 21.5701 11.6789 21.5701 12.3989 21.5255C13.0743 21.4844 13.3726 21.4261 13.8183 21.2478C14.0035 21.1758 14.2949 21.0901 14.4663 21.0592C14.8503 20.9941 14.9875 20.9461 15.3406 20.7507C15.4983 20.6684 15.728 20.5587 15.8549 20.5107C16.1566 20.3975 16.2732 20.3358 16.4103 20.2193C16.472 20.1644 16.6195 20.0718 16.736 20.0135C16.8526 19.9553 17.0172 19.849 17.1029 19.7804C17.1886 19.7118 17.3738 19.5713 17.5143 19.4684C17.8435 19.2353 18.08 19.0261 18.536 18.5701C18.9955 18.1107 19.2869 17.785 19.4343 17.5655C19.496 17.4695 19.6298 17.2947 19.7258 17.1713C19.8252 17.0478 19.9486 16.8661 19.9966 16.7667C20.048 16.6673 20.1543 16.4958 20.2366 16.3861C20.3155 16.2764 20.432 16.057 20.4903 15.8958C20.552 15.7381 20.6549 15.5153 20.7235 15.4021C20.9086 15.0935 20.9978 14.8535 21.0595 14.4901C21.0903 14.3015 21.1726 14.017 21.248 13.8215C21.3235 13.6364 21.4092 13.3655 21.4366 13.2181C21.5292 12.7724 21.5703 11.761 21.5498 10.417C21.5292 8.89811 21.4743 8.45925 21.2446 8.00325C21.2069 7.93125 21.1315 7.69125 21.0766 7.47182C21.0183 7.25239 20.9052 6.92668 20.8229 6.74839C20.7406 6.57011 20.6 6.24097 20.5143 6.01811C20.4286 5.79525 20.2983 5.52439 20.2263 5.41811C20.1543 5.31182 20.0378 5.11297 19.9726 4.97582C19.904 4.83868 19.76 4.63296 19.6572 4.51639C19.5543 4.39982 19.4686 4.29011 19.4686 4.27297C19.4686 4.23525 18.7966 3.57696 18.44 3.26839C18.2858 3.13468 18.0766 2.95297 17.9738 2.86039C17.6035 2.52782 17.216 2.21925 16.8972 2.00668C16.7189 1.88325 16.5338 1.74268 16.4858 1.69125C16.4378 1.63982 16.3006 1.55411 16.1772 1.49925C16.0538 1.44096 15.8995 1.35525 15.8343 1.30382C15.6355 1.14954 15.5532 1.10496 15.3029 1.02268C15.1726 0.981536 14.96 0.885537 14.8366 0.813537C14.5692 0.652395 14.5178 0.638679 13.9143 0.522107C13.6606 0.474109 13.2595 0.381536 13.0229 0.316394C12.7863 0.25468 12.4709 0.186109 12.32 0.165536C11.9463 0.114108 10.2938 0.0935376 9.76577 0.134679ZM3.90977 7.02611C4.28348 7.10497 4.48577 7.31068 4.62291 7.75982C4.64691 7.83525 4.73263 8.06497 4.81491 8.27411C4.8972 8.47982 5.00348 8.81239 5.05148 9.01125C5.10291 9.21011 5.2092 9.51868 5.29148 9.69697C5.39091 9.91639 5.46977 10.1667 5.53148 10.4513C5.59663 10.7735 5.65491 10.9415 5.75434 11.1233C5.83663 11.2741 5.92577 11.5107 5.98063 11.7301C6.15548 12.4364 6.28234 12.4741 6.62862 11.9255C6.85834 11.5587 6.91662 11.4181 7.00234 11.0135C7.09491 10.5747 7.13605 10.441 7.28005 10.1324C7.33148 10.0261 7.4172 9.70725 7.47205 9.43297C7.53034 9.15525 7.62291 8.81239 7.67777 8.66839C7.73262 8.52782 7.82177 8.25011 7.88005 8.05125C8.00691 7.59182 8.08577 7.40668 8.21948 7.25239C8.40462 7.04325 8.56577 7.00554 9.23434 7.00554C9.88577 7.00554 9.96805 7.02954 10.0606 7.25239C10.1841 7.54382 10.0743 8.10268 9.83434 8.42154C9.64577 8.66839 9.63891 8.68554 9.52234 9.20668C9.45719 9.49125 9.36119 9.79639 9.28234 9.97125C9.19662 10.1667 9.11777 10.4307 9.05262 10.7461C8.99434 11.0238 8.88805 11.3873 8.79891 11.617C8.71319 11.833 8.59319 12.2033 8.53491 12.4364C8.4732 12.6695 8.40805 12.8993 8.38748 12.9507C8.31891 13.1358 8.02062 14.2535 7.95205 14.5964C7.91091 14.7987 7.80462 15.145 7.70177 15.4021C7.39662 16.1564 7.2252 16.2661 6.35091 16.2593C5.79205 16.2524 5.67548 16.2181 5.39091 15.961C5.1852 15.7758 5.09948 15.6147 5.00005 15.2135C4.95891 15.0593 4.8732 14.7987 4.80805 14.6375C4.74291 14.4764 4.63663 14.1267 4.57148 13.8627C4.50634 13.5987 4.34863 13.0501 4.21491 12.6455C4.08463 12.241 3.93377 11.7473 3.88577 11.5518C3.83777 11.3564 3.75891 11.1233 3.71434 11.0375C3.61491 10.8353 3.54634 10.5987 3.4572 10.1427C3.4092 9.87868 3.35091 9.71068 3.24806 9.51525C3.15206 9.33011 3.08348 9.12439 3.0252 8.86382C2.94634 8.51068 2.89834 8.39068 2.6412 7.90039C2.5692 7.76325 2.55206 7.68439 2.54863 7.46497C2.54863 7.04668 2.62748 6.99868 3.32691 6.99182C3.54634 6.98839 3.81034 7.00554 3.90977 7.02611ZM12.0972 7.08097C12.2858 7.16668 12.3543 7.23868 12.4023 7.41697C12.4298 7.51297 12.44 8.78496 12.44 11.617V15.6833L12.3646 15.8341C12.2035 16.1495 11.8058 16.3038 11.2435 16.2627C11.0618 16.2524 10.8663 16.225 10.8081 16.2078C10.6743 16.1667 10.5406 16.0295 10.4618 15.8513C10.4035 15.721 10.4001 15.481 10.3932 11.5655C10.3863 8.83982 10.3966 7.37925 10.4172 7.31068C10.4652 7.17354 10.5886 7.05697 10.7326 7.01925C10.7943 7.00554 11.0926 6.99525 11.3943 7.00211C11.8606 7.00897 11.9669 7.01925 12.0972 7.08097ZM17.1303 7.08097C17.2469 7.12211 17.3943 7.19068 17.456 7.23868C17.5178 7.28325 17.6755 7.37582 17.8058 7.44439C18.1315 7.60897 18.3166 7.77697 18.5909 8.17811C18.9749 8.72668 18.9612 8.67182 18.9989 9.81697C19.0366 11.065 19.0023 11.5964 18.872 11.8604C18.6046 12.4021 18.2412 12.8273 17.8263 13.081C17.6823 13.1701 17.5212 13.2764 17.4629 13.3175C17.2675 13.4615 17.0206 13.5061 16.3486 13.5335C15.9475 13.5473 15.6869 13.5713 15.6389 13.5987C15.464 13.6981 15.4469 13.7941 15.4263 14.7884C15.4023 15.8581 15.4023 15.8615 15.08 16.081C14.816 16.2593 14.6686 16.2901 14.2126 16.273C13.7566 16.2558 13.5955 16.1941 13.3349 15.9404C13.2012 15.8101 13.16 15.7415 13.1292 15.5975C13.1018 15.4707 13.0915 14.2947 13.0915 11.6067C13.0915 8.29811 13.0983 7.76325 13.1429 7.58839C13.2012 7.36554 13.2698 7.25239 13.4069 7.14954C13.6058 7.00211 13.7429 6.99182 15.3715 6.99868C16.8389 7.00897 16.9246 7.01239 17.1303 7.08097Z" fill={color} />
      <path d="M15.6972 8.53467C15.5567 8.59296 15.4607 8.7061 15.3989 8.88781C15.3269 9.1141 15.2892 10.9758 15.3544 11.3324C15.4332 11.7952 15.5841 11.9427 15.9715 11.9392C16.2355 11.9358 16.4241 11.8604 16.7052 11.6547C17.0892 11.3701 17.2058 11.0375 17.2058 10.2284C17.2058 9.68667 17.1509 9.37124 17.0035 9.08324C16.9247 8.93238 16.7155 8.7301 16.5544 8.65124C16.2835 8.5141 15.8858 8.45924 15.6972 8.53467Z" fill={color} />
    </svg>

  );
};



export const IconBack: React.FC<IProps> = (props: any) => {
  return (

    <MdArrowBack
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconBackSkip: React.FC<IProps> = (props: any) => {
  return (

    <IoPlaySkipBack
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCameraReverse: React.FC<IProps> = (props: any) => {
  return (

    <MdFlipCameraAndroid
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconCarnivalAgencyFlow: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 603 603">
      <path
        d="M67 125.5c0 34.333.346 52.5 1 52.5.55 0 1-.675 1-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.51 1.5-1.134C81 163.445 90.512 154 91.944 154c.581 0 1.056-.51 1.056-1.134 0-1.421 9.512-10.866 10.944-10.866.581 0 1.056-.491 1.056-1.09 0-1.425 40.485-41.91 41.91-41.91.599 0 1.09-.475 1.09-1.056C148 96.512 157.445 87 158.866 87c.624 0 1.134-.675 1.134-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.45 1.5-1c0-.654-18.167-1-52.5-1H67v52.5M365 74c0 .55-.675 1-1.5 1s-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.575-1.5 1.278c0 1.434-3.49 4.722-5.011 4.722-.544 0-.989.675-.989 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.517-1.5 1.149c0 1.421-6.511 7.851-7.95 7.851-.578 0-1.05.499-1.05 1.109 0 1.444-10.447 11.891-11.891 11.891-.61 0-1.109.675-1.109 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.472-1.5 1.05c0 1.439-6.43 7.95-7.851 7.95-.632 0-1.149.675-1.149 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.575-1.5 1.278c0 1.434-3.49 4.722-5.011 4.722-.544 0-.989.675-.989 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.517-1.5 1.149c0 1.421-6.511 7.851-7.95 7.851-.578 0-1.05.499-1.05 1.109 0 1.444-10.447 11.891-11.891 11.891-.61 0-1.109.675-1.109 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.472-1.5 1.05c0 1.439-6.43 7.95-7.851 7.95-.632 0-1.149.675-1.149 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.45 1.5-1 1.5c-.659 0-1 31.333-1 92s.341 92 1 92c.55 0 1-.675 1-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.51 1.5-1.134C81 540.445 90.512 531 91.944 531c.581 0 1.056-.491 1.056-1.091C93 528.484 130.484 491 131.909 491c.6 0 1.091-.472 1.091-1.05 0-1.439 6.43-7.95 7.851-7.95.632 0 1.149-.675 1.149-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.51 1.5-1.134c0-1.421 9.512-10.866 10.944-10.866.581 0 1.056-.492 1.056-1.094 0-1.429 25.477-26.906 26.906-26.906.602 0 1.094-.475 1.094-1.056 0-1.432 9.445-10.944 10.866-10.944.624 0 1.134-.445 1.134-.989 0-1.521 3.288-5.011 4.722-5.011.703 0 1.278-.675 1.278-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.506 1.5-1.124c0-1.421 12.511-13.876 13.939-13.876.584 0 1.061-.491 1.061-1.092C500 121.483 534.483 87 535.908 87c.601 0 1.092-.445 1.092-.989 0-1.521 3.288-5.011 4.722-5.011.703 0 1.278-.675 1.278-1.5s.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.45 1.5-1c0-.659-31.333-1-92-1s-92 .341-92 1m179.708 196.03c-2.635 2.733-5.447 4.97-6.25 4.97-.802 0-1.458.638-1.458 1.418 0 1.851-23.731 25.582-25.582 25.582-.78 0-1.418.639-1.418 1.421s-2.061 3.482-4.579 6-5.218 4.579-6 4.579-1.421.638-1.421 1.418c0 1.851-23.731 25.582-25.582 25.582a1.43 1.43 0 0 0-1.418 1.434c0 .788-4.275 5.687-9.5 10.887s-9.5 9.954-9.5 10.566c0 .612-.675 1.113-1.5 1.113s-1.5.675-1.5 1.5-.445 1.5-.989 1.5c-1.521 0-5.011 3.288-5.011 4.722 0 .703-.675 1.278-1.5 1.278s-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.472 1.5-1.05 1.5c-1.439 0-7.95 6.43-7.95 7.851 0 .632-.675 1.149-1.5 1.149s-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5c0 .92-.936 1.5-2.421 1.5-1.876 0-2.568.674-3.079 3-.362 1.65-1.298 3-2.079 3-.782 0-1.421.675-1.421 1.5s-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.517 1.5-1.149 1.5c-1.421 0-7.851 6.511-7.851 7.95 0 .578-.675 1.05-1.5 1.05s-1.5.675-1.5 1.5-.675 1.5-1.5 1.5-1.5.675-1.5 1.5-.517 1.5-1.149 1.5c-1.421 0-7.851 6.511-7.851 7.95 0 .578-.506 1.05-1.124 1.05-1.421 0-13.876 12.511-13.876 13.939 0 .584-.575 1.061-1.278 1.061-.703 0-2.048.9-2.99 2-.942 1.1-2.392 2-3.222 2-.831 0-1.51.639-1.51 1.421s-2.061 3.482-4.579 6-5.218 4.579-6 4.579-1.421.639-1.421 1.42c0 .781-2.736 4.156-6.08 7.5-3.344 3.344-6.719 6.08-7.5 6.08-.781 0-1.42.639-1.42 1.421s-2.061 3.482-4.579 6-5.218 4.579-6 4.579-1.421.638-1.421 1.418c0 .78-5.437 6.855-12.082 13.5-6.645 6.645-12.72 12.082-13.5 12.082-.78 0-1.418.65-1.418 1.445 0 .794-2.25 3.659-5 6.366s-5 5.207-5 5.555c0 .349 41.432.634 92.071.634 96.12 0 94.929.049 94.929-3.929 0-.589.675-1.071 1.5-1.071s1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.575-1.5 1.278-1.5c1.434 0 4.722-3.49 4.722-5.011 0-.544.675-.989 1.5-.989s1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.489-1.5 1.088-1.5c1.421 0 68.912-67.491 68.912-68.912 0-.599.445-1.088.989-1.088 1.521 0 5.011-3.288 5.011-4.722 0-.703.675-1.278 1.5-1.278s1.5-.675 1.5-1.5.675-1.5 1.5-1.5 1.5-.675 1.5-1.5.482-1.5 1.071-1.5c3.978 0 3.929 1.191 3.929-94.929 0-50.639-.337-92.058-.75-92.041-.413.016-2.906 2.266-5.542 5"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalAgencyPublic: React.FC<IProps> = (props: any) => {
  return (

    <BsFillBuildingsFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalAreaReserved: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.05544 0.0702991C2.35714 0.224956 1.86505 0.459285 1.35422 0.89045C0.805886 1.34505 0.374721 2.00117 0.159139 2.69478L0.0279148 3.11657L0.013855 7.00643C0.00916846 9.14351 0.00916846 11.2478 0.013855 11.6836L0.0279148 12.4663L12.4942 0L7.92479 0.00468636C4.21303 0.00468636 3.29914 0.0187464 3.05544 0.0702991Z"
        fill={color} />
      <path
        d="M10.0106 4.4992L12.5085 6.99246L15.0018 9.49041L19.0557 5.43652C21.2865 3.20571 23.1096 1.36857 23.1096 1.35451C23.1096 1.33577 22.9877 1.20454 22.8424 1.05457C22.5144 0.731199 22.027 0.421885 21.5864 0.257855C20.9256 0.00946712 20.8131 9.34601e-05 17.5419 9.34601e-05H14.5097L10.0106 4.4992Z"
        fill={color} />
      <path
        d="M16.0092 10.4978L23.9998 18.4884L23.9858 10.8024C23.9764 4.20837 23.9623 3.08359 23.9061 2.89144L23.8358 2.67117L16.0092 10.4978Z"
        fill={color} />
      <path
        d="M9.00784 5.81589C8.96098 5.92837 8.46889 7.05314 7.91118 8.31852C7.35817 9.57921 6.71611 11.0508 6.48178 11.5851L6.05999 12.5552L6.16778 12.6536L6.27088 12.752L6.95512 11.1914C7.33005 10.3337 8.00492 8.78249 8.45951 7.75144C8.91411 6.71571 9.28435 5.84869 9.28435 5.82526C9.28435 5.79714 9.24217 5.7409 9.19062 5.69404C9.10157 5.61437 9.09689 5.61437 9.00784 5.81589Z"
        fill={color} />
      <path
        d="M8.19669 6.31275C7.93893 6.57988 7.9155 6.63143 6.75792 9.27935C6.11117 10.7603 5.58159 11.9976 5.58159 12.0257C5.58159 12.0538 5.62376 12.1147 5.67532 12.1616C5.76436 12.2413 5.76905 12.2413 5.85809 12.0397C5.90496 11.9273 6.15803 11.3461 6.4158 10.7556C7.05786 9.27935 8.44508 6.12528 8.46851 6.0831C8.52475 5.99406 8.44508 6.06436 8.19669 6.31275Z"
        fill={color} />
      <path
        d="M9.31243 6.78156C9.15778 7.13774 8.60945 8.39843 8.08455 9.58414C7.56434 10.7698 7.01133 12.0352 6.85667 12.3961L6.57079 13.0522L6.67389 13.16L6.777 13.2725L6.82855 13.1366C6.86136 13.0663 7.34876 11.9509 7.91583 10.662C9.9873 5.93798 9.82327 6.33634 9.72954 6.23324C9.68267 6.18168 9.63112 6.1395 9.61706 6.1395C9.603 6.1395 9.4624 6.43007 9.31243 6.78156Z"
        fill={color} />
      <path
        d="M9.75282 7.4375C9.56535 7.87335 8.8858 9.42461 8.24374 10.8868C7.12365 13.441 7.07678 13.5582 7.15645 13.6425C7.19863 13.6894 7.25019 13.7316 7.26893 13.7316C7.28768 13.7316 7.34392 13.6332 7.40016 13.5066C7.50795 13.2535 9.09201 9.63082 9.83249 7.95302C10.3011 6.8798 10.3199 6.82825 10.2402 6.74389C10.198 6.69702 10.1465 6.65484 10.1277 6.65484C10.109 6.65484 9.94028 7.00634 9.75282 7.4375Z"
        fill={color} />
      <path
        d="M7.58274 14.0691L7.68116 14.1675C7.7374 14.2191 7.78895 14.2566 7.79832 14.2425C7.81707 14.2191 7.96235 13.8863 9.00277 11.5055C9.48549 10.3948 10.0947 9.00759 10.3572 8.4124L10.8305 7.33917L10.7274 7.23138L10.6196 7.12359L7.58274 14.0691Z"
        fill={color} />
      <path
        d="M6.9031 7.60631C6.67345 7.84064 6.61253 7.96249 5.86268 9.66372C5.42214 10.662 5.06596 11.4962 5.06596 11.5196C5.06596 11.543 5.10814 11.5993 5.155 11.6415C5.23936 11.7211 5.24873 11.7211 5.2956 11.6321C5.32372 11.5805 5.71739 10.6901 6.17199 9.64966C6.6219 8.60924 7.03432 7.66724 7.08119 7.55476C7.13274 7.44697 7.16554 7.35792 7.16086 7.35792C7.15148 7.35792 7.03901 7.4704 6.9031 7.60631Z"
        fill={color} />
      <path
        d="M11.0091 7.90619C10.9435 8.05616 10.2687 9.60742 9.50475 11.3508C8.73616 13.0942 8.11284 14.5424 8.11284 14.5658C8.11284 14.5892 8.15502 14.6455 8.20189 14.6877C8.31436 14.7908 8.24875 14.9032 8.86269 13.4973C9.12514 12.8927 9.72034 11.5289 10.1843 10.4744C10.6483 9.41527 11.0982 8.3936 11.1872 8.19207L11.3372 7.83589L11.2341 7.73748L11.1263 7.63906L11.0091 7.90619Z"
        fill={color} />
      <path
        d="M11.5663 8.30001C11.5288 8.38906 11.0882 9.39667 10.5821 10.5449C8.9699 14.2238 8.62778 15.0112 8.62778 15.0674C8.62778 15.1002 8.66996 15.1612 8.72151 15.208C8.81056 15.2877 8.81524 15.2877 8.85742 15.1799C8.88085 15.119 9.20891 14.3598 9.58853 13.4974C11.2898 9.62163 11.8146 8.41249 11.8146 8.36563C11.8146 8.33282 11.7725 8.2719 11.7256 8.22972C11.6366 8.15004 11.6319 8.15004 11.5663 8.30001Z"
        fill={color} />
      <path
        d="M5.57697 8.93732C5.3567 9.17634 5.27234 9.32162 4.93022 10.1137L4.53655 11.0228L4.64434 11.1213C4.70058 11.1775 4.75681 11.2009 4.76619 11.1775C4.78025 11.1494 5.02864 10.5823 5.32389 9.91682C5.61914 9.24664 5.85347 8.69362 5.8441 8.68425C5.83941 8.67488 5.71756 8.79204 5.57697 8.93732Z"
        fill={color} />
      <path
        d="M12.1056 8.74981C12.0681 8.82011 11.2105 10.7744 9.51391 14.6455L9.10618 15.5828L9.2046 15.6859C9.25615 15.7469 9.3077 15.789 9.31239 15.7797C9.3452 15.7469 12.3305 8.90447 12.3305 8.86229C12.3305 8.83886 12.2884 8.7873 12.2415 8.74512C12.1571 8.66545 12.1478 8.66545 12.1056 8.74981Z"
        fill={color} />
      <path
        d="M12.0959 10.4135C11.8006 11.0931 11.1211 12.6443 10.5868 13.8675L9.60733 16.0936L9.71512 16.1967L9.82291 16.3045L11.3414 12.8365C12.8036 9.48557 12.8551 9.36371 12.7755 9.27936C12.7286 9.2278 12.677 9.18563 12.663 9.18563C12.6489 9.18563 12.3912 9.73864 12.0959 10.4135Z"
        fill={color} />
      <path
        d="M12.9488 10.1323C12.6442 10.8446 11.2851 13.9378 10.6805 15.3203L10.1181 16.5997L10.2165 16.6982C10.2681 16.7544 10.3197 16.7872 10.3337 16.7731C10.3431 16.7638 10.9195 15.4656 11.6038 13.8956C12.2927 12.3209 12.9723 10.7743 13.1129 10.4556C13.3519 9.90731 13.3612 9.8745 13.2863 9.79014C13.2441 9.73859 13.1925 9.7011 13.1738 9.7011C13.155 9.7011 13.0519 9.89793 12.9488 10.1323Z"
        fill={color} />
      <path
        d="M4.26917 10.2402L4.01609 10.4979L4.12857 10.6151L4.23636 10.7323L4.39571 10.3714C4.48007 10.1745 4.54568 10.0058 4.5363 10.0011C4.52693 9.99177 4.40977 10.0996 4.26917 10.2402Z"
        fill={color} />
      <path
        d="M12.8363 12.0585C12.3817 13.0942 11.6975 14.6548 11.3179 15.5265L10.6289 17.1106L10.7274 17.2137C10.7836 17.2653 10.8351 17.3027 10.8445 17.2887C10.8539 17.2793 10.9523 17.059 11.0648 16.8013C11.1726 16.5435 11.8334 15.0344 12.5317 13.4504C13.2253 11.8663 13.8111 10.5213 13.8299 10.4697C13.8627 10.3947 13.8439 10.3432 13.7689 10.2729L13.6658 10.1745L12.8363 12.0585Z"
        fill={color} />
      <path
        d="M13.5582 12.0773C13.2255 12.8459 12.5553 14.3691 12.0726 15.4657C11.5946 16.5624 11.1915 17.4997 11.1775 17.5513C11.1634 17.6122 11.1868 17.6825 11.2478 17.734C11.3415 17.8184 11.3462 17.8184 11.4305 17.6169C11.4821 17.5044 11.7914 16.7967 12.1195 16.0516C12.4475 15.3017 13.0099 14.0176 13.3708 13.1928C13.7316 12.3679 14.1066 11.5103 14.205 11.2853L14.3831 10.8823L14.28 10.7792L14.1722 10.6807L13.5582 12.0773Z"
        fill={color} />
      <path
        d="M14.5847 11.3931C14.4254 11.7681 12.7195 15.6579 12.1758 16.8952L11.6416 18.1137L11.74 18.2215L11.8384 18.3339L11.9931 17.9871C12.4242 17.0498 14.8612 11.4494 14.8612 11.4072C14.8612 11.3791 14.8191 11.3181 14.7675 11.2713C14.6785 11.1916 14.6738 11.1916 14.5847 11.3931Z"
        fill={color} />
      <path
        d="M1.49033 13.0192L0 14.5096L0.0281194 20.8786L0.159343 21.3004C0.534269 22.5142 1.49502 23.475 2.69947 23.8358C3.08377 23.953 3.20562 23.9671 4.05857 23.9811L4.99589 23.9999L10.2448 18.7462L6.63619 15.1376C4.65377 13.1505 3.01815 11.5289 3.00409 11.5289C2.99003 11.5289 2.31048 12.1991 1.49033 13.0192Z"
        fill={color} />
      <path
        d="M14.4907 13.277C14.1158 14.13 13.53 15.475 13.1832 16.2623C12.3771 18.0995 12.4146 17.9776 12.7239 17.6683C12.9817 17.4152 13.0004 17.3731 14.1814 14.6783C14.8375 13.1739 15.3765 11.9273 15.3765 11.9085C15.3765 11.871 15.2218 11.7164 15.1844 11.7164C15.175 11.7164 14.861 12.4194 14.4907 13.277Z"
        fill={color} />
      <path
        d="M15.6016 12.4054C15.5595 12.5038 15.1377 13.4786 14.6549 14.5706C14.1769 15.6626 13.7879 16.5671 13.7973 16.5717C13.8067 16.5811 13.9192 16.478 14.0504 16.3421C14.2706 16.1171 14.3456 15.9625 15.0955 14.2566C15.8781 12.471 15.9016 12.4148 15.8219 12.3257C15.7047 12.1992 15.6813 12.2039 15.6016 12.4054Z"
        fill={color} />
      <path
        d="M15.9299 13.3238C15.7846 13.6659 15.5222 14.2564 15.3535 14.6454L15.0442 15.3484L15.3207 15.0672C15.5784 14.8095 15.63 14.711 16.0049 13.8534L16.4126 12.9161L16.3048 12.813L16.1971 12.7052L15.9299 13.3238Z"
        fill={color} />
      <path
        d="M16.6096 13.4364C16.5534 13.5582 16.4784 13.7457 16.4315 13.8488L16.3518 14.0363L16.5955 13.8019C16.9236 13.4832 16.9423 13.4411 16.8111 13.3145L16.7033 13.2114L16.6096 13.4364Z"
        fill={color} />
      <path
        d="M12.963 19.4495L17.509 23.9955H19.0415C20.1616 23.9955 20.6631 23.9767 20.9162 23.9299C22.4674 23.6299 23.6672 22.4208 23.9343 20.8789L23.9999 20.5087L17.9542 14.4583L12.963 19.4495Z"
        fill={color} />
      <path
        d="M9.12023 21.8865L7.01128 23.9955H15.494L13.385 21.8865C12.2274 20.7243 11.2667 19.7776 11.2526 19.7776C11.2386 19.7776 10.2778 20.7243 9.12023 21.8865Z"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalAttractions: React.FC<IProps> = (props: any) => {
  return (

    <MdAttractions
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalBathroom: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.4162 26H12.6846V0H11.4162V26Z"
        fill={color} />
      <path
        d="M4.12251 0.0738181C4.12251 0.114828 3.97188 0.172241 3.78161 0.196846C3.57548 0.229654 3.39314 0.319875 3.32972 0.410096C3.2663 0.500316 3.17116 0.574133 3.11567 0.574133C3.06017 0.574133 3.0126 0.623345 3.0126 0.68896C3.0126 0.746373 2.89368 0.894007 2.75891 1.01704L2.49729 1.23849V3.25615L2.75891 3.51041C2.89368 3.64164 3.0126 3.79748 3.0126 3.84669C3.0126 3.8959 3.06017 3.93691 3.11567 3.93691C3.17116 3.93691 3.2663 4.01073 3.32972 4.10095C3.39314 4.19117 3.50413 4.26499 3.57548 4.26499C3.65476 4.26499 3.72611 4.3142 3.7499 4.36341C3.76575 4.43722 4.00359 4.47003 4.55854 4.47003C5.1135 4.47003 5.35133 4.43722 5.37512 4.36341C5.39097 4.3142 5.4544 4.26499 5.50989 4.26499C5.6526 4.26499 6.4216 3.4694 6.4216 3.32177C6.4216 3.26435 6.46917 3.19874 6.52466 3.17413C6.58809 3.15773 6.6198 2.89527 6.6198 2.25552C6.6198 1.61577 6.58809 1.35331 6.52466 1.32871C6.46917 1.3123 6.4216 1.25489 6.4216 1.19748C6.4216 1.14006 6.23926 0.902209 6.02521 0.672556C5.71602 0.344481 5.54953 0.237856 5.3117 0.196846C5.13728 0.164039 4.99458 0.114828 4.99458 0.0738181C4.99458 0.0328086 4.79638 1.01838e-06 4.55854 1.01838e-06C4.32071 1.01838e-06 4.12251 0.0328086 4.12251 0.0738181Z"
        fill={color} />
      <path
        d="M19.241 0.246061C19.3203 0.246061 19.4709 0.188648 19.5819 0.131234C19.8039 4.01852e-06 20.5016 -0.0410054 20.565 0.0738211C20.5888 0.106629 20.7553 0.164042 20.9297 0.196849C21.1041 0.221455 21.2468 0.287071 21.2468 0.32808C21.2468 0.377291 21.3023 0.410099 21.3736 0.410099C21.5164 0.410099 21.8018 0.705367 21.8018 0.853001C21.8018 0.910414 21.8731 1.00064 21.9603 1.06625C22.0475 1.13187 22.1189 1.2631 22.1189 1.36972C22.1189 1.46814 22.1585 1.57477 22.1981 1.59937C22.2457 1.62398 22.2774 1.94385 22.2774 2.30474C22.2774 2.68202 22.2457 2.95269 22.1981 2.95269C22.1585 2.95269 22.1189 3.0265 22.1189 3.11672C22.1189 3.21515 22.0317 3.37918 21.9207 3.49401C21.8097 3.60884 21.7225 3.74827 21.7225 3.81388C21.7225 3.8795 21.6591 3.93691 21.5798 3.93691C21.5005 3.93691 21.3895 4.01073 21.3261 4.10095C21.2627 4.19117 21.1675 4.26499 21.12 4.26499C21.0645 4.26499 21.009 4.3142 20.9931 4.36341C20.9693 4.43723 20.7236 4.47004 20.1527 4.46183C19.4313 4.46183 19.3362 4.44543 19.2014 4.28139C19.1142 4.18297 19.027 4.10095 18.9953 4.10095C18.9636 4.10095 18.8209 3.98612 18.6702 3.83849C18.369 3.55963 18.1549 3.18234 18.1549 2.93628C18.1549 2.85426 18.1232 2.78865 18.0756 2.78865C18.0281 2.78865 17.9964 2.55899 17.9964 2.25552C17.9964 1.95205 18.0281 1.7224 18.0756 1.7224C18.1232 1.7224 18.1549 1.65679 18.1549 1.56657C18.1549 1.48455 18.2025 1.32871 18.258 1.21388C18.4086 0.910414 19.0825 0.246061 19.241 0.246061Z"
        fill={color} />
      <path
        d="M3.17116 5.49527C3.17116 5.54448 2.91747 5.57729 2.57657 5.57729C2.23567 5.57729 1.98198 5.61009 1.98198 5.65931C1.98198 5.70032 1.91855 5.74132 1.83927 5.74132C1.66486 5.74132 1.26846 5.92177 1.26846 6.00379C1.26846 6.04479 1.2209 6.0694 1.15747 6.0694C0.998916 6.0694 0.554953 6.5205 0.554953 6.67634C0.554953 6.75016 0.523242 6.80757 0.483602 6.80757C0.443963 6.80757 0.388467 6.9142 0.356756 7.05363C0.325044 7.18486 0.269549 7.31609 0.229909 7.34069C0.19027 7.3735 0.158558 7.52114 0.158558 7.67697C0.158558 7.83281 0.126846 7.95584 0.079279 7.95584C0.0237837 7.95584 0 9.14511 0 11.3596C0 13.2297 0.0317116 14.7634 0.0634232 14.7634C0.103063 14.7634 0.174414 14.8946 0.237837 15.0505C0.30126 15.2063 0.396395 15.3375 0.451891 15.3375C0.507386 15.3375 0.554953 15.3703 0.554953 15.4196C0.554953 15.4606 0.6818 15.5016 0.83243 15.5016C0.98306 15.5016 1.10991 15.4606 1.10991 15.4196C1.10991 15.3703 1.1654 15.3375 1.23675 15.3375C1.30018 15.3375 1.41909 15.2719 1.49045 15.1981C1.60936 15.0751 1.62522 14.7388 1.649 11.9584L1.67279 8.85804H2.14053V17.0517C2.14053 24.3678 2.15639 25.2454 2.25945 25.2946C2.3308 25.3192 2.42594 25.4505 2.46558 25.5899C2.52107 25.7457 2.60828 25.836 2.70342 25.836C2.78269 25.836 2.85405 25.8688 2.85405 25.918C2.85405 25.959 2.99675 26 3.17909 26C3.45657 26 3.54377 25.9508 3.81332 25.6473C3.97981 25.4587 4.12251 25.2536 4.12251 25.1962C4.12251 25.147 4.16215 25.0978 4.20179 25.0978C4.25728 25.0978 4.28107 23.4164 4.28107 20.2177V15.3375H4.83602V20.2177C4.83602 23.4164 4.85981 25.0978 4.9153 25.0978C4.96287 25.0978 4.99458 25.147 4.99458 25.1962C4.99458 25.2536 5.13728 25.4587 5.30377 25.6555C5.57332 25.9508 5.66052 26 5.938 26C6.12034 26 6.26304 25.959 6.26304 25.918C6.26304 25.8688 6.32647 25.836 6.40575 25.836C6.50881 25.836 6.60394 25.7129 6.70701 25.4669C6.78629 25.2618 6.88142 25.0978 6.91313 25.0978C6.94484 25.0978 6.97656 25.0076 6.97656 24.9009C6.97656 24.7861 7.0162 24.6713 7.05583 24.6467C7.11133 24.6139 7.13511 21.8826 7.13511 16.7237C7.13511 8.98927 7.13511 8.85804 7.28574 8.85804C7.43637 8.85804 7.4443 8.94826 7.46809 11.8763L7.49187 14.8946L7.7852 15.1981C7.99926 15.4114 8.14989 15.5016 8.3243 15.5016C8.45115 15.5016 8.56214 15.4606 8.56214 15.4196C8.56214 15.3703 8.6097 15.3375 8.6652 15.3375C8.85547 15.3375 9.11709 14.9685 9.11709 14.6978C9.11709 14.5502 9.15673 14.4353 9.19637 14.4353C9.24394 14.4353 9.27565 13.3937 9.27565 11.4826C9.27565 9.57161 9.24394 8.52997 9.19637 8.52997C9.1488 8.52997 9.11709 8.28391 9.11709 7.95584C9.11709 7.62776 9.08538 7.3817 9.03781 7.3817C8.99817 7.3817 8.95853 7.30789 8.95853 7.21767C8.95853 7.12744 8.92682 7.05363 8.87925 7.05363C8.83961 7.05363 8.79997 6.96341 8.79997 6.84858C8.79997 6.62713 8.31637 6.0694 8.1261 6.0694C8.06268 6.0694 8.00718 6.02839 8.00718 5.98738C8.00718 5.93817 7.93583 5.90536 7.84862 5.90536C7.76142 5.90536 7.69007 5.86435 7.69007 5.82334C7.69007 5.77413 7.60286 5.74132 7.49187 5.74132C7.38088 5.74132 7.29367 5.70032 7.29367 5.65931C7.29367 5.61009 6.71493 5.57729 5.70809 5.57729C4.70125 5.57729 4.12251 5.54448 4.12251 5.49527C4.12251 5.44606 3.90846 5.41325 3.64684 5.41325C3.38522 5.41325 3.17116 5.44606 3.17116 5.49527Z"
        fill={color} />
      <path
        d="M19.2252 5.57728C19.5185 5.57728 19.7405 5.54447 19.7405 5.49526C19.7405 5.44605 20.0021 5.41324 20.3747 5.41324C20.7473 5.41324 21.009 5.44605 21.009 5.49526C21.009 5.54447 21.223 5.57728 21.4846 5.57728C21.7463 5.57728 21.9603 5.61009 21.9603 5.6593C21.9603 5.70031 22.0713 5.74132 22.1981 5.74132C22.3329 5.74132 22.436 5.76592 22.436 5.79873C22.436 5.88895 22.8324 6.06939 23.0068 6.06939C23.0861 6.06939 23.1733 6.12681 23.1971 6.19242C23.2288 6.25804 23.3001 6.31545 23.3556 6.31545C23.5062 6.31545 24.1008 6.93879 24.1008 7.09463C24.1008 7.16025 24.1405 7.21766 24.1801 7.21766C24.2277 7.21766 24.2594 7.30788 24.2594 7.42271C24.2594 7.53753 24.299 7.62775 24.3387 7.62775C24.3862 7.62775 24.418 7.70157 24.418 7.79179C24.418 7.88201 24.4497 7.95583 24.4893 7.95583C24.521 7.95583 24.5765 8.17728 24.6082 8.44794C24.6399 8.71861 24.6954 8.95646 24.7351 8.98107C24.7826 9.01387 24.8144 9.1205 24.8144 9.23532C24.8144 9.34195 24.854 9.43217 24.8936 9.43217C24.9412 9.43217 24.9729 9.5634 24.9729 9.71924C24.9729 9.87507 25.0126 10.0063 25.0522 10.0063C25.0998 10.0063 25.1315 10.1129 25.1315 10.2524C25.1315 10.3836 25.1711 10.4984 25.2107 10.4984C25.2583 10.4984 25.29 10.6296 25.29 10.7855C25.29 10.9413 25.3217 11.0725 25.3614 11.0725C25.401 11.0725 25.4565 11.2366 25.4803 11.4416C25.512 11.6467 25.5675 11.8107 25.6151 11.8107C25.6547 11.8107 25.6864 11.9009 25.6864 12.0158C25.6864 12.1306 25.7261 12.2208 25.7657 12.2208C25.8133 12.2208 25.845 12.3849 25.845 12.5899C25.845 12.7949 25.8846 12.959 25.9243 12.959C26.0353 12.959 26.0194 13.9924 25.9084 14.2057C25.7261 14.5255 25.623 14.5994 25.3297 14.5994C25.1156 14.5994 24.9888 14.5337 24.8144 14.3533C24.6796 14.2139 24.5765 14.058 24.5765 14.0006C24.5765 13.9432 24.5052 13.8448 24.418 13.7792C24.3308 13.7136 24.2594 13.5823 24.2594 13.4757C24.2594 13.3773 24.2277 13.2789 24.188 13.2543C24.1484 13.2214 24.0929 13.0164 24.0612 12.7949C24.0295 12.5653 23.974 12.3849 23.9344 12.3849C23.8947 12.3849 23.863 12.2536 23.863 12.0978C23.863 11.9419 23.8313 11.8107 23.7837 11.8107C23.7441 11.8107 23.7044 11.6795 23.7044 11.5237C23.7044 11.3678 23.6727 11.2366 23.6252 11.2366C23.5855 11.2366 23.5459 11.1218 23.5459 10.9905C23.5459 10.8511 23.5142 10.7445 23.4666 10.7445C23.427 10.7445 23.3715 10.523 23.3398 10.2524C23.3081 9.9817 23.2526 9.73564 23.2208 9.71103C23.1812 9.68643 23.1495 9.5798 23.1495 9.46498C23.1495 9.35835 23.1178 9.26813 23.0702 9.26813C23.0306 9.26813 22.9909 9.17791 22.9909 9.06308C22.9909 8.94826 22.9592 8.85804 22.9117 8.85804C22.872 8.85804 22.8324 8.78422 22.8324 8.694C22.8324 8.57097 22.7769 8.52996 22.6342 8.52996C22.4598 8.52996 22.4439 8.55457 22.4915 8.79242C22.5153 8.94006 22.5708 9.07129 22.6104 9.08769C22.6421 9.10409 22.6738 9.24353 22.6738 9.39116C22.6738 9.547 22.7135 9.69463 22.7531 9.71924C22.8007 9.74384 22.8324 9.85867 22.8324 9.9735C22.8324 10.0801 22.872 10.1703 22.9117 10.1703C22.9592 10.1703 22.9909 10.3016 22.9909 10.4574C22.9909 10.6132 23.0226 10.7445 23.0623 10.7445C23.1019 10.7445 23.1574 10.9659 23.1891 11.2366C23.2208 11.5072 23.2763 11.7533 23.316 11.7779C23.3556 11.8025 23.3873 11.9091 23.3873 12.024C23.3873 12.1306 23.427 12.2208 23.4666 12.2208C23.5142 12.2208 23.5459 12.3274 23.5459 12.4669C23.5459 12.5981 23.5855 12.7129 23.6252 12.7129C23.6727 12.7129 23.7044 12.8442 23.7044 13C23.7044 13.1558 23.7362 13.2871 23.7758 13.2871C23.8154 13.2871 23.8709 13.4675 23.9026 13.6972C23.9344 13.9186 23.9899 14.1237 24.0295 14.1565C24.0691 14.1811 24.1008 14.3287 24.1008 14.4845C24.1008 14.6404 24.1405 14.7634 24.1801 14.7634C24.2277 14.7634 24.2594 14.8946 24.2594 15.0505C24.2594 15.2063 24.299 15.3375 24.3387 15.3375C24.3862 15.3375 24.418 15.4278 24.418 15.5344C24.418 15.6492 24.4497 15.7558 24.4893 15.7804C24.521 15.805 24.5765 16.0511 24.6082 16.3218C24.6399 16.5924 24.6954 16.8139 24.7351 16.8139C24.7826 16.8139 24.8144 16.9041 24.8144 17.0107C24.8144 17.1255 24.854 17.2404 24.8936 17.265C24.9412 17.2896 24.9729 17.4372 24.9729 17.5931C24.9729 17.7407 25.0205 17.8883 25.076 17.9047C25.1235 17.9293 24.6558 17.9539 24.0374 17.9539C22.9672 17.9621 22.8958 17.9703 22.8562 18.1262C22.8324 18.2164 22.7848 18.2902 22.7452 18.2902C22.7055 18.2902 22.6738 18.364 22.6738 18.4543C22.6738 18.5445 22.6421 18.6183 22.6025 18.6183C22.5708 18.6183 22.5153 18.8397 22.4836 19.1104C22.4518 19.3811 22.3963 19.6025 22.3567 19.6025C22.3091 19.6025 22.2774 19.7091 22.2774 19.8486C22.2774 19.9798 22.2457 20.0946 22.1981 20.0946C22.1585 20.0946 22.1189 20.1849 22.1189 20.2997C22.1189 20.4145 22.0872 20.5047 22.0396 20.5047C21.9999 20.5047 21.9603 20.5949 21.9603 20.7016C21.9603 20.8164 21.9286 20.923 21.889 20.9476C21.8493 20.9804 21.7938 21.1855 21.7621 21.4069C21.7304 21.6366 21.6749 21.817 21.6353 21.817C21.5956 21.817 21.5639 21.9401 21.5639 22.0959C21.5639 22.2517 21.5322 22.4076 21.4846 22.4322C21.445 22.4568 21.4054 22.5716 21.4054 22.6864C21.4054 22.7931 21.3736 22.8833 21.3261 22.8833C21.2864 22.8833 21.2468 22.9735 21.2468 23.0801C21.2468 23.1949 21.2151 23.3016 21.1754 23.3262C21.1437 23.3508 21.0882 23.5558 21.0565 23.7855C21.0248 24.0069 20.9693 24.1956 20.9297 24.1956C20.8821 24.1956 20.8504 24.3268 20.8504 24.4826C20.8504 24.6385 20.8187 24.7697 20.7711 24.7697C20.7315 24.7697 20.6918 24.8763 20.6918 25.0158C20.6918 25.147 20.6601 25.2618 20.6126 25.2618C20.5729 25.2618 20.5333 25.3274 20.5333 25.4177C20.5333 25.4997 20.4857 25.6637 20.4302 25.7703C20.3509 25.9344 20.3113 25.959 20.232 25.8688C20.1765 25.8113 20.1369 25.6883 20.1369 25.5981C20.1369 25.5079 20.1052 25.4095 20.0576 25.3849C20.018 25.3602 19.9783 25.2454 19.9783 25.1306C19.9783 25.024 19.9466 24.9337 19.907 24.9337C19.8673 24.9337 19.8118 24.7533 19.7801 24.5237C19.7484 24.3022 19.6929 24.0972 19.6533 24.0643C19.6136 24.0397 19.5819 23.8921 19.5819 23.7363C19.5819 23.5804 19.5502 23.4574 19.5027 23.4574C19.463 23.4574 19.4234 23.3672 19.4234 23.2524C19.4234 23.1375 19.3917 23.0473 19.3441 23.0473C19.3045 23.0473 19.2648 22.9325 19.2648 22.8013C19.2648 22.6618 19.2331 22.5552 19.1935 22.5552C19.1538 22.5552 19.0983 22.3748 19.0666 22.1451C19.0349 21.9237 18.9794 21.7186 18.9398 21.6858C18.9001 21.6612 18.8684 21.5546 18.8684 21.4397C18.8684 21.3331 18.8367 21.2429 18.7891 21.2429C18.7495 21.2429 18.7099 21.1117 18.7099 20.9558C18.7099 20.8 18.6782 20.6688 18.6306 20.6688C18.5909 20.6688 18.5513 20.5539 18.5513 20.4227C18.5513 20.2833 18.5196 20.1766 18.48 20.1766C18.4403 20.1766 18.3848 19.988 18.3531 19.7666C18.3214 19.5451 18.2659 19.3565 18.2263 19.3565C18.1866 19.3565 18.1549 19.2416 18.1549 19.1104C18.1549 18.971 18.1232 18.8643 18.0756 18.8643C18.036 18.8643 17.9964 18.7741 17.9964 18.6593C17.9964 18.5445 17.9646 18.4543 17.9171 18.4543C17.8774 18.4543 17.8378 18.3394 17.8378 18.2082V17.9621H15.5387V17.7571C15.5387 17.6423 15.5783 17.552 15.618 17.552C15.6656 17.552 15.6973 17.4208 15.6973 17.265C15.6973 17.1091 15.7369 16.9779 15.7765 16.9779C15.8241 16.9779 15.8558 16.8877 15.8558 16.7811C15.8558 16.6662 15.8955 16.5514 15.9351 16.5268C15.9827 16.5022 16.0144 16.3874 16.0144 16.2725C16.0144 16.1659 16.0461 16.0757 16.0857 16.0757C16.1174 16.0757 16.1729 15.8543 16.2047 15.5836C16.2364 15.3129 16.2919 15.0751 16.3315 15.0505C16.3791 15.0177 16.4108 14.87 16.4108 14.7142C16.4108 14.5584 16.4504 14.4353 16.4901 14.4353C16.5376 14.4353 16.5693 14.3041 16.5693 14.1483C16.5693 13.9924 16.609 13.8612 16.6486 13.8612C16.6962 13.8612 16.7279 13.771 16.7279 13.6643C16.7279 13.5495 16.7596 13.4429 16.8072 13.4101C16.8468 13.3855 16.9023 13.1476 16.934 12.877C16.9657 12.6063 17.0212 12.3849 17.0529 12.3849C17.0926 12.3849 17.1243 12.2946 17.1243 12.1798C17.1243 12.065 17.1639 11.9748 17.2036 11.9748C17.2511 11.9748 17.2828 11.8599 17.2828 11.7287C17.2828 11.5893 17.3225 11.4826 17.3621 11.4826C17.4097 11.4826 17.4414 11.3514 17.4414 11.1956C17.4414 11.0397 17.4731 10.9085 17.5207 10.9085C17.5603 10.9085 17.6158 10.6871 17.6475 10.4164C17.6792 10.1457 17.7347 9.89968 17.7664 9.87507C17.8061 9.85047 17.8378 9.70283 17.8378 9.547C17.8378 9.39116 17.8774 9.26813 17.9171 9.26813C17.9646 9.26813 17.9964 9.17791 17.9964 9.07129C17.9964 8.95646 18.036 8.84163 18.0756 8.81703C18.2025 8.73501 18.1708 8.52996 18.0281 8.52996C17.7902 8.52996 17.5603 8.91545 17.481 9.46498C17.4493 9.67003 17.3938 9.84226 17.3542 9.84226C17.3146 9.84226 17.2828 9.9899 17.2828 10.1703C17.2828 10.3508 17.2511 10.4984 17.2036 10.4984C17.1639 10.4984 17.1243 10.5886 17.1243 10.7035C17.1243 10.8183 17.0926 10.9085 17.045 10.9085C17.0054 10.9085 16.9657 11.0315 16.9657 11.1874C16.9657 11.3432 16.934 11.4908 16.8944 11.5155C16.8547 11.5401 16.7992 11.7615 16.7675 12.0158C16.7437 12.2618 16.6803 12.4833 16.6407 12.5079C16.601 12.5407 16.5693 12.6473 16.5693 12.7621C16.5693 12.8688 16.5376 12.959 16.4901 12.959C16.4504 12.959 16.4108 13.0656 16.4108 13.205C16.4108 13.3363 16.387 13.4511 16.3474 13.4511C16.3156 13.4511 16.2443 13.5741 16.1809 13.7136C16.0302 14.099 15.4991 14.5994 15.2612 14.5994C15.1502 14.5994 14.952 14.4927 14.8093 14.3533L14.5636 14.1072L14.6191 13.3445C14.6429 12.9344 14.7063 12.5735 14.7459 12.5653C14.7935 12.5489 14.8252 12.4095 14.8252 12.2536C14.8252 12.0978 14.8648 11.9748 14.9045 11.9748C14.952 11.9748 14.9838 11.9009 14.9838 11.8107C14.9838 11.7205 15.0234 11.6467 15.063 11.6467C15.1106 11.6467 15.1423 11.5565 15.1423 11.4498C15.1423 11.335 15.174 11.2284 15.2137 11.2038C15.2454 11.1792 15.3009 10.9331 15.3326 10.6625C15.3643 10.3918 15.4198 10.1703 15.4594 10.1703C15.507 10.1703 15.5387 10.0801 15.5387 9.96529C15.5387 9.85047 15.5783 9.76025 15.618 9.76025C15.6656 9.76025 15.6973 9.61261 15.6973 9.43217C15.6973 9.25173 15.7369 9.10409 15.7765 9.10409C15.8241 9.10409 15.8558 9.01387 15.8558 8.89905C15.8558 8.78422 15.8955 8.694 15.9351 8.694C15.9827 8.694 16.0144 8.60378 16.0144 8.49715C16.0144 8.38233 16.0461 8.2757 16.0857 8.2511C16.1174 8.22649 16.1729 8.02965 16.1967 7.8164C16.2205 7.60315 16.276 7.4145 16.3236 7.3981C16.3711 7.3817 16.4108 7.30788 16.4108 7.23406C16.4108 7.15204 16.5218 7.00441 16.6486 6.89779C16.7834 6.79116 16.8865 6.65993 16.8865 6.59432C16.8865 6.5287 16.9261 6.47949 16.9737 6.47949C17.0292 6.47949 17.1243 6.41387 17.1956 6.32365C17.267 6.24163 17.4414 6.14321 17.5841 6.11861C17.7189 6.0858 17.8378 6.02018 17.8378 5.97917C17.8378 5.93816 17.925 5.90536 18.0281 5.90536C18.1391 5.90536 18.25 5.86435 18.2738 5.82334C18.2976 5.77413 18.4086 5.74132 18.5196 5.74132C18.6227 5.74132 18.7099 5.70031 18.7099 5.6593C18.7099 5.61009 18.9318 5.57728 19.2252 5.57728Z"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalBus: React.FC<IProps> = (props: any) => {
  return (

    <FaBus
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalCabin: React.FC<IProps> = (props: any) => {
  return (

    <FaCouch
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalCircuit: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7143 0.050339C15.6092 0.32197 13.7021 1.75369 12.7797 3.76262C12.4968 4.38511 12.2591 5.38109 12.2138 6.09977C12.112 7.93894 12.9212 10.1459 14.7207 12.9245C15.5809 14.26 17.1315 16.2689 17.471 16.4953C18.3877 17.1065 19.3724 16.8971 20.159 15.9124C22.9319 12.4605 24.4938 9.54608 24.822 7.23723C25.0823 5.37543 24.3466 3.23634 22.9545 1.84989C21.5568 0.452126 19.6723 -0.192997 17.7143 0.050339ZM19.3271 4.22666C20.5438 4.68503 21.1267 6.09412 20.5834 7.25986C19.5931 9.37066 16.4977 8.8274 16.2883 6.50156C16.1411 4.88875 17.7936 3.64944 19.3271 4.22666Z"
        fill={color} />
      <path
        d="M7.98714 10.8532C7.67023 10.9494 7.41558 11.3229 7.48349 11.5945C7.54008 11.8095 8.34365 14.0731 8.41156 14.1976C8.48513 14.3447 8.79637 14.5315 8.95482 14.5315C9.02273 14.5315 9.6056 14.3391 10.2507 14.1071C11.06 13.8185 11.4731 13.6374 11.5806 13.5355C11.9371 13.196 11.8126 12.6697 11.3316 12.4716L11.0713 12.3641L10.2451 12.6584C9.79235 12.8225 9.40754 12.947 9.39622 12.9357C9.37924 12.9243 9.23211 12.5226 9.05668 12.0415C8.88125 11.5605 8.70017 11.1191 8.64358 11.0625C8.56435 10.972 8.22481 10.7852 8.16822 10.8022C8.15691 10.8022 8.07768 10.8305 7.98714 10.8532Z"
        fill={color} />
      <path
        d="M5.2932 11.8324C5.12909 11.9173 4.89707 12.2398 4.89707 12.3926C4.89707 12.4492 5.39506 13.864 6.00623 15.5334C6.61174 17.2027 7.08709 18.5835 7.06445 18.6062C7.04182 18.6288 5.77421 19.0985 4.25195 19.6531C2.72403 20.202 1.4168 20.683 1.33758 20.7283C1.25269 20.7679 1.14517 20.8528 1.08293 20.9207C0.952769 21.0678 0.907497 21.4753 1.0037 21.662C1.09424 21.8261 1.4168 22.0581 1.56394 22.0581C1.62619 22.0581 2.97302 21.5884 4.56885 21.0112C6.15902 20.434 7.49453 19.9643 7.52849 19.9643C7.5681 19.9643 8.15097 21.4866 8.85835 23.4276C9.54874 25.3347 10.1882 27.0946 10.2844 27.3323C10.4768 27.8416 10.6466 28.0001 11.0031 28.0001C11.2917 28.0001 11.6086 27.7454 11.6595 27.4738C11.6878 27.3266 11.303 26.2062 9.69021 21.7469C7.21724 14.9109 6.22127 12.1889 6.14204 12.0418C6.01188 11.7984 5.57614 11.6909 5.2932 11.8324Z"
        fill={color} />
      <path
        d="M11.2063 15.154C9.3785 15.8387 9.254 15.918 9.254 16.3367C9.254 16.4839 9.85951 18.2155 11.0705 21.526C12.0665 24.2649 12.921 26.5795 12.9663 26.67C13.1474 27.0605 13.6454 27.1567 13.9736 26.8624C14.3301 26.5512 14.3301 26.5398 13.5039 24.2536C13.0964 23.1218 12.7626 22.1711 12.7626 22.1372C12.7626 22.1032 14.2565 21.5317 16.09 20.8696C17.9179 20.2075 19.5307 19.6189 19.6722 19.5623L19.9381 19.4605L20.2324 20.2754C20.3965 20.7281 20.5833 21.1355 20.6512 21.2034C21.0247 21.5543 21.5679 21.4128 21.7547 20.9092C21.8169 20.7451 21.7433 20.4451 21.3755 19.4775L21.2001 19.0134L21.9697 18.7418C22.3941 18.589 22.8072 18.4136 22.8808 18.357C23.4467 17.9156 22.9827 17.0101 22.2866 17.2025C22.1678 17.2308 19.8815 18.0627 17.2105 19.0361C14.5338 20.0151 12.3268 20.8073 12.2929 20.796C12.1967 20.7677 10.7932 16.8291 10.8611 16.7838C10.9008 16.7612 11.444 16.5518 12.0778 16.3141C13.453 15.7991 13.5265 15.7652 13.668 15.5332C13.8038 15.3125 13.8095 15.1483 13.6906 14.8937C13.5775 14.656 13.3511 14.5315 13.0625 14.5372C12.938 14.5428 12.1401 14.8088 11.2063 15.154Z"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalCleanHealth: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.72222 0.0150435C7.3002 0.0524521 5.93921 0.319656 5.84953 0.378441C5.82315 0.399818 5.69127 0.447914 5.55939 0.490667C4.77867 0.725807 3.57065 1.43657 2.86905 2.06717C2.16746 2.70312 1.38673 3.69177 1.04912 4.36513C1.01204 4.434 0.971334 4.51204 0.937615 4.57669C0.913773 4.62241 0.893422 4.66143 0.880312 4.68577C0.780084 4.87282 0.553251 5.4286 0.489949 5.64771C0.453023 5.76528 0.394996 5.93095 0.35807 6.0218C0.321143 6.1073 0.252566 6.43329 0.20509 6.74325C0.162888 7.0532 0.0943108 7.40057 0.0573846 7.51814C-0.0164679 7.77466 -0.0217431 9.271 0.0573846 9.37254C0.0837605 9.40995 0.141787 9.65577 0.178714 9.92298C0.210365 10.1848 0.284217 10.5375 0.336969 10.6979C0.352242 10.7494 0.370244 10.8093 0.388868 10.8713L0.388891 10.8713L0.38891 10.8714C0.428169 11.002 0.470186 11.1417 0.495224 11.2323C0.632379 11.7239 0.838111 12.2851 0.980541 12.5576C1.05967 12.7126 1.12825 12.8622 1.12825 12.8889C1.12825 12.9157 1.2021 13.0439 1.2865 13.1722C1.37618 13.3058 1.44476 13.434 1.44476 13.4608C1.44476 13.4875 1.48168 13.557 1.52388 13.6104C1.57136 13.6692 1.72434 13.899 1.86677 14.1181C2.35209 14.8556 2.74245 15.3739 3.31217 16.0099C3.5179 16.2397 3.71836 16.4802 3.76056 16.5443C3.87134 16.71 5.92866 18.7674 5.98668 18.7674C6.01306 18.7674 6.03416 18.1796 6.03416 17.3887V16.0045L5.75458 15.716C5.37476 15.3258 4.61514 14.4601 4.42523 14.1982C4.33555 14.0807 4.1562 13.8455 4.01904 13.6745C3.87661 13.5035 3.76583 13.3432 3.76583 13.3165C3.76583 13.2898 3.72363 13.2256 3.66561 13.1722C3.61285 13.1187 3.52318 12.9905 3.47042 12.8889C3.46236 12.8748 3.45368 12.8596 3.44456 12.8435L3.44411 12.8428C3.38768 12.7436 3.31452 12.615 3.26469 12.5416C3.20139 12.4507 3.12754 12.3225 3.09061 12.2477C3.05896 12.1728 3.00621 12.0766 2.97456 12.0339C2.89543 11.9056 2.57364 11.1735 2.47342 10.8849C2.37319 10.5963 2.16218 9.73059 2.0725 9.25497C2.00392 8.89691 2.04085 7.47004 2.12525 7.26162C2.15691 7.17612 2.22021 6.94098 2.26241 6.7379C2.42594 5.93095 3.06424 4.77128 3.75001 4.03914C4.10345 3.66505 4.95802 2.94895 5.05298 2.94895C5.0688 2.94895 5.19541 2.87947 5.33256 2.79397C5.47499 2.70846 5.6438 2.62296 5.71765 2.60158C5.7915 2.5802 5.90756 2.52142 5.97613 2.47332C6.04471 2.43057 6.15021 2.38247 6.20297 2.37713C6.26099 2.36644 6.5142 2.30231 6.77268 2.2275C7.69057 1.96563 9.26784 1.9496 9.85866 2.20077C9.91669 2.22215 10.0908 2.27025 10.249 2.30231C10.6552 2.38782 11.5731 2.86879 12.1323 3.28562C12.6176 3.64368 12.9235 3.94829 13.4194 4.55217C13.5777 4.74456 13.7781 4.9797 13.8625 5.07055L14.0155 5.2469L14.1949 5.05986C14.2898 4.95832 14.3689 4.85144 14.3689 4.82472C14.3689 4.76059 15.5981 3.50473 15.7932 3.36579C15.82 3.34644 15.8571 3.32008 15.8991 3.29028C15.973 3.23775 16.0621 3.17451 16.1361 3.11996C16.2522 3.0398 16.4315 2.92757 16.5318 2.87947L16.5636 2.86251L16.5637 2.86248C16.6564 2.81308 16.7577 2.75912 16.7955 2.73518C17.0435 2.5802 17.6026 2.3611 17.8769 2.30231C18.051 2.27025 18.2989 2.20612 18.4308 2.16337C18.7315 2.06183 19.9554 2.01373 20.4881 2.0832C21.2108 2.17405 22.3978 2.55348 22.6562 2.77259C22.6984 2.81 22.7565 2.84206 22.7776 2.84206C22.8514 2.84206 23.4106 3.23218 23.7324 3.50473L23.7726 3.53946C23.946 3.68889 24.0311 3.7623 24.1109 3.84125C24.188 3.91748 24.26 3.99888 24.4017 4.15886L24.4234 4.18343C24.8138 4.63233 24.9193 4.76059 24.9193 4.80869C24.9193 4.83006 24.9826 4.94229 25.0617 5.05986C25.3941 5.55152 25.7053 6.35313 25.8952 7.19749C26.006 7.67846 26.0482 8.70987 25.9796 9.12137C25.8847 9.69853 25.8161 10.0245 25.7369 10.2971C25.7212 10.3508 25.7011 10.42 25.6797 10.4941C25.6434 10.619 25.6032 10.7576 25.5734 10.8582C25.4837 11.1628 25.3888 11.3926 25.1198 11.9644C24.8402 12.5576 23.8695 13.9631 23.3367 14.551C23.3279 14.561 23.3131 14.5778 23.2937 14.5999C23.2704 14.6263 23.2405 14.6602 23.206 14.6993C23.1313 14.784 23.0354 14.8927 22.9411 14.9999C22.767 15.2029 22.5613 15.4274 22.4822 15.4969L22.3345 15.6305V17.0413C22.3345 17.9017 22.3556 18.4468 22.3872 18.4468C22.4505 18.4468 23.9856 16.897 24.4973 16.3145C24.8349 15.9297 25.1145 15.577 25.7053 14.8128C25.9743 14.4655 26.1853 14.1662 26.1853 14.1395C26.1853 14.1234 26.2434 14.0326 26.3172 13.9364C26.3911 13.8402 26.4491 13.7333 26.4491 13.7066C26.4491 13.6745 26.486 13.6211 26.5282 13.5837C26.6601 13.4715 27.272 12.1354 27.4408 11.5796C27.8839 10.1314 27.9947 9.5008 28 8.45335C28 7.67312 27.8787 6.72722 27.7099 6.19815C27.6571 6.0218 27.6096 5.84544 27.6096 5.80803C27.6096 5.71184 27.2773 4.92626 27.0716 4.52545C26.8869 4.1674 26.3963 3.38716 26.2592 3.22684C25.8319 2.73518 25.4732 2.35041 25.2516 2.15268C25.1962 2.10459 25.133 2.04848 25.0749 1.99704C25.0169 1.9456 24.9641 1.89884 24.9298 1.86944C24.6555 1.61827 23.9592 1.17471 23.4106 0.896818C21.7331 0.0524522 19.9184 -0.19872 18.146 0.170022C17.724 0.255527 17.265 0.362409 17.1279 0.410506C16.6953 0.56014 15.9304 0.875441 15.846 0.944915C15.8038 0.976979 15.6614 1.06248 15.5295 1.12661C15.1022 1.33503 14.907 1.47398 14.3267 1.94426C14.1896 2.05648 14.0524 2.14733 14.0155 2.14733C13.9628 2.14733 13.4405 1.76256 13.1979 1.53811C13.1451 1.49001 13.0871 1.4526 13.066 1.4526C13.0501 1.4526 12.9605 1.39382 12.8708 1.32434C12.6703 1.17471 11.5573 0.624269 11.2144 0.512044C11.0772 0.469291 10.919 0.410506 10.8609 0.383785C10.8029 0.357065 10.4495 0.27156 10.0697 0.191398C9.31005 0.0364199 8.32886 -0.0330532 7.72222 0.0150435Z"
        fill={color} />
      <path
        d="M19.3223 3.32838C19.1324 3.5368 19.1324 3.67575 19.317 3.9002C19.4542 4.07121 19.4806 4.07655 19.9817 4.12465C20.7941 4.20481 21.29 4.38117 22.0338 4.86213C22.9938 5.48205 23.7165 6.64171 23.8642 7.81207C23.9328 8.36251 23.9117 8.88089 23.7798 9.53286C23.706 9.91229 23.706 9.96039 23.7851 10.1314C23.8695 10.3131 23.9856 10.3772 24.2388 10.3772C24.4498 10.3772 24.5975 10.1635 24.7452 9.65043C25.0142 8.70453 24.9087 7.42195 24.4709 6.36917C23.8695 4.92092 22.7512 3.9002 21.1686 3.3551C20.8521 3.24822 20.2877 3.16271 19.8393 3.16271C19.5017 3.16271 19.4647 3.1734 19.3223 3.32838Z"
        fill={color} />
      <path
        d="M12.8391 13.3165V11.927L14.1738 11.9377L15.5031 11.9537L15.5347 13.3165H20.9102V16.042H19.5966L19.565 24.833L19.4278 25.191C19.354 25.3888 19.259 25.5972 19.2168 25.6453C19.1746 25.6987 19.0691 25.843 18.99 25.9659C18.7843 26.2812 18.2462 26.6874 17.8717 26.8103C17.7028 26.8691 17.5446 26.9332 17.5288 26.9599C17.4866 27.0134 10.8768 27.0134 10.8398 26.9599C10.824 26.9332 10.671 26.8744 10.5075 26.821C9.83228 26.6072 9.20454 25.9445 8.9144 25.1322L8.77725 24.7475V16.042H7.4057V13.3165H12.8391ZM16.8588 21.9044C16.8694 20.6058 16.8694 18.7567 16.8588 17.7895L16.8483 16.042H11.4676V24.2718H16.8483L16.8588 21.9044Z"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalDistricts: React.FC<IProps> = (props: any) => {
  return (

    <GiPathDistance
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalFireman: React.FC<IProps> = (props: any) => {
  return (

    <BsFire
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalGuide: React.FC<IProps> = (props: any) => {
  return (

    <FaBook
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalJuvenile: React.FC<IProps> = (props: any) => {
  return (

    <FaChildren
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalLifeGuard: React.FC<IProps> = (props: any) => {
  return (

    <FaLifeRing
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalMaps: React.FC<IProps> = (props: any) => {
  return (

    <IoMdMap
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalMask: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 43 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.87214 0.0804218C5.65094 0.243942 5.07817 0.430823 3.99747 0.979785C3.16533 1.41195 2.83031 1.66891 2.2035 2.35803C1.28491 3.36251 0.571644 4.79916 0.182591 6.411C-0.0551634 7.42717 -0.0551634 7.43885 0.15017 8.04621C1.09038 10.9545 2.93838 13.8629 4.69992 15.2061C6.28856 16.4208 7.59621 16.888 9.72519 16.9814C12.1027 17.0866 13.4644 16.7829 18.2627 15.0893C19.6028 14.6221 20.8996 14.2016 21.1482 14.1549C21.6994 14.0614 22.8881 14.3885 25.5359 15.393C27.9242 16.2806 29.0481 16.6077 30.5827 16.853C32.0633 17.0866 34.1815 17.0165 35.1757 16.7245C36.0079 16.4792 37.2182 15.8718 37.9639 15.3346C39.5742 14.1782 41.4438 11.4334 42.5785 8.56013L43 7.48557L42.7298 6.32924C42.3192 4.5422 41.8328 3.59611 40.7413 2.41643C39.3688 0.921385 38.1909 0.349063 35.8782 0.0804218C32.8306 -0.281659 27.9999 0.886345 22.6504 3.28075L21.4832 3.80635L19.7649 3.05883C14.4695 0.769544 9.80084 -0.316699 6.87214 0.0804218ZM11.8542 6.91325C12.2324 7.00669 12.8592 7.24029 13.2591 7.43885C14.0696 7.83597 17.1928 9.91502 17.1172 10.0085C16.9875 10.1486 12.7728 10.8261 11.5948 10.8961C10.1142 10.9896 9.21726 10.8494 8.42835 10.4173C7.61782 9.96174 6.95859 9.03901 6.76407 8.06957C6.68842 7.70749 6.68842 7.70749 7.47733 7.38045C9.07677 6.73805 10.5573 6.5862 11.8542 6.91325ZM33.7168 6.91325C34.1058 7.01837 34.7434 7.22861 35.1541 7.39213C36.0187 7.75421 36.0403 7.85933 35.5432 8.93389C35.1649 9.76318 34.657 10.2537 33.8248 10.6158C32.863 11.0363 30.7232 10.9896 27.881 10.4873C26.6598 10.2771 25.6007 10.0785 25.5142 10.0552C25.3521 9.99678 27.7513 8.32653 28.9833 7.64909C30.5503 6.79645 32.2038 6.53948 33.7168 6.91325Z"
        fill={color} />
    </svg>

  );
};



export const IconCarnivalMedical: React.FC<IProps> = (props: any) => {
  return (

    <FaClinicMedical
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalMusic: React.FC<IProps> = (props: any) => {
  return (

    <BsFileMusicFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalPolice: React.FC<IProps> = (props: any) => {
  return (

    <GiPoliceOfficerHead
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalStreet: React.FC<IProps> = (props: any) => {
  return (

    <GiStreetLight
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalTaxi: React.FC<IProps> = (props: any) => {
  return (

    <BsFillTaxiFrontFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCarnivalTrio: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.1 0.0225811C6.81623 0.109856 4.41698 0.346741 3.94227 0.533754C2.99283 0.907785 2.37698 2.56598 2.22302 5.19666C2.15887 6.19407 2.08189 6.68031 1.97925 6.68031C1.87661 6.68031 1.85095 6.44342 1.88944 5.90731C1.95359 5.00964 1.79963 4.81016 0.978495 4.81016C-0.0222596 4.81016 0.0162309 4.72289 0.00340075 7.8024C-0.00942943 10.3832 0.00340075 10.5453 0.234344 10.67C0.606419 10.857 1.44038 10.8196 1.73548 10.6076C1.86378 10.5079 2.01774 10.4206 2.08189 10.4206C2.13321 10.4206 2.1717 11.7048 2.1717 13.2757C2.1717 15.7069 2.19736 16.1682 2.37698 16.3303C2.47963 16.4425 2.63359 16.5298 2.69774 16.5298C2.76189 16.5298 2.81321 16.7168 2.81321 16.9412C2.81321 17.2903 2.74906 17.39 2.40265 17.5396L1.97925 17.7142V21.5792C1.97925 25.3444 1.99208 25.4566 2.27434 25.9678C2.45397 26.3169 2.55661 26.7034 2.55661 27.1148C2.55661 27.9127 2.71057 28 4.18604 28C5.48189 28 5.63585 27.9127 5.63585 27.227V26.7532H12.5H19.3641V27.227C19.3641 27.9127 19.5181 28 20.814 28C22.2894 28 22.4434 27.9127 22.4434 27.1148C22.4434 26.7034 22.546 26.3169 22.7385 25.9678C23.0079 25.4566 23.0208 25.3444 23.0208 21.5792V17.7142L22.6102 17.5396C22.2509 17.39 22.1868 17.2903 22.1868 16.9412C22.1868 16.7168 22.2381 16.5298 22.3023 16.5298C22.3664 16.5298 22.5204 16.4425 22.623 16.3303C22.8026 16.1682 22.8283 15.7069 22.8283 13.2757C22.8283 11.7048 22.8668 10.4206 22.9309 10.4206C22.9823 10.4206 23.1362 10.5079 23.2645 10.6076C23.5596 10.8196 24.3936 10.857 24.7657 10.67C24.9966 10.5453 25.0094 10.3832 24.9966 7.8024C24.9838 4.72289 25.0223 4.81016 24.0215 4.81016C23.2004 4.81016 23.0464 5.00964 23.1106 5.90731C23.1491 6.44342 23.1234 6.68031 23.0208 6.68031C22.9181 6.68031 22.8411 6.19407 22.777 5.19666C22.6872 3.51353 22.3407 2.02987 21.866 1.24441C21.4555 0.558691 20.9166 0.371675 18.9792 0.197128C17.414 0.0724525 10.9347 -0.0522251 9.1 0.0225811ZM21.8917 3.90002C22.097 4.19925 22.1226 4.63561 22.1611 7.50317L22.2124 10.7697L21.9174 10.9692C21.6479 11.1437 20.6857 11.1687 12.5 11.1687C4.31434 11.1687 3.35208 11.1437 3.08264 10.9692L2.78755 10.7697L2.83887 7.50317C2.87736 4.63561 2.90302 4.19925 3.10831 3.90002L3.32642 3.5634H12.5H21.6736L21.8917 3.90002ZM5.9951 17.39C6.1234 17.4648 6.20038 18.1131 6.29019 19.6591C6.44415 22.1651 6.45698 22.1402 5.27661 22.1402C4.07057 22.1402 4.09623 22.2025 4.09623 19.7339C4.09623 18.2254 4.14755 17.5272 4.25019 17.4274C4.42981 17.2529 5.73849 17.2279 5.9951 17.39ZM20.7498 17.4274C20.8524 17.5272 20.9038 18.2254 20.9038 19.7339C20.9038 22.2025 20.9294 22.1402 19.7234 22.1402C18.543 22.1402 18.5558 22.1651 18.697 19.6591C18.7868 18.0757 18.8638 17.4648 18.9921 17.39C19.2615 17.2279 20.5702 17.2529 20.7498 17.4274ZM17.9272 18.3625L17.9657 18.6493H12.5128C7.30378 18.6493 7.04717 18.6368 7.04717 18.4248C7.04717 18.3002 7.08566 18.1506 7.13698 18.1131C7.1883 18.0633 9.62604 18.0383 12.5513 18.0508L17.8887 18.0882L17.9272 18.3625ZM17.8887 19.4597C17.8887 19.709 17.786 19.709 12.577 19.7464C9.3566 19.7589 7.20113 19.7215 7.13698 19.6591C7.07283 19.5968 7.04717 19.4472 7.08566 19.3474C7.16264 19.1604 7.74 19.148 12.5257 19.1729C17.786 19.2103 17.8887 19.2103 17.8887 19.4597ZM17.863 20.4695C17.9015 20.5069 17.9015 20.6191 17.863 20.7189C17.7604 20.9807 7.23962 20.9807 7.13698 20.7189C7.09849 20.6191 7.09849 20.5069 7.13698 20.4695C7.23962 20.3698 17.7604 20.3698 17.863 20.4695ZM17.7989 21.7288L17.8374 22.0155H12.5128C7.41925 22.0155 7.17547 22.0031 7.17547 21.7911C7.17547 21.6664 7.21396 21.5168 7.26529 21.4794C7.31661 21.4295 9.69019 21.4046 12.5513 21.4171L17.7604 21.4545L17.7989 21.7288Z"
        fill={color} />
    </svg>

  );
};



export const IconChat: React.FC<IProps> = (props: any) => {
  return (

    <BsFillChatFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCheck: React.FC<IProps> = (props: any) => {
  return (

    <MdCheck
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCheckBoxOn: React.FC<IProps> = (props: any) => {
  return (

    <RiCheckboxFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCheckBoxOff: React.FC<IProps> = (props: any) => {
  return (

    <RiCheckboxBlankLine
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCheckAll: React.FC<IProps> = (props: any) => {
  return (

    <BsCheckAll
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCheckedCircle: React.FC<IProps> = (props: any) => {
  return (

    <HiCheckCircle
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconClose: React.FC<IProps> = (props: any) => {
  return (

    <MdClose
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCompanyManageOn: React.FC<IProps> = (props: any) => {
  return (

    <LiaUserTieSolid
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCompanyManageOff: React.FC<IProps> = (props: any) => {
  return (

    <LiaUserAltSlashSolid
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCopy: React.FC<IProps> = (props: any) => {
  return (

    <FaCopy
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCoupon: React.FC<IProps> = (props: any) => {
  return (

    <AiFillTag
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconCreditCard: React.FC<IProps> = (props: any) => {
  return (

    <BsCreditCardFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// export const IconDashboard: React.FC<IProps> = (props: any) => {
//   return (

//     <Icon
//       style={props.style}
//       type={'material-community'}
//       name={Platform.select({ android: 'view-dashboard', ios: 'view-dashboard-outline' })}
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



export const IconDollar: React.FC<IProps> = (props: any) => {
  return (

    <BiDollar
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconDrawer: React.FC<IProps> = (props: any) => {
  return (

    <HiOutlineMenu
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconEdit: React.FC<IProps> = (props: any) => {
  return (

    <RiEditBoxFill
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};

export const IconMapDirection: React.FC<IProps> = (props: any) => {
  return (

    <FaDirections
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};

export const IconMicrophone: React.FC<IProps> = (props: any) => {
  return (

    <FaMicrophoneAlt
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};


export const IconEyeOn: React.FC<IProps> = (props: any) => {
  return (

    <IoMdEye
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconEyeOff: React.FC<IProps> = (props: any) => {
  return (

    <IoMdEyeOff
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconDelete: React.FC<IProps> = (props: any) => {
  return (

    <FaTrash
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconDelivery: React.FC<IProps> = (props: any) => {
  return (

    <MdDeliveryDining
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconEmail: React.FC<IProps> = (props: any) => {
  return (

    <MdEmail
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconEvents: React.FC<IProps> = (props: any) => {
  return (

    <MdEvent
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};


export const IconCalendarStart: React.FC<IProps> = (props: any) => {
  return (

    <MdEvent
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconEventEnd: React.FC<IProps> = (props: any) => {
  return (

    <MdEvent
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconExclamation: React.FC<IProps> = (props: any) => {
  return (

    <FaExclamation
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconExit: React.FC<IProps> = (props: any) => {
  return (

    <BiExit
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconFavoriteOn: React.FC<IProps> = (props: any) => {
  return (

    <MdFavorite
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconFavoriteOff: React.FC<IProps> = (props: any) => {
  return (

    <MdOutlineFavoriteBorder
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconFlag: React.FC<IProps> = (props: any) => {
  return (

    <IoFlag
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconFlashOn: React.FC<IProps> = (props: any) => {
  return (

    <MdOutlineFlashOn
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconFlashOff: React.FC<IProps> = (props: any) => {
  return (

    <MdOutlineFlashOff
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconForks: React.FC<IProps> = (props: any) => {
  return (

    <GiForkKnifeSpoon
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};


export const IconGallery: React.FC<IProps> = (props: any) => {
  return (
    <FaImages
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />
  );
};



export const IconHelp: React.FC<IProps> = (props: any) => {
  return (

    <MdOutlineHelp
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconHome: React.FC<IProps> = (props: any) => {
  return (

    <IoHomeSharp
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconInformation: React.FC<IProps> = (props: any) => {
  return (

    <IoMdInformationCircle
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconItemAlcoholNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M453 160.333V133.667C467.725 133.667 479.667 121.725 479.667 107C479.667 92.2747 467.725 80.3333 453 80.3333V53.6667C453 38.9413 441.059 27 426.333 27H373C358.275 27 346.333 38.9413 346.333 53.6667V80.3333C331.608 80.3333 319.667 92.2747 319.667 107C319.667 121.725 331.608 133.667 346.333 133.667V160.333C346.333 198.467 313 239.4 279.667 280.333C246.333 321.267 213 362.2 213 400.333V499.218L480.127 227.843C464.209 204.102 453 181.209 453 160.333ZM556.415 328.719L467.62 418.925C506.763 442.157 533 484.848 533 533.667C533 607.304 473.304 667 399.667 667C351.6 667 309.474 641.565 286.013 603.421L213 677.595V720.333C213 749.789 236.877 773.667 266.333 773.667H533C561.363 771.187 583.853 748.696 586.333 720.333V400.333C586.333 378.257 573.798 353.924 556.415 328.719Z"
        fill={color} />
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
    </svg>

  );
};



export const IconItemAlcoholYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M453 133.667V160.333C453 196.333 486.333 238.333 519.667 280.333C553 322.333 586.333 364.333 586.333 400.333V720.333C583.853 748.696 561.363 771.187 533 773.667H266.333C236.877 773.667 213 749.789 213 720.333V400.333C213 362.2 246.333 321.267 279.667 280.333C313 239.4 346.333 198.467 346.333 160.333V133.667C331.608 133.667 319.667 121.725 319.667 107C319.667 92.2747 331.608 80.3333 346.333 80.3333V53.6667C346.333 38.9413 358.275 27 373 27H426.333C441.059 27 453 38.9413 453 53.6667V80.3333C467.725 80.3333 479.667 92.2747 479.667 107C479.667 121.725 467.725 133.667 453 133.667ZM266.333 533.667C266.333 607.304 326.029 667 399.667 667C473.304 667 533 607.304 533 533.667C533 460.029 473.304 400.333 399.667 400.333C326.029 400.333 266.333 460.029 266.333 533.667Z"
        fill={color} />
    </svg>

  );
};



export const IconItemSpicyNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M558.828 147.891C552.805 110.472 532.718 84.9693 514.953 71.7023C513.95 70.968 512.803 70.4541 511.587 70.1945C510.371 69.9348 509.114 69.9352 507.898 70.1956C506.683 70.456 505.536 70.9706 504.533 71.7055C503.53 72.4405 502.694 73.3792 502.08 74.4601L484.219 105.457C483.198 107.253 482.835 109.348 483.191 111.383C483.548 113.418 484.603 115.265 486.174 116.606C496.421 125.693 514.297 149.151 505.211 194.031C483.775 190.754 461.894 191.941 440.938 197.516C411.117 205.464 385.849 221.939 366.044 243.245L450.663 257.776L558.828 147.891Z"
        fill={color} />
      <path
        d="M420.526 288.392L363.991 278.687C352.576 303.031 346.253 335.193 340.196 369.999L420.526 288.392Z"
        fill={color} />
      <path
        d="M175.262 715.933L518.166 367.576L566.965 354.571L617.365 385.104C590.506 492.043 457.093 667.76 230.62 728.115C214.802 732.33 197.957 730.089 183.791 721.884C180.765 720.132 177.915 718.139 175.262 715.933Z"
        fill={color} />
      <path
        d="M566.877 318.091L617.835 266.322C628.593 282.138 636.62 299.686 641.545 318.235C645.428 332.805 646.671 347.315 646.781 361.682L572.399 316.619L566.877 318.091Z"
        fill={color} />
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
    </svg>

  );
};



export const IconItemSpicyYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M452.514 385.072L427.048 289.512L363.991 278.687C321.457 369.396 349.62 568.638 198.829 608.824C183.011 613.04 169.515 623.367 161.311 637.533C153.107 651.7 150.866 668.545 155.082 684.364C159.298 700.183 169.625 713.68 183.791 721.884C197.957 730.089 214.802 732.33 230.62 728.115C457.093 667.76 590.506 492.043 617.365 385.104L566.965 354.571L452.514 385.072ZM555.695 211.138C572.961 138.274 541.385 91.4428 514.953 71.7023C513.95 70.968 512.803 70.4541 511.587 70.1945C510.371 69.9348 509.114 69.9352 507.898 70.1956C506.683 70.456 505.536 70.9706 504.533 71.7055C503.53 72.4405 502.694 73.3792 502.08 74.4601L484.219 105.457C483.198 107.253 482.834 109.348 483.191 111.383C483.548 113.418 484.603 115.265 486.174 116.606C496.421 125.693 514.297 149.151 505.211 194.031C483.775 190.754 461.894 191.941 440.938 197.516C411.117 205.464 385.849 221.939 366.044 243.245L455.305 258.573L477.513 341.906L572.399 316.619L646.781 361.682C646.671 347.315 645.428 332.805 641.544 318.235C635.479 295.39 624.71 274.064 609.927 255.622C595.143 237.18 576.672 222.028 555.695 211.138Z"
        fill={color} />
    </svg>

  );
};



export const IconItemVegetarianNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M494.748 212.989C472.869 218.1 453.973 227.098 439.027 239.775C429.905 247.475 414.548 265.706 408.171 276.245L403.242 284.695L409.027 297.652C409.282 298.221 409.53 298.775 409.771 299.317L494.748 212.989Z"
        fill={color} />
      <path
        d="M393.349 316C365.258 230.195 286.704 161.841 192.706 144.693C168.123 140.304 134.196 139.908 108.978 143.996C90.8356 146.802 57.4301 155.101 52.8717 157.807C40.5792 165.125 40.6649 173.703 53.0664 208.722C80.4269 285.616 131.93 342.893 199.449 371.457L214.567 377.845L285.124 373.611C307.43 372.272 327.413 370.883 340.356 369.837L350.19 359.847C343.811 351.094 333.319 337.847 327.21 331.173C297.672 299.042 260.948 273.494 201.023 242.758C195.125 239.822 190.661 236.942 191.063 236.489C193.876 233.316 247.454 251.272 274.286 264.539C312.126 282.975 341.032 302.509 376.388 333.232L393.349 316Z"
        fill={color} />
      <path
        d="M317.381 393.176C178.794 401.625 156.976 403.413 153.974 405.086C151.77 406.506 148.512 409.42 146.93 411.66C144.15 415.404 143.968 417.131 144.866 432.098C146.44 458.325 154.831 490.867 166.223 516.219C169.336 523.118 172.725 529.86 176.373 536.428L317.381 393.176Z"
        fill={color} />
      <path
        d="M260.784 629.051C282.811 644.026 306.998 655.588 332.535 663.023C371.272 674.432 384.497 675.497 447.97 672.403C518.587 669.166 541.239 665.232 577.689 650.456C679.496 609.154 746.28 506.296 742.418 396.663C741.768 378.678 740.12 375.057 730.43 370.918C726.119 368.949 711.759 369.504 504.032 381.935L260.784 629.051Z"
        fill={color} />
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
    </svg>

  );
};



export const IconItemVegetarianYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M108.978 143.996C90.8353 146.802 57.4298 155.101 52.8715 157.807C40.579 165.125 40.6646 173.703 53.0662 208.722C80.4266 285.616 131.93 342.893 199.449 371.457L214.567 377.845L285.124 373.611C323.895 371.284 355.647 368.806 355.613 368.236C355.484 366.098 336.395 341.208 327.209 331.173C297.672 299.042 260.947 273.494 201.023 242.758C195.125 239.822 190.66 236.942 191.062 236.489C193.876 233.316 247.454 251.272 274.286 264.539C312.453 283.134 341.531 302.847 377.307 334.031L402.975 356.524L400.478 343.513C381.553 245.084 296.555 163.638 192.706 144.693C168.123 140.304 134.196 139.908 108.978 143.996Z"
        fill={color} />
      <path
        d="M510.913 209.997C482.114 214.014 457.54 224.072 439.027 239.775C429.905 247.475 414.548 265.706 408.171 276.245L403.242 284.695L409.027 297.652C415.963 313.115 417.705 318.303 420.867 332.848C422.09 338.926 423.529 343.846 423.957 343.82C427.521 343.606 466.795 313.926 496.626 288.961C506.569 280.64 515.047 274.122 515.492 274.382C516.399 275.186 458.141 341.34 444.908 354.436L434.782 364.486L470.283 362.498L505.775 360.368L512.101 356.126C538.938 338.493 563.11 307.43 577.189 272.682C583.794 256.406 590.616 231.821 590.222 225.264C589.923 220.275 584.161 212.467 579.32 210.469C571.258 207.233 533.331 206.935 510.913 209.997Z"
        fill={color} />
      <path
        d="M153.974 405.085C151.77 406.505 148.511 409.419 146.929 411.66C144.15 415.403 143.967 417.13 144.866 432.097C146.44 458.324 154.83 490.866 166.222 516.218C198.398 587.53 260.027 641.911 332.535 663.022C371.272 674.431 384.496 675.497 447.969 672.402C518.586 669.165 541.239 665.231 577.689 650.455C679.496 609.153 746.279 506.295 742.418 396.662C741.767 378.677 740.119 375.056 730.43 370.917C725.723 368.768 709.037 369.626 441.775 385.667C190.62 400.74 157.711 403.001 153.974 405.085Z"
        fill={color} />
    </svg>

  );
};



export const IconItemVeganNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
      <path
        d="M177.6 119C176.2 120.6 175 122.2 175 122.5C175 122.8 174.5 123.6 174 124.3C170.8 128.1 164 138.2 164 139C164 139.6 163.6 140 163.1 140C162.6 140 162 140.8 161.6 141.7C161.3 142.7 160.1 144.8 159 146.5C157.9 148.1 156.7 150.2 156.4 151C156 151.8 154.7 153.8 153.5 155.5C152.3 157.1 151 159.2 150.7 160C150.3 160.8 148.6 163.7 147 166.5C145.4 169.2 143 173.5 141.8 176C140.5 178.5 138.9 181.1 138.3 181.8C137.6 182.5 137 183.8 137 184.6C137 185.4 136.6 186 136 186C135.5 186 135 186.5 135 187.1C135 187.7 132.5 193.4 129.4 199.8C126.3 206.3 122.5 214.2 121 217.5C114 232.9 113 235.1 113 235.8C113 236.9 106.3 253 105.6 253.7C105.3 254.1 105 255.2 105 256.3C105 257.3 104.4 259.6 103.6 261.3C102.9 263.1 101.5 267.2 100.5 270.5C99.4999 273.8 98.3999 277.4 97.8999 278.5C95.9999 283.5 93.9999 290.5 93.9999 292.5C93.9999 293.6 93.5999 295 93.0999 295.6C92.3999 296.4 89.5999 307.5 86.9999 320C86.4999 322.5 85.5999 327 84.8999 330C83.2999 337.8 81.1999 355.1 78.9999 377.5C77.6999 391.4 77.6999 416.8 78.9999 425.7C79.4999 429.5 80.3999 436.3 80.8999 441C81.4999 445.7 82.3999 451.5 82.8999 454C84.4999 461.1 86.5999 469.4 87.1999 471C87.5999 471.8 88.7999 475.3 89.8999 478.8C91.0999 482.2 92.3999 485.8 92.8999 486.8C93.3999 487.7 94.5999 490.3 95.4999 492.5C98.0999 498.6 104.6 511.4 107.5 516C108.9 518.2 110 520.4 110 521C110 521.5 110.3 522 110.8 522C111.2 522 112.6 523.8 114 526C115.3 528.2 116.8 530 117.2 530C117.6 530 118 530.5 118 531.1C118 532.2 122.5 538.3 126.7 543C128 544.4 129 545.8 129 546.1C129 546.5 130.9 548.8 133.3 551.3C135.6 553.7 139.4 557.8 141.6 560.4C143.9 562.9 146.4 565 147.2 565C147.9 565 164.6 548.6 184.3 528.5L220.2 492L219 488.3C218.4 486.2 217.5 483.6 217 482.5C215.1 477.8 208.6 457 207.4 451.5C207 449.8 206.4 448 206 447.5C205.6 446.9 205 445.1 204.7 443.5C204.5 441.8 203.1 436 201.6 430.5C200.2 425 199 419.5 199 418.3C199 417.1 198.6 415.8 198 415.5C197.5 415.2 197 413.9 197 412.8C197 411.6 196.4 407.9 195.6 404.6C193 393 191 381.6 188.4 362.5C185.2 339.7 182.9 296 184.8 296C185.6 296 186 298.3 186 302.7C186 306.5 186.4 311.1 187 313C187.5 314.9 188.4 319.9 188.9 324C189.5 328.1 190.7 335.1 191.5 339.5C192.4 343.9 193.5 349.8 193.9 352.7C194.4 355.5 195.1 358.4 195.5 358.9C195.8 359.5 196.5 362.1 197 364.8C198.4 372.2 200 379.3 200.9 381.5C201.4 382.6 202.4 386 203.3 389C207.1 402 211.4 415.6 212 417C212.4 417.8 213.6 421.2 214.6 424.5C215.6 427.8 216.7 430.9 217 431.5C217.4 432 218.5 434.7 219.5 437.5C220.4 440.2 221.8 443.8 222.5 445.5C223.2 447.1 225.2 452.1 227 456.5C229.6 462.9 234.6 474.2 235.6 475.8C235.7 476 254.4 457.3 277.1 434.3C299.8 411.3 331.6 379.2 347.8 362.9L377.1 333.3L375.8 330.4C375.1 328.8 374.3 327.3 374 327C373.7 326.7 372.6 324.9 371.6 323C370.5 321.1 369.2 319 368.8 318.5C366.5 315.8 354 296.6 354 295.9C354 295.4 353.6 295 353.2 295C352.8 295 350 291.6 347 287.3C344 283.1 341 279.2 340.5 278.6C339.9 278 338.3 275.9 337 274C335.6 272.1 333.8 269.6 332.9 268.5C327.4 261.9 322.3 255.8 318.2 251.1C315.6 248.1 312.6 244.5 311.5 243.1C310.4 241.7 308.1 239 306.3 237.1C304.5 235.2 303 233.3 303 232.8C303 232.4 302.3 232 301.5 232C300.7 232 300 231.5 300 230.9C300 229.9 296.6 226.1 284.8 213.7C281 209.9 278 206.6 278 206.4C278 205.5 234.3 163.1 224 154C220.6 151 215.9 146.7 213.6 144.5C211.3 142.3 206.2 137.8 202.4 134.5C198.6 131.2 193.9 127.1 192 125.3C190.1 123.5 186.7 120.7 184.4 119.1L180.3 116L177.6 119Z"
        fill={color} />
      <path
        d="M532.9 356.7C529.6 357.1 525.5 360.9 490.8 395.8C435.9 451.1 426.2 461.3 425.6 464C425.3 465.4 424.6 468.7 424.1 471.5C422 482 421 486.1 420 487.9C419.5 489 419 490.8 419 491.9C419 493.1 418.6 494.8 418.1 495.8C417.6 496.7 416.2 500.4 414.9 504C413.7 507.6 412.3 510.9 411.8 511.4C409.7 513.9 413.4 515.2 415.7 512.9C416.3 512.3 417.7 511.3 418.8 510.6C420.4 509.7 435.1 500.7 446 494C446.8 493.5 449.5 492 452 490.8C454.5 489.5 456.7 488.3 457 488C458.1 486.9 483.7 473.9 495 468.7C506.5 463.4 508.8 462.4 518 458.9C522.7 457.1 526.9 455.3 527.4 454.8C528 454.4 529.4 454 530.6 454C531.9 454 533.1 453.6 533.4 453.1C533.7 452.6 535.7 451.9 537.7 451.5C539.8 451.1 542 450.5 542.5 450.1C544.3 448.9 564.6 442.9 580 439C581.9 438.6 586.3 437.4 589.7 436.6C593.2 435.7 597.7 435 599.7 435H603.5L600.5 436.4C598.9 437.1 592.8 439.2 587 441C581.2 442.8 576.1 444.6 575.5 445C575 445.4 573.3 446 571.7 446.4C570.2 446.8 566.4 448.2 563.2 449.6C556.4 452.6 554.9 453.2 549 455.5C546.5 456.4 543.8 457.6 543 458.1C542.2 458.6 540.8 459.3 540 459.6C536.9 460.8 527.3 465.6 520.6 469.2C516.8 471.3 513.1 473 512.4 473C511.6 473 511 473.4 511 473.9C511 474.4 510 475.2 508.8 475.6C506.6 476.2 488.9 487.1 471.5 498.3C457.1 507.6 431 527.1 430.2 529.1C430 529.6 429.2 530 428.5 530C427.8 530 427 530.3 426.8 530.7C426.7 531.2 423.8 533.7 420.5 536.5C400.9 552.8 362 591 362 593.9C362 594.2 364 595.4 366.5 596.5C369 597.6 371 598.8 371 599.2C371 599.7 371.5 600 372 600C372.6 600 375.8 601.3 379.3 602.9C391.1 608.4 398.5 611.7 402 613C403.9 613.7 406.9 614.9 408.7 615.6C410.4 616.4 412.5 617 413.3 617C414.2 617 415.1 617.4 415.4 617.9C415.7 618.4 417.6 619.1 419.6 619.5C421.6 619.8 424 620.5 424.9 620.9C427.1 622.1 433.8 624.2 438 625.1C439.9 625.5 444.2 626.6 447.5 627.5C457.8 630.3 472.2 632.9 490 635C501.4 636.4 537.6 635.9 540.5 634.3C541.6 633.7 545.2 632.4 548.5 631.5C551.8 630.6 558.2 628 562.8 625.9C567.4 623.8 571.3 622 571.6 622C571.9 622 574.7 620.3 577.8 618.3C580.9 616.2 584 614.3 584.5 614C586.2 613.2 594.4 607.6 595.6 606.5C596.2 606 598.1 604.4 599.9 603C605.9 598.5 616.4 589.6 622.4 584C633.7 573.5 655 551.7 655 550.6C655 550.3 656.7 548.4 658.9 546.3C661 544.2 664.7 540 667.1 537C673.2 529.5 675.2 527 677 525C677.8 524.1 680.1 521.4 682 518.9C683.9 516.5 685.8 514.3 686.2 514.2C686.6 514 687 513.4 687 512.9C687 512.3 688.3 510.5 690 508.7C691.6 506.9 693 505 693 504.3C693 503.7 693.3 503 693.8 502.8C695 502.3 701 494.3 701 493.2C701 492.6 701.4 492 701.8 491.8C702.3 491.6 705.5 487.7 708.9 483C712.2 478.3 715.5 474 716 473.3C716.6 472.6 717 471.8 717 471.5C717 471.2 717.4 470.4 718 469.7C721.5 465.4 726 458.8 726 458C726 457.4 726.5 457 727 457C727.6 457 728 456.4 728 455.6C728 454.8 728.3 454 728.8 453.8C729.4 453.5 733.7 447.5 736.5 442.8C737 441.9 741.8 434.2 747.1 425.8C760.3 404.7 759.7 406 757 403.8C755.8 402.8 754.2 402 753.4 402C752.6 402 752 401.5 752 401C752 400.4 751.3 400 750.5 400C749.7 400 748.2 399.6 747.2 399C746.3 398.5 743.3 397.1 740.5 395.9C737.8 394.7 733 392.7 730 391.3C727 389.9 723.1 388.2 721.3 387.4C719.6 386.6 717.3 386 716.1 386C714.9 386 714 385.7 714 385.2C714 384.4 708.1 382.2 703.8 381.3C702.2 381 701 380.4 701 379.9C701 379.4 700.4 379 699.6 379C698.4 379 684.3 374.9 675 371.8C673.1 371.2 669.9 370.3 668 369.9C666.1 369.5 661.6 368.4 658 367.5C651 365.8 647 364.9 637.5 363C634.2 362.4 629.5 361.4 627 360.9C621.3 359.8 608.3 358.1 595.5 357C585.8 356.1 540.2 355.9 532.9 356.7Z"
        fill={color} />
      <path
        d="M349.4 538.8C325.7 562.8 305.1 583.9 303.6 585.7L300.9 588.9L304.7 594.2C309.3 600.6 309.2 600.5 313.2 605.6C318.6 612.2 321.9 616.4 323.3 618.4C324.1 619.5 325.4 620.1 326.2 619.8C327 619.5 331.3 614.1 335.8 607.8C340.2 601.6 344.3 596 344.7 595.4C346.1 593.5 348 590.5 348.7 589C349.1 588.2 349.6 587.3 349.9 587C350.9 586.1 353 582.6 353.6 580.7C354 579.8 354.6 579 355.1 579C355.6 579 356 578.4 356 577.6C356 576.8 356.6 575.5 357.3 574.8C357.9 574.1 359.4 571.7 360.5 569.5C361.6 567.3 362.8 565.3 363.1 565C363.4 564.7 367.6 556.4 372.4 546.5C377.2 536.6 381.8 527.2 382.5 525.7C383.3 524.1 384 522 384 521C384 520 384.4 519 384.8 518.8C385.8 518.4 392 502 392 499.8C392 498.9 392.5 497.8 393 497.5C394.2 496.8 394.4 495 393.3 495.1C392.8 495.1 373.1 514.8 349.4 538.8Z"
        fill={color} />
      <path
        d="M265.2 624.3C259.1 630.5 254 636 254 636.5C254 637.1 256 638.3 258.3 639.3C260.6 640.4 263.9 641.8 265.5 642.5C267.2 643.2 270.5 644.6 273 645.5C275.5 646.5 278.4 647.6 279.5 648.1C284.4 650.2 295.9 654 297.4 654C300.5 654 300.3 649.6 297.1 644.8C295.4 642.3 294 639.7 294 639.1C294 638.5 293.7 638 293.3 638C292.8 638 289.1 632.3 285 625.5C280.9 618.7 277.3 613 277 613C276.7 613 271.4 618.1 265.2 624.3Z"
        fill={color} />
    </svg>

  );
};



export const IconItemVeganYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M177.6 119C176.2 120.6 175 122.2 175 122.5C175 122.8 174.5 123.6 174 124.3C170.8 128.1 164 138.2 164 139C164 139.6 163.6 140 163.1 140C162.6 140 162 140.8 161.6 141.7C161.3 142.7 160.1 144.8 159 146.5C157.9 148.1 156.7 150.2 156.4 151C156 151.8 154.7 153.8 153.5 155.5C152.3 157.1 151 159.2 150.7 160C150.3 160.8 148.6 163.7 147 166.5C145.4 169.2 143 173.5 141.8 176C140.5 178.5 138.9 181.1 138.3 181.8C137.6 182.5 137 183.8 137 184.6C137 185.4 136.6 186 136 186C135.5 186 135 186.5 135 187.1C135 187.7 132.5 193.4 129.4 199.8C126.3 206.3 122.5 214.2 121 217.5C114 232.9 113 235.1 113 235.8C113 236.9 106.3 253 105.6 253.7C105.3 254.1 105 255.2 105 256.3C105 257.3 104.4 259.6 103.6 261.3C102.9 263.1 101.5 267.2 100.5 270.5C99.4999 273.8 98.3999 277.4 97.8999 278.5C95.9999 283.5 93.9999 290.5 93.9999 292.5C93.9999 293.6 93.5999 295 93.0999 295.6C92.3999 296.4 89.5999 307.5 86.9999 320C86.4999 322.5 85.5999 327 84.8999 330C83.2999 337.8 81.1999 355.1 78.9999 377.5C77.6999 391.4 77.6999 416.8 78.9999 425.7C79.4999 429.5 80.3999 436.3 80.8999 441C81.4999 445.7 82.3999 451.5 82.8999 454C84.4999 461.1 86.5999 469.4 87.1999 471C87.5999 471.8 88.7999 475.3 89.8999 478.8C91.0999 482.2 92.3999 485.8 92.8999 486.8C93.3999 487.7 94.5999 490.3 95.4999 492.5C98.0999 498.6 104.6 511.4 107.5 516C108.9 518.2 110 520.4 110 521C110 521.5 110.3 522 110.8 522C111.2 522 112.6 523.8 114 526C115.3 528.2 116.8 530 117.2 530C117.6 530 118 530.5 118 531.1C118 532.2 122.5 538.3 126.7 543C128 544.4 129 545.8 129 546.1C129 547.2 146.4 565.4 154.6 573C161.9 579.7 180.8 595 181.8 595C182.3 595 183.4 595.7 184.1 596.6C184.9 597.5 187.3 599.4 189.5 600.8C191.7 602.2 194.1 603.9 194.8 604.7C195.5 605.4 196.7 606 197.5 606C198.2 606 199 606.4 199.2 606.8C199.9 608.6 228.1 625 230.4 625C231.3 625 232 625.4 232 625.8C232 626.7 239.9 630.8 254.5 637.5C265.4 642.5 267.8 643.5 273 645.5C275.5 646.5 278.4 647.6 279.5 648.1C284.4 650.2 295.9 654 297.4 654C300.5 654 300.3 649.6 297.1 644.8C295.4 642.3 294 639.8 294 639.2C294 638.6 293.6 638 293.2 637.8C292.1 637.4 278 614.5 278 613.2C278 612.6 277.6 612 277.2 611.8C276.2 611.4 271.7 603.7 267 594.5C265.1 590.6 263.3 587.3 263 587C261.1 585.1 245 552.1 245 550.2C245 549.5 244.6 549 244 549C243.5 549 243 548.5 243 548C243 547.4 241.6 543.9 239.9 540.2C238.2 536.5 236.3 532.4 235.8 531C234.7 528.3 233.1 524.5 230.6 518.8C229.7 516.8 229 514.6 229 513.8C229 513 228.6 512 228.1 511.5C227.6 510.9 225.1 504.6 222.5 497.5C219.9 490.3 217.4 483.6 217 482.5C214.9 477.3 208.6 456.8 207.4 451.5C207 449.8 206.4 448 206 447.5C205.6 446.9 205 445.1 204.7 443.5C204.5 441.8 203.1 436 201.6 430.5C200.2 425 199 419.5 199 418.3C199 417.1 198.6 415.8 198 415.5C197.5 415.2 197 413.9 197 412.8C197 411.6 196.4 407.9 195.6 404.6C193 393 191 381.6 188.4 362.5C185.2 339.7 182.9 296 184.8 296C185.6 296 186 298.3 186 302.7C186 306.5 186.4 311.1 187 313C187.5 314.9 188.4 319.9 188.9 324C189.5 328.1 190.7 335.1 191.5 339.5C192.4 343.9 193.5 349.8 193.9 352.7C194.4 355.5 195.1 358.4 195.5 358.9C195.8 359.5 196.5 362.1 197 364.8C198.4 372.2 200 379.3 200.9 381.5C201.4 382.6 202.4 386 203.3 389C207.1 402 211.4 415.6 212 417C212.4 417.8 213.6 421.2 214.6 424.5C215.6 427.8 216.7 430.9 217 431.5C217.4 432 218.5 434.7 219.5 437.5C220.4 440.2 221.8 443.8 222.5 445.5C223.2 447.1 225.2 452.1 227 456.5C232.8 470.9 255.3 517.2 259.5 523.4C260.7 525.1 261.9 527.2 262.3 528C262.6 528.8 264.3 531.7 265.9 534.5C267.5 537.2 269.8 541.2 270.9 543.2C272.8 546.7 281.3 560 289.9 573C291.9 576 293.8 578.6 294.3 578.8C294.7 579 295 579.6 295 580.1C295 580.7 295.5 581.6 296 582.3C296.9 583.4 303.9 593 308.8 599.9C309.7 601.2 311.9 603.9 313.5 605.9C317.8 611.2 321.7 616.2 323.3 618.4C324.1 619.5 325.4 620.1 326.2 619.8C327 619.5 331.3 614.1 335.8 607.8C340.2 601.6 344.3 596 344.7 595.4C346.1 593.5 348 590.5 348.7 589C349.1 588.2 349.6 587.3 349.9 587C350.9 586.1 353 582.6 353.6 580.8C354 579.8 354.6 579 355.1 579C355.6 579 356 578.4 356 577.6C356 576.8 356.6 575.5 357.3 574.8C357.9 574.1 359.4 571.7 360.5 569.5C361.6 567.3 362.8 565.3 363.1 565C363.4 564.7 367.6 556.4 372.4 546.5C377.2 536.6 381.8 527.2 382.5 525.7C383.3 524.1 384 522 384 521C384 520 384.4 519 384.8 518.8C385.7 518.5 392 502.1 392 500.2C392 499.5 392.4 498.2 392.9 497.2C393.5 496.3 394.6 492.8 395.5 489.5C396.4 486.2 397.8 481.7 398.6 479.5C399.4 477.2 400 474.4 400 473.2C400 471.9 400.4 470.1 401 469.1C401.5 468.1 402.4 464.6 402.9 461.4C407 438.5 408 431.8 408 426.3C408 418.8 405.3 399.2 404 396.8C403.4 395.8 403 394.2 403 393.3C403 391.3 396.9 371.8 396 371C395.7 370.7 394.6 368.2 393.5 365.5C392.5 362.7 390 357.1 387.8 353C385.7 348.9 384 344.9 384 344.2C384 343.6 383.6 343 383.2 343C382.8 343 381.7 341.5 380.9 339.7C379.1 335.8 374.7 327.7 374 327C373.7 326.7 372.6 324.9 371.6 323C370.5 321.1 369.2 319 368.8 318.5C366.5 315.8 354 296.6 354 295.9C354 295.4 353.6 295 353.2 295C352.8 295 350 291.6 347 287.3C344 283.1 341 279.2 340.5 278.6C339.9 278 338.3 275.9 337 274C335.6 272.1 333.8 269.6 332.9 268.5C327.4 261.9 322.3 255.8 318.2 251.1C315.6 248.1 312.6 244.5 311.5 243.1C310.4 241.7 308.1 239 306.3 237.1C304.5 235.2 303 233.3 303 232.8C303 232.4 302.3 232 301.5 232C300.7 232 300 231.5 300 230.9C300 229.9 296.6 226.1 284.8 213.7C281 209.9 278 206.6 278 206.4C278 205.5 234.3 163.1 224 154C220.6 151 215.9 146.7 213.6 144.5C211.3 142.3 206.2 137.8 202.4 134.5C198.6 131.2 193.9 127.1 192 125.3C190.1 123.5 186.7 120.7 184.4 119.1L180.3 116L177.6 119Z"
        fill={color} />
      <path
        d="M529.5 357C517 358.2 503.5 360.2 501.8 361.1C500.9 361.6 498.8 362 497.2 362C494.4 362 490.8 362.9 478.5 366.7C469.8 369.3 457.8 374.2 450 378.3C445.9 380.5 441.5 382.8 440.3 383.4C439 384 438 384.8 438 385.2C438 385.7 437.5 386 437 386C436.4 386 435.1 386.8 434.1 387.7C432.5 389.3 432.2 391.8 431.6 406C430.7 430.9 428.5 451.2 424.6 469.5C421.4 484.5 421 486.1 420 487.9C419.5 489 419 490.8 419 491.9C419 493.1 418.6 494.8 418.1 495.8C417.6 496.7 416.2 500.4 414.9 504C413.7 507.6 412.3 510.9 411.8 511.4C409.7 513.9 413.4 515.2 415.7 512.9C416.3 512.3 417.7 511.3 418.8 510.6C420.4 509.7 435.1 500.7 446 494C446.8 493.5 449.5 492 452 490.8C454.5 489.5 456.7 488.3 457 488C458.1 486.9 483.7 473.9 495 468.7C506.5 463.4 508.8 462.4 518 458.9C522.7 457.1 526.9 455.3 527.4 454.8C528 454.4 529.4 454 530.6 454C531.9 454 533.1 453.6 533.4 453.1C533.7 452.6 535.7 451.9 537.7 451.5C539.8 451.1 542 450.5 542.5 450.1C544.3 448.9 564.6 442.9 580 439C581.9 438.6 586.3 437.4 589.7 436.6C593.2 435.7 597.7 435 599.7 435H603.5L600.5 436.4C598.9 437.1 592.8 439.2 587 441C581.2 442.8 576.1 444.6 575.5 445C575 445.4 573.3 446 571.7 446.4C570.2 446.8 566.4 448.2 563.2 449.6C556.4 452.6 554.9 453.2 549 455.5C546.5 456.4 543.8 457.6 543 458.1C542.2 458.6 540.8 459.3 540 459.6C536.9 460.8 527.3 465.6 520.6 469.2C516.8 471.3 513.1 473 512.4 473C511.6 473 511 473.4 511 473.9C511 474.4 510 475.2 508.8 475.6C506.6 476.2 488.9 487.1 471.5 498.3C457.1 507.6 431 527.1 430.2 529.1C430 529.6 429.2 530 428.5 530C427.8 530 427 530.3 426.8 530.7C426.7 531.2 423.8 533.7 420.5 536.5C400.9 552.8 362 591 362 593.9C362 594.2 364 595.4 366.5 596.5C369 597.6 371 598.8 371 599.2C371 599.7 371.5 600 372 600C372.6 600 375.8 601.3 379.3 602.9C391.1 608.4 398.5 611.7 402 613C403.9 613.7 406.9 614.9 408.7 615.6C410.4 616.4 412.5 617 413.3 617C414.2 617 415.1 617.4 415.4 617.9C415.7 618.4 417.6 619.1 419.6 619.5C421.6 619.8 424 620.5 424.9 620.9C427.1 622.1 433.8 624.2 438 625.1C439.9 625.5 444.2 626.6 447.5 627.5C457.8 630.3 472.2 632.9 490 635C501.4 636.4 537.6 635.9 540.5 634.3C541.6 633.7 545.2 632.4 548.5 631.5C551.8 630.6 558.2 628 562.8 625.9C567.4 623.8 571.3 622 571.6 622C571.9 622 574.7 620.3 577.8 618.3C580.9 616.2 584 614.3 584.5 614C586.2 613.2 594.4 607.6 595.6 606.5C596.2 606 598.1 604.4 599.9 603C605.9 598.5 616.4 589.6 622.4 584C633.7 573.5 655 551.7 655 550.6C655 550.3 656.7 548.4 658.9 546.3C661 544.2 664.7 540 667.1 537C673.2 529.5 675.2 527 677 525C677.8 524.1 680.1 521.4 682 518.9C683.9 516.5 685.8 514.3 686.2 514.2C686.6 514 687 513.4 687 512.9C687 512.3 688.3 510.5 690 508.7C691.6 506.9 693 505 693 504.3C693 503.7 693.3 503 693.8 502.8C695 502.3 701 494.3 701 493.2C701 492.6 701.4 492 701.8 491.8C702.3 491.6 705.5 487.7 708.9 483C712.2 478.3 715.5 474 716 473.3C716.6 472.6 717 471.8 717 471.5C717 471.2 717.4 470.4 718 469.7C721.5 465.4 726 458.8 726 458C726 457.4 726.5 457 727 457C727.6 457 728 456.4 728 455.6C728 454.8 728.3 454 728.8 453.8C729.4 453.5 733.7 447.5 736.5 442.8C737 441.9 741.8 434.2 747.1 425.8C760.3 404.7 759.7 406 757 403.8C755.8 402.8 754.2 402 753.4 402C752.6 402 752 401.5 752 401C752 400.4 751.3 400 750.5 400C749.7 400 748.2 399.6 747.2 399C746.3 398.5 743.3 397.1 740.5 395.9C737.8 394.7 733 392.7 730 391.3C727 389.9 723.1 388.2 721.3 387.4C719.6 386.6 717.3 386 716.1 386C714.9 386 714 385.7 714 385.2C714 384.4 708.1 382.2 703.8 381.3C702.2 381 701 380.4 701 379.9C701 379.4 700.4 379 699.6 379C698.4 379 684.3 374.9 675 371.8C673.1 371.2 669.9 370.3 668 369.9C666.1 369.5 661.6 368.4 658 367.5C651 365.8 647 364.9 637.5 363C634.2 362.4 629.5 361.4 627 360.9C621.3 359.8 608.3 358.1 595.5 357C584.1 356 540.1 356 529.5 357Z"
        fill={color} />
    </svg>

  );
};



export const IconItemOrganicNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M533.472 173.65C531.238 160.685 527.17 147.968 519.629 135.738C512.255 122.574 503.853 111.376 493.252 101.979C450.384 63.9786 400.779 55.811 348.446 74.9664C298.137 93.3812 269.984 131.937 262.316 185.612C259.885 202.632 260.49 219.577 261.095 236.517C261.413 245.446 261.732 254.374 261.606 263.31C261.5 270.811 264.602 277.208 273.317 276.862C281.298 276.544 285.036 271.761 284.884 263.267C284.835 260.517 284.781 257.767 284.726 255.015L284.726 254.994C284.391 238.128 284.056 221.235 284.981 204.425C288.423 141.88 326.416 101.147 382.534 91.8707C447.805 81.0809 506.071 130.727 512.433 195.023L533.472 173.65ZM480.829 227.129C465.266 229.264 450.054 233.104 435.633 240.164C360.497 276.951 318.404 335.352 301.283 409.531L480.829 227.129ZM263.979 447.427C265.78 430.226 269.022 413.19 273.607 396.271C294.634 318.689 341.664 260.454 412.218 221.576C412.352 221.501 412.488 221.428 412.622 221.355C414.774 220.189 416.829 219.076 415.354 214.83C406.378 214.83 397.381 214.831 388.368 214.832H388.326C361.923 214.835 335.383 214.838 308.842 214.815C302.447 214.809 301.159 218.761 301.173 224.063C301.176 225.235 301.18 226.407 301.183 227.579V227.58V227.581V227.586C301.218 239.621 301.253 251.657 301.096 263.69C300.891 279.431 289.663 292.362 275.292 293.716C263.258 294.849 250.193 283.716 246.322 269.588C243.494 259.263 243.791 248.82 244.089 238.383V238.383V238.382C244.215 233.959 244.341 229.536 244.229 225.124C244.035 217.462 241.262 214.352 233.612 214.655L232.746 214.689C224.102 215.033 215.377 215.38 206.808 214.526C194.399 213.291 190.982 218.099 191.009 230.35C191.223 327.333 191.305 424.317 191.262 521.301L263.979 447.427ZM191.042 699.902L285.482 603.96C295.673 632.142 309.214 658.92 326.707 684.345C327.202 685.065 327.687 685.801 328.175 686.542C330.698 690.375 333.291 694.316 337.805 696.649C338.154 696.5 338.548 696.382 338.944 696.263C339.8 696.007 340.666 695.747 341.11 695.164C371.288 655.499 410.661 626.286 450.04 597.069L450.04 597.069C454.709 593.605 459.378 590.141 464.032 586.659C472.366 580.424 480.621 574.086 489.056 567.609L489.073 567.596C494.067 563.763 499.122 559.881 504.294 555.944C541.811 527.545 577.035 498.046 603.079 458.744C607.493 463.023 607.267 466.841 607.062 470.294V470.294V470.295C607.02 471.008 606.978 471.706 606.979 472.389C607.009 498.899 607.002 525.409 606.994 551.919C606.978 608.074 606.962 664.228 607.305 720.381C607.382 732.955 603.248 736.036 591.234 736C463.073 735.616 334.91 735.603 206.749 735.999C194.306 736.038 190.974 732.078 191 719.943C191.015 713.263 191.029 706.582 191.042 699.902ZM307.42 581.674L343.135 545.391C343.363 547.31 344.154 549.234 346.167 551.037C349.476 546.056 351.536 540.706 353.123 535.243L595.615 288.896C607.804 318.561 613.34 349.736 606.157 383.653C599.065 417.142 579.627 443.795 555.998 467.908C526.79 497.714 492.873 521.284 458.954 544.855C446.118 553.775 433.282 562.695 420.701 571.953C419.798 572.618 418.894 573.282 417.99 573.947C417.384 574.392 416.779 574.837 416.173 575.282C389.582 594.816 362.988 614.352 341.901 640.287C340.883 641.539 339.557 642.542 337.93 643.773L337.929 643.773L337.928 643.774C337.068 644.424 336.124 645.139 335.095 645.988C327.365 636.691 323.33 625.871 319.378 615.276L319.377 615.274L319.376 615.272C318.525 612.988 317.677 610.715 316.797 608.47C313.322 599.607 310.19 590.674 307.42 581.674Z"
        fill={color} />
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
    </svg>

  );
};



export const IconItemOrganicYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M504.294 555.944C541.811 527.545 577.035 498.046 603.079 458.745C608.406 463.908 606.974 468.401 606.979 472.39C607.073 555.054 606.801 637.72 607.305 720.381C607.382 732.956 603.248 736.036 591.234 736C463.073 735.617 334.91 735.604 206.749 736C194.306 736.038 190.974 732.078 191 719.943C191.356 556.746 191.369 393.547 191.009 230.35C190.982 218.099 194.399 213.291 206.808 214.527C215.663 215.409 224.685 215.009 233.612 214.655C241.262 214.352 244.035 217.462 244.229 225.125C244.606 239.946 242.295 254.887 246.322 269.588C250.193 283.717 263.258 294.85 275.292 293.716C289.663 292.362 300.891 279.431 301.096 263.69C301.268 250.483 301.21 237.272 301.173 224.064C301.159 218.761 302.447 214.809 308.842 214.815C344.457 214.847 380.072 214.83 415.354 214.83C416.921 219.343 414.503 220.317 412.218 221.576C341.664 260.454 294.634 318.689 273.607 396.271C262.061 438.874 259.036 482.211 266.078 527.09C275.082 584.463 293.977 636.775 326.707 684.345C329.767 688.793 332.419 693.865 337.805 696.65C338.907 696.178 340.461 696.017 341.11 695.165C374.867 650.796 420.128 619.506 464.032 586.659C477.304 576.73 490.378 566.537 504.294 555.944Z"
        fill={color} />
      <path
        d="M519.628 135.738C536.339 162.837 535.997 192.327 536.422 221.617C536.5 227.032 532.159 229.425 527.822 231.67C462.185 265.641 416.111 318.029 385.117 384.501C362.314 433.406 348.518 484.802 343.619 538.55C343.269 542.388 341.675 547.015 346.167 551.037C354.017 539.221 354.836 525.33 359 512.776C389.066 422.138 440.892 346.326 511.818 283.072C527.096 269.447 542.919 256.653 559.679 244.929C566.384 240.24 570.26 240.609 574.785 248.165C599.851 290.02 616.697 333.885 606.157 383.653C599.065 417.142 579.627 443.795 555.998 467.908C515.737 508.993 466.528 538.23 420.701 571.953C392.619 592.618 364.185 612.88 341.901 640.287C340.344 642.202 338.07 643.532 335.095 645.988C325.698 634.686 321.761 621.133 316.796 608.47C298.262 561.19 289.457 511.907 293.481 461.237C301.334 362.364 343.806 285.123 435.633 240.164C455.787 230.297 477.488 226.719 499.533 225.297C509.371 224.663 512.606 220.307 512.935 210.868C515.438 139.142 453.078 80.2092 382.533 91.8707C326.416 101.147 288.423 141.88 284.981 204.425C283.905 223.984 284.534 243.656 284.884 263.267C285.036 271.761 281.297 276.544 273.317 276.862C264.601 277.208 261.5 270.811 261.606 263.31C261.971 237.421 258.603 211.602 262.316 185.612C269.984 131.937 298.137 93.3812 348.446 74.9664C400.779 55.811 450.383 63.9786 493.252 101.979C503.853 111.376 512.255 122.574 519.628 135.738Z"
        fill={color} />
    </svg>

  );
};



export const IconItemLactoseNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M314.6 21.6002C307.6 23.8002 299.7 31.9002 297.6 39.0002C295.6 45.8002 295.5 62.0002 297.4 68.4002C300.2 77.6002 308.2 85.0002 317.6 87.1002C320.6 87.8002 323 88.5002 323 88.7002C323 90.4002 310.6 120.1 305.5 130.5C297.2 147.5 289.1 160 266.7 190.8C247.1 217.9 230.3 244.3 225.8 255.3C219.9 269.8 220 268.4 220.2 385.1L220.5 491.7L338 372.7C402.6 307.2 455.6 253.1 455.8 252.5C455.9 251.9 448.8 241.5 439.9 229.6C426.1 211 423.7 207.1 423.2 203.4C422.3 195.5 424.7 191.7 434.6 185.1C440.6 181.2 447 180.9 452 184.2C453.8 185.5 461.7 195.1 469.5 205.6L483.7 224.8L504.9 203.6C516.5 192 526 182.1 526 181.7C526 181.3 522.4 175.9 518.1 169.7C502.5 147.6 493.3 130.3 482.6 103.3C479.5 95.5002 477 88.9002 477 88.7002C477 88.5002 479.4 87.8002 482.4 87.1002C491.8 85.0002 499.8 77.6002 502.6 68.4002C504.5 62.0002 504.4 45.8002 502.4 39.0002C500.2 31.6002 492.4 23.8002 485 21.6002C477.2 19.3002 322.2 19.3002 314.6 21.6002Z"
        fill={color} />
      <path
        d="M695.7 71.5002C693 72.2002 689 74.1002 686.7 75.6002C684.4 77.1002 546.4 214.7 380 381.3C168.5 593.1 76.6 685.8 74.5 689.4C71.7 694.1 71.5 695.2 71.5 704C71.5 713.4 71.6 713.7 75 718.5C82.3 728.6 95 731.3 107.8 725.5C113.8 722.8 131.2 705.6 418.1 418.2C747.3 88.4002 726.6 109.8 727.7 97.3002C728.5 88.5002 726.7 83.6002 720.6 77.5002C716.4 73.2002 714.4 72.0002 710.1 71.1002C703.8 69.8002 701.9 69.8002 695.7 71.5002Z"
        fill={color} />
      <path
        d="M551.8 333.9L524 362V525.1C524 673.5 523.9 688.5 522.4 691.6C519.7 697.2 515.6 699.4 507.4 699.8C499 700.3 494.2 698.5 490.7 693.6L488.5 690.5L488 544.8L487.5 399L353.7 534.8L219.8 670.5L220.3 692C220.6 708.4 221.1 715.1 222.5 720C230.2 748.1 251.6 769.6 280.1 777.7C286.1 779.4 293.1 779.5 400.5 779.5H514.5L522 777.2C548.8 768.8 568 749.8 577.2 722.5L579.5 715.5L579.8 546C579.9 452.8 579.9 360.6 579.8 341.1L579.5 305.8L551.8 333.9Z"
        fill={color} />
    </svg>

  );
};



export const IconItemLactoseYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M314.6 21.5999C307.6 23.7999 299.7 31.8999 297.6 38.9999C295.6 45.7999 295.5 61.9999 297.4 68.3999C300.2 77.5999 308.2 84.9999 317.6 87.0999C320.6 87.7999 323 88.4999 323 88.6999C323 90.3999 310.6 120.1 305.5 130.5C297.2 147.5 289.1 160 266.7 190.8C247.1 217.9 230.3 244.3 225.8 255.3C219.6 270.4 219.9 257.4 220.2 496C220.5 705.1 220.6 713.8 222.4 720C230.6 748.6 251.6 769.6 280.1 777.7C286.1 779.4 293.1 779.5 400.5 779.5H514.5L522 777.2C549.1 768.7 568.7 749.1 577.2 722L579.5 714.5V492.5V270.5L577.2 263C574.4 254.3 570.7 246.7 564.5 237.1C562 233.3 560 229.9 560 229.6C560 228.5 546.9 209.6 531.8 188.8C511.3 160.7 502.5 146.9 494.5 130.5C489.4 120.1 477 90.3999 477 88.6999C477 88.4999 479.4 87.7999 482.4 87.0999C491.8 84.9999 499.8 77.5999 502.6 68.3999C504.5 61.9999 504.4 45.7999 502.4 38.9999C500.2 31.5999 492.4 23.7999 485 21.5999C477.2 19.2999 322.2 19.2999 314.6 21.5999ZM452 184.2C455.2 186.4 520.4 273.3 522.8 278.6C523.7 280.4 524 333 524 484.6C524 710.1 524.5 692.3 517.6 697.3C515 699.2 513.2 699.5 506 699.5C498.8 699.5 497 699.2 494.4 697.3C487.5 692.3 488 709.4 488 491.3V294.4L455.9 251.1C427.7 213 423.7 207.2 423.2 203.4C422.3 195.5 424.7 191.7 434.6 185.1C440.6 181.2 447 180.9 452 184.2Z"
        fill={color} />
    </svg>

  );
};



export const IconItemGlutenNo: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M389.4 68.3999C383.4 70.2999 376.5 75.3999 373.2 80.2999C367.2 89.2999 367.5 85.1999 367 153.9L366.5 217.2L359.5 211.4C336.9 192.8 301.3 175.9 274.4 170.9L267.2 169.6L266.6 164.5C265.5 155 263.1 149.9 256.6 143.4C249.2 136 243 133.5 232.5 133.6C219.8 133.8 209.4 140.3 203.8 151.8L200.5 158.5V306.5C200.5 470.6 200.1 459.4 207.1 486.1C211.2 501.4 211.1 501.3 215.7 496.9C217.8 494.9 230.1 483.5 243 471.5L266.5 449.7L267 427L267.5 404.3L275 406.7C280.8 408.6 295.1 414.9 300.1 417.7C300.6 418 350 372.6 350.3 371.5C350.7 370.3 331.8 358.9 320.5 353.4C307.8 347.3 290 341 278.5 338.5C274.1 337.6 269.7 336.6 268.8 336.3C267.1 335.9 267 332.7 267 286.9V237.8L270.3 238.5C275.5 239.6 291.3 246.4 299.3 250.9C321.7 263.8 341 284.1 352.6 307.3C358.8 319.5 364.7 339.8 366.2 354.2C366.5 356.7 377.2 347 479.7 251.8C586.1 153 592.9 146.5 591.6 144.6C589.6 141.6 581.4 136.2 576.7 134.8C570.5 133.1 561.2 133.3 555 135.5C550.9 136.8 547.9 138.9 543.4 143.4C536.9 150 534.5 155 533.3 164.7C532.8 169.2 532.4 170 530.6 170C527.7 170 510.2 174.5 501 177.6C482.4 183.9 457.5 197.8 440.5 211.5L433.5 217.1L433 153.8L432.5 90.4999L430.1 85.4999C426.9 79.1999 420.8 73.0999 414.5 69.9999C408.5 67.0999 395.9 66.2999 389.4 68.3999Z"
        fill={color} />
      <path
        d="M724.8 85.2799C722.8 85.9799 719.8 87.4799 718.2 88.4799C709.9 93.6799 137.6 620.78 87.3 669.48C78 678.48 77 680.78 77 692.98C77 699.98 77.3 701.08 80.3 705.48C86.1 714.28 97.8 717.98 109.2 714.88C117.5 712.58 112.4 717.18 481 377.38C724.8 152.78 752.5 126.68 756.4 118.48C758.7 113.58 758.5 102.78 756.1 98.0799C753 92.0799 746.5 86.2799 741.5 84.9799C735.8 83.5799 729.4 83.6799 724.8 85.2799Z"
        fill={color} />
      <path
        d="M549 369.2C521.2 395 496.9 417.7 495 419.6L491.5 423.2L497.4 419.5C504.8 414.8 514.1 410.6 524.9 406.9L533.2 404.1L532.7 428.8C532.4 446.5 531.8 455.5 530.6 460.5C521.2 501.4 494.7 535.4 458.4 553.1C450.2 557.1 436.8 562 434.2 562C432.9 562 432.8 559 433.3 540.2C433.6 527.1 434.5 514.9 435.5 509.5C438.5 492.5 445.8 474.8 455.9 459.5C458.4 455.6 460.9 451.9 461.4 451.1C461.9 450.3 440.8 469.6 414.6 494L367 538.2V550.1C367 559.7 366.7 562 365.6 562C364.8 562 360.4 560.7 355.9 559.1L347.6 556.2L328.6 573.8C318.1 583.5 306.4 594.5 302.6 598.1L295.7 604.6L310.1 611.8C326.3 619.8 340.5 624.9 356 628.4L366.5 630.7L367 670.1C367.5 709.4 367.5 709.5 369.9 714.5C373.1 720.8 379.1 726.9 385.5 730C389.8 732.1 391.9 732.5 400 732.5C408.1 732.5 410.3 732.1 414.5 730.1C420.8 726.9 426.9 720.9 430 714.5L432.5 709.5L433 670.1L433.5 630.7L444 628.4C527.9 609.7 590.4 538.7 599 452.5C599.7 445.5 600 420 599.8 381.9L599.5 322.3L549 369.2Z"
        fill={color} />
    </svg>

  );
};



export const IconItemGlutenYes: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;
  const color = props.color || Colors.attention;


  return (

    <svg width={size} height={size} viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M433.333 100C433.333 81.591 418.41 66.667 400 66.667C381.59 66.667 366.667 81.591 366.667 100V217.593C339.127 192.945 304.719 175.816 266.667 169.432V166.667C266.667 148.258 251.743 133.334 233.333 133.334C214.924 133.334 200 148.258 200 166.667V233.334V333.334V400V433.334C200 532.434 272.076 614.7 366.667 630.567V700C366.667 718.41 381.59 733.334 400 733.334C418.41 733.334 433.333 718.41 433.333 700V630.567C527.923 614.7 600 532.434 600 433.334V400V333.334V233.334V166.667C600 148.258 585.077 133.334 566.667 133.334C548.257 133.334 533.333 148.258 533.333 166.667V169.432C495.28 175.816 460.873 192.945 433.333 217.593V100ZM533.333 336.1V237.534C475.827 252.336 433.333 304.539 433.333 366.667V384.26C460.873 359.614 495.28 342.484 533.333 336.1ZM433.333 533.334V562.467C490.84 547.664 533.333 495.46 533.333 433.334V404.2C475.827 419.004 433.333 471.207 433.333 533.334ZM366.667 562.467V533.334C366.667 471.207 324.174 419.004 266.667 404.2V433.334C266.667 495.46 309.159 547.664 366.667 562.467ZM266.667 336.1C304.719 342.484 339.127 359.614 366.667 384.26V366.667C366.667 304.539 324.174 252.336 266.667 237.534V336.1Z"
        fill={color} />
    </svg>

  );
};


export const IconKey: React.FC<IProps> = (props: any) => {
  return (

    <MdVpnKey
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconKids: React.FC<IProps> = (props: any) => {
  return (

    <GiKidSlide
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconList: React.FC<IProps> = (props: any) => {
  return (

    <RiListCheck
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconLock: React.FC<IProps> = (props: any) => {
  return (

    <IoMdLock
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMap: React.FC<IProps> = (props: any) => {
  return (

    <IoMdGlobe
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMapLocation: React.FC<IProps> = (props: any) => {
  return (

    <MdMyLocation
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// export const IconMapMarker: React.FC<IProps> = (props: any) => {
//   return (

//     <MapMarkerStyle
//       style={props.style}
//       resizeMode={'contain'}
//       source={Platform.select({
//         android: Images.cyanMarkerMD,
//         ios: Images.cyanMarkerIOS,
//       })}
//     />

//   );
// };



export const IconMapPin: React.FC<IProps> = (props: any) => {
  return (

    <IoLocationSharp
      style={props.style}
      size={props.size}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMathMinus: React.FC<IProps> = (props: any) => {
  return (

    <FaMinus
      style={props.style}
      size={props.size}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMathPlus: React.FC<IProps> = (props: any) => {
  return (

    <FaPlus
      style={props.style}
      size={props.size}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMore: React.FC<IProps> = (props: any) => {
  return (

    <FiMoreHorizontal
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconMoreHorizontal: React.FC<IProps> = (props: any) => {
  return (

    <MdMoreHoriz
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconNotifications: React.FC<IProps> = (props: any) => {
  return (

    <MdNotifications
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconOrderBag: React.FC<IProps> = (props: any) => {
  return (

    <FaShoppingBag
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconOrderMenu: React.FC<IProps> = (props: any) => {
  return (

    <MdList
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconOrderSheet: React.FC<IProps> = (props: any) => {
  return (

    <MdFastfood
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// export const IconOrderCart: React.FC<IProps> = (props: any) => {
//   return (

//     <Icon
//       style={props.style}
//       type={'zocial'}
//       name={'cart'}
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



export const IconParking: React.FC<IProps> = (props: any) => {
  return (

    <FaParking
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconPerson: React.FC<IProps> = (props: any) => {
  return (

    <IoPersonCircle
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconProfile: React.FC<IProps> = (props: any) => {
  return (

    <MdFace
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconProfileDisable: React.FC<IProps> = (props: any) => {
  return (

    <FaMinusCircle
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};


export const IconAddGroup: React.FC<IProps> = (props: any) => {
  return (

    <MdOutlinePlaylistAddCircle
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};


export const IconPhone: React.FC<IProps> = (props: any) => {
  return (

    <MdPhone
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconPhoneCell: React.FC<IProps> = (props: any) => {
  return (

    <IoMdPhonePortrait
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// export const IconPromotions: React.FC<IProps> = (props: any) => {
//   return (

//     <Icon
//       type={Platform.select({ android: 'material-community', ios: 'fontisto' })}
//       name={Platform.select({ android: 'sale', ios: 'shopping-sale' })}
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



export const IconRefresh: React.FC<IProps> = (props: any) => {
  return (

    <MdRefresh
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconReportsGeneral: React.FC<IProps> = (props: any) => {
  return (

    <RiLineChartFill
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconReserves: React.FC<IProps> = (props: any) => {
  return (

    <RiReservedFill
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconSearch: React.FC<IProps> = (props: any) => {
  return (

    <IoMdSearch
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconShare: React.FC<IProps> = (props: any) => {
  return (

    <MdShare
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSmoking: React.FC<IProps> = (props: any) => {
  return (

    <FaSmoking
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialFacebook: React.FC<IProps> = (props: any) => {
  return (

    <FaFacebook
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialInstagram: React.FC<IProps> = (props: any) => {
  return (

    <FaInstagram
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialLinkedIn: React.FC<IProps> = (props: any) => {
  return (

    <FaLinkedin
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialMessenger: React.FC<IProps> = (props: any) => {
  return (

    <FaFacebookMessenger
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialThreads: React.FC<IProps> = (props: any) => {
  return (

    <FaThreads
      style={props.style}
      size={props.size || 16}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialTikTok: React.FC<IProps> = (props: any) => {
  return (

    <FaTiktok
      style={props.style}
      size={props.size || 16}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialTwitter: React.FC<IProps> = (props: any) => {
  return (

    <FaXTwitter
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialWhatsApp: React.FC<IProps> = (props: any) => {
  return (

    <FaWhatsapp
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconSocialYoutube: React.FC<IProps> = (props: any) => {
  return (

    <FaYoutube
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconStarOutline: React.FC<IProps> = (props: any) => {
  return (

    <MdStarOutline
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconStarFull: React.FC<IProps> = (props: any) => {
  return (

    <MdStar
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconStore: React.FC<IProps> = (props: any) => {
  return (

    <FaStoreAlt
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTermCookies: React.FC<IProps> = (props: any) => {
  return (

    <FaCookieBite
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTermData: React.FC<IProps> = (props: any) => {
  return (

    <FaDatabase
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTermLicences: React.FC<IProps> = (props: any) => {
  return (

    <FaAddressCard
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTermPrivacity: React.FC<IProps> = (props: any) => {
  return (

    <BsFillFileLock2Fill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTermUse: React.FC<IProps> = (props: any) => {
  return (

    <MdSecurity
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTicket: React.FC<IProps> = (props: any) => {
  return (

    <ImTicket
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconThumbDown: React.FC<IProps> = (props: any) => {
  return (

    <MdThumbDown
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconThumbMiddle: React.FC<IProps> = (props: any) => {
  return (

    <MdThumbsUpDown
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconThumbUp: React.FC<IProps> = (props: any) => {
  return (

    <MdThumbUp
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconVerified: React.FC<IProps> = (props: any) => {
  return (

    <GoVerified
      style={props.style}
      size={props.size || 17}
      color={props.color || Colors.attention}
    />

  );
};



// // Grid Events Icons

export const IconNoitada: React.FC<IProps> = (props: any) => {
  const size = props.size || 18;


  return (

    <svg width={size} height={size} viewBox="0 0 1024 1024" fill={props.color} xmlns="http://www.w3.org/2000/svg">
      <path d="M412.302 37.4022C410.599 37.7118 404.252 39.1051 398.215 40.4983C393.769 41.3075 389.413 42.552 385.211 44.2138C383.508 45.2974 386.14 52.109 397.596 77.4977C405.491 94.9911 412.457 108.769 413.076 108.15C413.696 107.531 415.089 102.732 416.173 97.6228C417.101 92.5142 418.65 85.2381 419.578 81.3679C420.352 77.4977 421.281 72.6986 421.746 70.5313C422.984 63.7197 423.758 62.7908 427.938 62.7908H432.118L431.034 109.543C429.951 155.676 429.951 156.45 432.892 153.354C434.595 151.651 447.289 136.944 461.067 120.844C475 104.589 488.778 88.7988 491.719 85.5478C497.602 79.5102 504.104 77.4977 502.246 82.4516C501.627 83.9997 488.314 107.84 472.523 135.396C456.733 162.952 444.348 186.019 445.122 186.638C445.741 187.257 458.9 188.65 474.226 189.734C489.552 190.663 504.259 191.747 506.736 191.902C509.368 192.211 519.895 192.83 530.422 193.604C550.237 194.843 553.953 196.236 553.953 202.274C553.953 203.822 553.488 205.215 552.869 205.215C548.225 205.215 472.368 216.826 471.439 217.6C470.665 218.219 481.657 229.83 495.744 243.453C517.882 264.662 521.133 268.532 519.43 270.544C517.727 272.712 514.941 271.628 494.351 260.791C481.657 254.135 470.975 248.562 470.82 248.562C470.511 248.562 470.356 249.645 470.356 250.884C470.356 253.67 508.903 312.033 510.761 312.033C514.631 312.033 538.936 291.134 547.451 280.297C572.839 248.562 584.295 210.633 580.27 170.538C577.242 140.415 565.166 111.914 545.629 88.7854C526.093 65.6571 500.013 48.985 470.82 40.9628C461.841 38.4859 453.172 37.557 437.072 37.0926C425.152 36.9378 414.005 36.9377 412.302 37.4022Z" />
      <path d="M203.31 98.5518C151.759 101.648 87.2035 110.627 53.7648 119.141C32.7108 124.56 30.2338 125.643 31.1627 129.514C31.6271 131.216 41.0705 149.484 52.0619 170.074C148.817 350.426 241.548 525.515 245.728 535.732C255.326 558.644 261.364 582.175 261.364 596.262C261.364 602.919 261.209 603.074 253.313 607.099C242.322 612.672 227.306 628.153 221.268 639.919C208.883 664.378 208.883 688.838 221.268 714.072C226.686 725.373 240.464 740.08 250.991 745.498L258.267 749.368V795.811C258.267 835.597 257.803 844.266 255.326 856.341C247.586 892.876 232.724 918.11 206.561 938.855C196.653 946.75 183.185 954.181 181.637 952.633C181.018 952.168 183.804 947.524 187.52 942.26C200.214 925.077 212.134 897.211 219.565 867.797C223.126 853.245 225.912 810.518 223.126 810.518C222.352 810.518 219.41 816.246 216.469 823.212C197.118 871.048 166.93 915.633 116.153 971.21C109.032 979.105 103.304 985.916 103.768 986.226C104.232 986.691 183.185 986.845 279.321 986.691L454.101 986.226L438.62 977.866C387.842 950.465 340.471 916.407 323.597 895.353C314.274 883.904 307.137 870.837 302.543 856.806C298.518 845.04 298.518 844.731 298.827 801.229L299.292 757.573L310.283 754.787C325.145 750.917 335.053 745.808 345.425 736.21C353.784 728.469 364.311 714.691 362.763 713.298C362.454 712.834 359.358 714.382 356.107 716.549C351.11 719.813 345.825 722.612 340.316 724.909C331.956 728.469 327.931 729.088 316.321 729.243C304.246 729.243 301.149 728.624 292.79 724.754C280.451 718.764 270.555 708.704 264.769 696.269C261.518 688.993 260.744 685.123 260.744 675.06C260.899 648.123 277.309 627.224 303.781 620.567C312.915 618.4 315.856 618.245 325.764 619.948C332.048 620.967 338.255 622.415 344.341 624.283C348.211 625.521 351.772 626.141 352.391 625.521C353.784 624.128 341.864 613.601 333.195 608.338C325.609 603.848 310.283 598.43 305.02 598.43H301.149L302.078 585.581C302.852 573.66 307.806 555.393 314.773 538.828C324.216 516.226 338.768 488.825 395.428 386.806C461.222 268.687 460.912 269.151 455.649 262.494C454.72 261.256 451.159 255.838 448.063 250.419C444.812 245.156 442.026 240.821 441.871 240.821C441.561 240.821 431.653 255.373 419.888 273.331L398.369 305.841H291.087L290.158 299.184C289.694 295.624 288.61 286.335 287.836 278.749C287.062 271.009 284.275 245.775 281.489 222.554C278.702 199.332 276.844 179.981 276.999 179.672C277.309 179.517 293.254 178.898 312.45 178.433C348.366 177.504 374.219 175.647 398.369 172.551C406.11 171.467 412.457 170.538 412.767 170.383C413.541 169.764 404.871 150.258 402.859 148.091C401.156 146.233 397.441 146.388 377.161 148.555C335.053 153.045 317.095 154.128 274.522 154.128C232.569 154.128 210.896 152.89 177.767 148.71C145.721 144.685 107.948 138.028 109.96 136.944C113.985 134.777 162.441 129.359 191.7 127.811C208.264 127.037 260.435 126.263 307.497 126.263C357.5 126.263 392.951 125.643 392.951 124.869C391.746 120.943 390.245 117.113 388.462 113.414C383.972 103.506 383.663 103.196 377.006 102.267C346.818 97.7778 250.527 95.6104 203.31 98.5518ZM142.161 168.216C147.734 169.145 153.926 170.538 155.939 171.002C159.19 171.931 161.976 178.743 181.792 236.951C194.022 272.712 204.084 302.9 204.084 303.983C204.084 305.531 200.988 305.841 191.39 305.531L178.85 305.067L152.688 238.499C138.445 201.809 126.215 170.228 125.596 168.216C124.822 164.965 125.132 164.655 128.383 165.429C130.395 165.894 136.588 167.132 142.161 168.216ZM236.749 180.136C237.997 183.754 238.878 187.488 239.381 191.282C240.31 196.855 244.954 222.554 249.598 248.562C254.397 274.57 258.577 298.1 259.196 300.887L259.97 305.996L248.824 305.531L237.678 305.067L224.055 250.884C216.624 221.006 209.348 192.211 208.109 186.793L205.787 177.04L220.804 178.124C229.008 178.743 236.285 179.672 236.749 180.136Z" />
      <path d="M629.809 180.446V225.34H655.817C686.778 225.34 698.389 227.043 712.322 233.39C725.481 239.428 739.568 253.98 744.212 266.21C752.108 287.264 752.108 289.276 752.108 485.419C752.108 591.618 751.488 668.094 750.714 668.094C749.94 668.094 749.012 667.165 748.547 666.081C748.083 665.152 740.652 655.09 731.828 643.789C723.004 632.642 708.142 613.601 698.699 601.526C689.41 589.451 674.703 570.719 666.189 559.727C657.674 548.736 643.122 530.004 633.679 517.929C624.39 505.854 609.684 487.122 601.169 476.131C592.655 465.294 574.542 441.918 560.919 424.27C547.296 406.621 529.183 383.245 520.668 372.409C512.154 361.417 498.221 343.614 489.707 332.777C481.192 321.786 471.439 309.247 468.188 304.757C464.782 300.268 461.377 296.552 460.448 296.552C459.519 296.707 439.858 330.765 416.792 372.409L374.684 447.955L387.378 464.83C409.206 493.779 469.736 573.66 499.15 612.362C515.56 633.726 546.367 674.441 572.529 709.118C606.742 754.322 637.085 794.418 652.875 815.162C660.925 825.844 677.025 847.053 688.636 862.379C700.247 877.705 719.443 903.094 731.363 918.884C743.284 934.674 759.693 956.193 767.743 966.875L782.45 986.226L826.106 986.69L869.762 987V638.99C869.762 413.123 870.382 287.883 871.311 282.465C874.716 264.042 890.816 241.595 905.523 234.783C922.552 226.888 924.874 226.424 959.242 225.65L992.062 225.03L991.752 180.6L991.287 136.325L810.625 135.861L629.809 135.551V180.446Z" />
    </svg>

  );
};

export const IconQrCode: React.FC<IProps> = (props: any) => {
  return (

    <FaQrcode
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconQuotation: React.FC<IProps> = (props: any) => {
  const size = props.size || Sizes.iconAndroidSize;
  const color = props.color || Colors.attention;

  return (

    <svg width={size * (41 / 20)} height={size * (59 / 40)} viewBox="0 0 82 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.56 28.704L22.256 27.456C25.8613 27.456 29.0507 28.704 31.824 31.2C34.736 33.5573 36.192 37.0933 36.192 41.808C36.192 46.384 34.6667 50.2667 31.616 53.456C28.5653 56.6453 24.2667 58.24 18.72 58.24C13.312 58.24 8.80533 56.16 5.2 52C1.73333 47.84 0 42.5013 0 35.984C0 29.328 2.496 22.7413 7.488 16.224C12.6187 9.70666 19.8987 4.29866 29.328 0L30.784 3.53599C17.7493 10.7467 11.232 18.0267 11.232 25.376C11.232 27.5947 12.3413 28.704 14.56 28.704ZM60.32 28.704L68.016 27.456C71.6213 27.456 74.8107 28.704 77.584 31.2C80.496 33.5573 81.952 37.0933 81.952 41.808C81.952 46.384 80.4267 50.2667 77.376 53.456C74.3253 56.6453 70.0267 58.24 64.48 58.24C59.072 58.24 54.5653 56.16 50.96 52C47.4933 47.84 45.76 42.5013 45.76 35.984C45.76 29.328 48.256 22.7413 53.248 16.224C58.3787 9.70666 65.6587 4.29866 75.088 0L76.544 3.53599C63.5093 10.7467 56.992 18.0267 56.992 25.376C56.992 27.5947 58.1013 28.704 60.32 28.704Z"
        fill={color}
      />
    </svg>

  );
};



export const IconTypeBar: React.FC<IProps> = (props: any) => {
  return (

    <IoIosBeer
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeCoffeeShop: React.FC<IProps> = (props: any) => {
  return (

    <FaCoffee
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeEventProducer: React.FC<IProps> = (props: any) => {
  return (

    <MdEvent
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeCarnivalProducer: React.FC<IProps> = (props: any) => {
  return (

    <BsCalendarRangeFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypePartyProducer: React.FC<IProps> = (props: any) => {
  return (

    <GiPartyFlags
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeHamburguer: React.FC<IProps> = (props: any) => {
  return (

    <FaHamburger
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeNightClub: React.FC<IProps> = (props: any) => {
  return (

    <FaCocktail
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeParty: React.FC<IProps> = (props: any) => {
  return (

    <GiPartyPopper
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconTypeNightParty: React.FC<IProps> = (props: any) => {
  return (

    <FaCocktail
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

  );
};



export const IconTypePub: React.FC<IProps> = (props: any) => {
  return (

    <GiBeerBottle
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypePizzeria: React.FC<IProps> = (props: any) => {
  return (

    <IoMdPizza
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeRestaurant: React.FC<IProps> = (props: any) => {
  return (

    <MdRestaurantMenu
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconTypeSteakhouse: React.FC<IProps> = (props: any) => {
  return (

    <GiSteak
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconWaiter: React.FC<IProps> = (props: any) => {
  return (

    <FaUserTie
      style={props.style}
      color={props.color || Colors.attention}
      size={props.size || Sizes.iconAndroidSize}
    />

    //   <svg
    //   width="20"
    //   height="28"
    //   viewBox="0 0 20 28"
    //   fill="none"
    //   color={props.color}
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M19.3981 6.96245C17.9669 2.7979 14.1899 0 9.99928 0C5.63011 0 1.80218 2.95669 0.474099 7.35711C0.159557 8.39866 0 9.48493 0 10.5862C0 16.4228 4.48565 21.1713 9.9994 21.1713C15.5137 21.1713 20 16.4228 20 10.5862C20 9.33992 19.7974 8.12041 19.3981 6.96245ZM9.99928 18.8171C5.81265 18.8171 2.40647 15.1246 2.40647 10.586C2.40647 9.8112 2.50599 9.04673 2.70164 8.30897H11.3487L12.5003 5.84793L13.7124 8.30897H17.2972C17.4928 9.04496 17.5933 9.80803 17.5933 10.586C17.5934 15.1246 14.1866 18.8171 9.99928 18.8171Z"
    //     fill={props.color}
    //   />
    //   <path
    //     d="M3.46201 21.2795V28L9.95981 26.1126L16.4576 28V21.2795L9.95981 23.1673L3.46201 21.2795Z"
    //     fill={props.color}
    //   />
    // </svg>

  );
};



export const IconWatchStart: React.FC<IProps> = (props: any) => {
  return (

    <MdWatch
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconWatchEnd: React.FC<IProps> = (props: any) => {
  return (

    <MdWatchOff
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconWifi: React.FC<IProps> = (props: any) => {
  return (

    <RiWifiFill
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



export const IconWifiInformation: React.FC<IProps> = (props: any) => {
  return (

    <MdWifiFind
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// // Carnival Grid Events Icons

// export const IconStreet: React.FC<IProps> = (props: any) => {
//   return (

//     <NoitadaFontIcon
//       name="md-carnival-street"
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



// export const IconDistricts: React.FC<IProps> = (props: any) => {
//   return (

//     <NoitadaFontIcon
//       name="md-carnival-district"
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



// export const IconAttractions: React.FC<IProps> = (props: any) => {
//   return (

//     <NoitadaFontIcon
//       name="md-carnival-attractions"
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



export const IconLanguages: React.FC<IProps> = (props: any) => {
  return (

    <IoLanguage
      style={props.style}
      size={props.size || Sizes.iconAndroidSize}
      color={props.color || Colors.attention}
    />

  );
};



// export const IconLounge: React.FC<IProps> = (props: any) => {
//   return (

//     <NoitadaFontIcon
//       name="md-carnival-lounge"
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };



// export const IconCarnivalMaps: React.FC<IProps> = (props: any) => {
//   return (

//     <NoitadaFontIcon
//       name="md-carnival-maps"
//       size={props.size || Sizes.iconAndroidSize}
//       color={props.color || Colors.attention}
//     />

//   );
// };
